import React, { useCallback, useEffect, useLayoutEffect, useState, useRef } from "react";
import { useWorkStateFields, useStateFields } from '../../store/hooks';
import { setClassObj } from '../../store/workRefs';
import _ from 'lodash';
import StoreToken from "../../components/StoreToken";
import { globalLoader, defaultQuality, get_platform_bg_color, getAuthToken, catchError, 
         get_platform_action_color, getApiUrlFromSelectionType, isAdmin, get_more_logo, getAPIUrl,
         setNavigationHistory, navigateToUrl, getToTop, isMobile, shouldShowPlayStoreInstallBanner, dismissPlayStoreInstallBanner, openPlayStoreOrInstallApp } from "../../script/util";
import axios, { all } from "axios";
import './WorkDetails.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faPlay, faXmark, faArrowUp, 
         faPlus, faChevronLeft, faArrowLeft, 
         faCircleCheck, faRotateRight, 
         faAngleLeft, faAngleRight,
         faImage} from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from 'react-router-dom';
import VideoPlayer from "../../components/VideoPlayer.js";
import AlbumView from "../../components/AlbumView/AlbumView.js";
import printAlbumIcon from '../../images/print_album.png'
import Navbar from '../../components/Navbar/Navbar.jsx'
import SkeletonLoader from "../../components/SkeletonLoader.js";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import selfieIcon from '../../images/face-scan.png'
import hideIcon from '../../images/hide.png'
import whiteHideIcon from '../../images/Hide-Button-White.png'
import cloudCrossMark from '../../images/cloudCrossMark.png'
import shareIcon from '../../images/share.png'
import { Toast } from '@egreact/shared';
import { selectionModeArray } from '../../script/SelectionMode.js'
import { faCircleCheck as hollowCheck } from "@fortawesome/free-regular-svg-icons";
import noData from '../../images/no_data.png'
import filter from '../../images/sort.png'
import FaceSearch from "../../components/FaceSearch/FaceSearch.js";
import downloadIcon from '../../images/download.png'
import lockIcon from'../../images/lock.png'
import checkIcon from '../../images/checked.png'
import pencilIcon from '../../images/pencil.png'
import deleteIcon from '../../images/delete.png'
import uploadIcon from '../../images/upload.png'
import GuestUpload from "../GuestUpload/GuestUpload.js";
import { GiHamburgerMenu } from 'react-icons/gi'
import { get_global_can_add_to, get_global_can_make_private, get_global_is_album_required, get_global_is_downloadable,
         get_selected_workId, get_user_liked_photos, getApiMethod, getCurrentPage, isCurrentPhotoFlagged, getSelectedData, get_can_edit_draft_album, isValidId, getFaceSearchReturnNav } from "./work_utils.js";
import FloatingBar from "../../components/FloatingBar/FloatingBar.js";
import CustomStatus from "../../components/CustomStatus/CustomStatus.jsx";
import * as CONST from '../../script/const.js'
import NavigationPanel from "../../components/NavigationPanel/NavigationPanel.js";
import WorkDetailHeader from "./WorkDetailHeader.js";
import WorkDetailStory from "./WorkDetailStory.js";
import MasonryGrid from "./MasonryGrid.js";
import GalleryCarousel from "./GalleryCarousel.js";
import WorkDetailPopup from "./WorkDetailPopup.js";
import Banner from "../../components/Banner/Banner.js";
import {
    photos, guestUpload, albumSelection, blacklistReview, userFolders, videos, albums, hide,
    download, deleteUploads, likePhotos, viewPhotos, flagPhotos, approvePhoto, addTo, allPhotos,
    privatePhotos, publicPhotos, trashIcon, past_face_searches
} from "../../context/workConstants";

const WorkDetail = () => {
    const { isLoggedin, blocked } = useStateFields(['isLoggedin', 'blocked']);
    const { storeToLocal } = StoreToken();
    const [isPhotoPageLoading, setIsPhotoPageLoading] = useState(false)
    // A page still failed after retries: Select all stays off (it would miss photos) until Retry.
    const [pageLoadFailed, setPageLoadFailed] = useState(false)
    const pageLoadFailedRef = useRef(false)
    pageLoadFailedRef.current = pageLoadFailed
    // Bumped once per appended batch, for the few effects that read its pages (gallery list, Library sort).
    const [photoPagesVersion, setPhotoPagesVersion] = useState(0)
    // The collection object a page merge produced, so effects can tell a new page from a new collection.
    const pageMergedCollectionRef = useRef(null)
    // Tiles drawn in the grid. Pages still load in the background; the grid grows as the user
    // scrolls, so a huge gallery doesn't put every tile in the DOM at once.
    const [tileLimit, setTileLimit] = useState(CONST.GRID_RENDER_WINDOW)
    // MasonryGrid's last render: tiles drawn, and for selection every tile, the unselectable and checked ones.
    const tileCountsRef = useRef({ drawn: 0, total: 0, blocked: 0, checked: 0 })
    const photoPaginationRequestIdRef = useRef(0)
    const photoNextPageRef = useRef(CONST.PAGINATION_BATCH_SIZE)
    const hasMorePhotoPagesRef = useRef(true)
    // State copy of hasMorePhotoPagesRef so the grid re-renders when the last page is in. Starts
    // false: only a paginated load says more pages are coming.
    const [hasMorePhotoPages, setHasMorePhotoPagesState] = useState(false)
    const setHasMorePhotoPages = (value) => {
        hasMorePhotoPagesRef.current = value
        setHasMorePhotoPagesState(value)
    }
    const isFetchingPhotoPageRef = useRef(false)
    const photoCountRef = useRef(0)
    const totalPagesByWorkIdRef = useRef({})
    const fetchedPageNumbersRef = useRef(new Set())
    const activeInitialBatchKeyRef = useRef('')
    // work_id whose first page was refused by the axios guard; reloaded once the lockout ends.
    const blockedGalleryLoadRef = useRef(null)
    // Page requests (page >= 1) from when they are sent until a drain appends them. Leaving mid-batch
    // discards that batch, so a return - or a restarted drain while it is still in flight - reuses
    // these instead of downloading the same pages again.
    const pendingPhotoPagesRef = useRef(new Map())

    const pastFacePaginationRequestIdRef = useRef(0)
    const pastFaceNextPageRef = useRef(1)
    const hasMorePastFacePagesRef = useRef(true)
    const isFetchingPastFacePageRef = useRef(false)
    const pastFaceTotalPagesRef = useRef(0)
    const pastFaceFetchedPageNumbersRef = useRef(new Set())
    const pastFaceActiveFaceIdRef = useRef('')

    // Abandon a background page drain: the id bump fails the loop's guard, the flags are released
    // so a later visit can start again. handleCollections() re-seeds all of these on reload.
    const cancelPhotoPagination = () => {
        photoPaginationRequestIdRef.current += 1
        setHasMorePhotoPages(false)
        isFetchingPhotoPageRef.current = false
        activeInitialBatchKeyRef.current = ''
        setIsPhotoPageLoading(false)
        setPageLoadFailed(false)
    }

    const cancelPastFacePagination = () => {
        pastFacePaginationRequestIdRef.current += 1
        hasMorePastFacePagesRef.current = false
        isFetchingPastFacePageRef.current = false
        setIsPhotoPageLoading(false)
        setPageLoadFailed(false)
    }

    // A drain is only wanted while the URL still points at what it fills. Read live, so any way of
    // leaving stops it without each navigation path having to remember to cancel.
    const isStillOnWorkId = (workId) =>
        String(new URLSearchParams(window.location.search).get('work_id')) === String(workId)

    const defQuality = defaultQuality()
    
    const {
        // Data and Collection States
        data, setData, collection, setCollection, collectionData, setCollectionData, collectionFormattedData, setCollectionFormattedData,
        images, setImages, galleryImages, setGalleryImages, filteredData, setFilteredData, recallCollection, setRecallCollection,
        // Booking and Video States
        bookingPK, setBookingPK, videoUrl, setVideoUrl, videoDetails, setVideoDetails, currentQuality, setCurrentQuality, currentQualityUrl, 
        setCurrentQualityUrl, qualityVideo, setQualityVideo, hdUrl, setLoadingHD,
        // UI and Navigation States
        scrollPosition, setScrollPosition, prevScrollPosition, setPrevScrollPosition, photoScroll, setPhotoScroll, setDistanceFromTop,
        setHeight, currentDimensions, setCurrentDimensions, showTooltip, setShowTooltip, showArrow, setShowArrow,
        isScrollable, setIsScrollable, contentLoading, setContentLoading,
        // View States
        albumView, setAlbumView, videoView, setVideoView, showGallery, setShowGallery, showFilters, setShowFilters, showMenuSidebar, setShowMenuSidebar,
        // Toast and Notification States
        showToast, setShowToast, toastMessage, setToastMessage, loading, setLoading, updateLoader, setUpdateLoader,
        // Selection States
        selection, setSelection, selectionType, setSelectionType, selectedImages, setSelectedImages, selectionAll, setSelectionAll, selectImages, setSelectImages,
        hideSelection, setHideSelection, downloadSelection, setDownloadSelection, deleteSelection, setDeleteSelection, approveFlagSelection, setApproveFlagSelection,
        addToSelection, setAddToSelection, printSelection, setPrintSelection, multipleSelect, setMultipleSelect, updateSinglePhoto, setUpdateSinglePhoto,
        // Photo and Gallery States
        photoIndex, setPhotoIndex, setIndexDisplay, gridFirstCheck, setGridFirstCheck, setInitialCarousel,
        hideSelectedObj, setHideSelectedObj,
        // Filter and Option States
        filterDropdown, setFilterDropdown, selectedOption, setSelectedOption, filterWorkId, setFilterWorkId, allGuestPhotos, setAllGuestPhotos,
        yourUploads, setYourUploads,
        // Collection Navigation States
        setNextCollection, nextCollectionName, setNextCollectionName, setNextVideo, setPrevCollectionName, prevCollection, setPrevCollection,
        galleryNextCollectionPopup, setGalleryNextCollectionPopup, galleryCollectionName, galleryRightArrow,
        // Face Search States
        faceFilter, setFaceFilter, faceSearchState, setFaceSearchState, faceCollection, setFaceCollection, faceSearchData, setFaceSearchData,
        faceSearchOn, setFaceSearchOn, pastFaceSearches, setPastFaceSearches, faceFormattedData, setFaceFormattedData, faceOnly, setFaceOnly,
        faceSelect, setFaceSelect, faceHide, setFaceHide, readyFaceSearchDownload, setReadyFaceSearchDownload,
        // Image Processing States
        croppedImages, setCroppedImages, shareFaceFilter, setShareFaceFilter,
        // Album States
        albumData, setAlbumData, setDefAlbumData, setSingleAlbumData, albumTitle, setAlbumTitle,
        albumLocked, setAlbumLocked, isEditing, setIsEditing, albumBookingPopup, setAlbumBookingPopup, albumBookingData, setAlbumBookingData,
        // Share States
        shareDropdown, setShareDropdown, shareLinkData, setShareLinkData, shareLinkPopup, setShareLinkPopup, shareSelective, setShareSelective,
        shareSelectList, setShareSelectList, shareTab, setShareTab,
        // Popup and Modal States
        isPopupOpen, setIsPopupOpen, moreDropdown, setMoreDropdown, lockPopup, setLockPopup, likeViewPopup, setLikeViewPopup, newFolderPopup, setNewFolderPopup,
        flagPhotoPopup, setFlagPhotoPopup, downloadPopup, setDownloadPopup, folderDeletePopup, setFolderDeletePopup, trashDeletePopup, setTrashDeletePopup,
        allTrashDeletePopup, setAllTrashDeletePopup, uploadExpiryOpen, setUploadExpiryOpen,
        // Add To States
        isAddToOpen, setIsAddToOpen, isSingleAddToOpen, setIsSingleAddToOpen,
        // Download States
        downloadDetails, setDownloadDetails,
        // Delete States
        reloadDelete, setReloadDelete, deleteConfirm, setDeleteConfirm, deletePopup, setDeletePopup, deleteType, setDeleteType,
        // Hidden Work States
        hiddenWork, setHiddenWork,
        // Like and View States
        likeData, setLikeData, setCurrentPhotoLiked, currentPhotoFlagged, setCurrentPhotoFlagged, flaggedData, setFlaggedData,
        // Folder States
        userFolderData, setUserFolderData, folderName, setFolderName, checkedFolder, setCheckedFolder, libraryData, setLibraryData,
        // Print States
        printSelectedData, setPrintSelectedData,
        // Floating Bars States
        floatingBars, setFloatingBars,
        // Trash States
        trashFoldersInfo, setTrashFoldersInfo,
        // Expiry States
        expiryDate, setexpiryDate,
        // Error States
        workIdError, setWorkIdError, workIdErrorMessage, setWorkIdErrorMessage,
        // Other States
        nickname, setNickname, setRedirectUrl, setPillMargin, pastMargin, setPastMargin,
        // Refs
        qrRef, thumbRef, moreRef, likeViewRef, scrollContainerRef, thumbState, storyRef, dropdownRef, shareRef,
        divRef, popupRef, firstCheckMedia, nicknameInput, newCreatedFolder, pastFaceSearchesOn, setPastFaceSearchesOn
    } = useWorkStateFields(['data', 'collection', 'collectionData', 'collectionFormattedData', 'images', 'galleryImages', 'filteredData', 'recallCollection', 'bookingPK', 'videoUrl', 'videoDetails', 'currentQuality', 'currentQualityUrl', 'qualityVideo', 'hdUrl', 'scrollPosition', 'prevScrollPosition', 'photoScroll', 'currentDimensions', 'showTooltip', 'showArrow', 'isScrollable', 'contentLoading', 'albumView', 'videoView', 'showGallery', 'showFilters', 'showMenuSidebar', 'showToast', 'toastMessage', 'loading', 'updateLoader', 'selection', 'selectionType', 'selectedImages', 'selectionAll', 'selectImages', 'hideSelection', 'downloadSelection', 'deleteSelection', 'approveFlagSelection', 'addToSelection', 'printSelection', 'multipleSelect', 'updateSinglePhoto', 'photoIndex', 'gridFirstCheck', 'hideSelectedObj', 'filterDropdown', 'selectedOption', 'filterWorkId', 'allGuestPhotos', 'yourUploads', 'nextCollectionName', 'prevCollection', 'galleryNextCollectionPopup', 'galleryCollectionName', 'galleryRightArrow', 'faceFilter', 'faceSearchState', 'faceCollection', 'faceSearchData', 'faceSearchOn', 'pastFaceSearches', 'faceFormattedData', 'faceOnly', 'faceSelect', 'faceHide', 'readyFaceSearchDownload', 'croppedImages', 'shareFaceFilter', 'albumData', 'albumTitle', 'albumLocked', 'isEditing', 'albumBookingPopup', 'albumBookingData', 'shareDropdown', 'shareLinkData', 'shareLinkPopup', 'shareSelective', 'shareSelectList', 'shareTab', 'isPopupOpen', 'moreDropdown', 'lockPopup', 'likeViewPopup', 'newFolderPopup', 'flagPhotoPopup', 'downloadPopup', 'folderDeletePopup', 'trashDeletePopup', 'allTrashDeletePopup', 'uploadExpiryOpen', 'isAddToOpen', 'isSingleAddToOpen', 'downloadDetails', 'reloadDelete', 'deleteConfirm', 'deletePopup', 'deleteType', 'hiddenWork', 'likeData', 'currentPhotoFlagged', 'flaggedData', 'userFolderData', 'folderName', 'checkedFolder', 'libraryData', 'printSelectedData', 'floatingBars', 'trashFoldersInfo', 'expiryDate', 'workIdError', 'workIdErrorMessage', 'nickname', 'pastMargin', 'pastFaceSearchesOn']);
    // A page drain outlives the render that started it, so appends read the live filter from here.
    const selectedOptionRef = useRef(selectedOption)
    selectedOptionRef.current = selectedOption
    const allGuestPhotosRef = useRef(allGuestPhotos)
    allGuestPhotosRef.current = allGuestPhotos
    const [uploadedSelfie, setUploadedSelfie] = useState();
    const [trashLoading, setTrashLoading] = useState(false);
    const [showAppBanner, setShowAppBanner] = useState(false);
    const [showPrintAlbumTipLeft, setShowPrintAlbumTipLeft] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const faceFilterRequestRef = useRef(false);
    const selfieFetchedRef = useRef(false);
    useLayoutEffect(() => {
        storeToLocal();
    }, []);

    useEffect(() => {
        setShowPrintAlbumTipLeft(true);
        const t = setTimeout(() => setShowPrintAlbumTipLeft(false), 15000);
        return () => clearTimeout(t);
    }, []);
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    const for_passkey = queryParams.get("for_passkey")
    const shared_key = queryParams.get("key")
    const tab = queryParams.get("tab")
    const showTrash = queryParams.get("trash")
    let currentPage = getCurrentPage(CONST, tab);
    if((!id || id=='null') && !shared_key && tab!==userFolders){
        navigate('/')
    }
    const collection_id = queryParams.get("work_id")
    // Draft-album editing (add/remove photos, lock) is only available to the
    // booking owner, super admins and album collaborators. Deliverable admins
    // see the draft album but cannot edit it. UX gate only — backend enforces it.
    const canEditDraftAlbum = get_can_edit_draft_album(collection, data)
    const albumStatus = queryParams.get('album_status')
    const videoStatus = queryParams.get('video_status')
    var faceSearchOnly = queryParams.get('face_only') === 'true'

    const renderInstallBanner = () =>
        showAppBanner ? (
            <div className="work-detail-app-banner">
                <Banner
                    bgColor={get_platform_bg_color()}
                    title="Open in EventGraphia App"
                    subtitle="Faster browsing and a smoother viewing experience."
                    showActionButton
                    actionLabel="Open"
                    onAction={openPlayStoreOrInstallApp}
                    onClose={() => dismissPlayStoreInstallBanner(() => setShowAppBanner(false))}
                />
            </div>
        ) : null;

    const handleTitleChange = (e) => {
        setAlbumTitle(e.target.value);
    };


    useEffect(() => {
        if (tab==userFolders && showTrash) {
            queryParams.delete('work_id');
            navigate({ search: queryParams.toString() });
            getTrashFolders();
            setShowFilters(false);
        }
    }, [showTrash, collection_id]);

    useEffect(() => {
        const hasBannerContent = Boolean(
            id || shared_key || tab === userFolders || tab === videos || tab === albums
        );
        setShowAppBanner(shouldShowPlayStoreInstallBanner({ hasContent: hasBannerContent }));
    }, [id, shared_key, tab, currentDimensions]);

    
    const detectZoom = () => {
        if(!showGallery) return;
        if (window.visualViewport.scale < 1.05) {
          setHeight(window.innerHeight); 
        } else {
          setHeight('100vh');  
        }
    };

    
    const handleTouchMove = (e) => {
        if (e.touches.length === 2) {
          e.preventDefault(); 
          setHeight('100vh');
        }
    };

    useEffect(() => {
        if(!showGallery) return;
        const interval = setInterval(() => {
          detectZoom();
        }, 100);

        const fixedElement = document.getElementsByClassName('galleryContainer')[0];
    
        fixedElement?.addEventListener('touchmove', handleTouchMove, { passive: false });
    
        return () => {
          clearInterval(interval);
          fixedElement?.removeEventListener('touchmove', handleTouchMove);
        };
    }, [showGallery]);


    const changeAlbumTitle = async () => {
        if(isAdmin()){
            return;
        }
        if(albumTitle.trim()!==''){
            setIsEditing(false)
            const form = new FormData();
            form.append("title", albumTitle);
            const apiUrl = tab==albumSelection ? `${process.env.REACT_APP_STAG_URL}/api/work/update-my-deliverable-title/${collection_id}/`
                            : `${process.env.REACT_APP_STAG_URL}/api/work/folder/${collection_id}/update/title/`
            try{
                const response = await axios.post(apiUrl, form, {
                    headers: {
                        Authorization: getAuthToken(),
                    },
                });
                getSelectedData(data, tab).map((e)=>{
                    if(e.work_id==collection_id){
                        e.title = albumTitle
                    }
                })
                setCollection(prev => ({
                    ...prev,
                    title: albumTitle
                }));
                setCollectionData(prev => ({
                    ...prev,
                    [collection_id]: {
                      ...prev[collection_id],
                      title: albumTitle
                    }
                }));
                if(response?.data?.toast_data){
                    setShowToast(true)
                    setToastMessage(response?.data?.toast_data)
                }
            }catch(error){
                catchError(error)
            }
        }else{
            setShowToast(true)
            setToastMessage({'title':'Please enter a title'})
        }
    }

    const getFilteredData = () => {
        const currentData = allGuestPhotos ? collection?.photo_data?.flatMap(e=>e.data) : collection?.photo_data?.flatMap(e=>e.my_uploads)
        selectedOption === allPhotos && setImages(currentData)
        selectedOption === privatePhotos && setImages(hideSelectedObj[collection_id])
        selectedOption === publicPhotos && setImages(
            currentData.filter(item => 
                !hideSelectedObj[collection_id]?.some(hiddenItem => hiddenItem.photo_id === item.photo_id)
            )
        )
    }


    const handleGuestUplaods = (value) => {
        setUpdateLoader(true)
        setCollection();
        window.location.href = value.url
    }

    useEffect(() => {
        if (thumbRef.current) {
          var widthThumb = thumbRef.current.clientWidth;
          if (widthThumb > 600) {
            thumbState.current = true;
          }
        }
    }, [thumbRef.current]);


    useEffect(()=>{
        if(faceSearchOnly){
            setFaceOnly(true)
        }
    },[])

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (selection || (event.target.tagName === 'A' || event.target.tagName === 'FORM')) {
                event.preventDefault();
                const confirmMessage = "Are you sure you want to navigate away? Your selection will be lost.";
                const confirmed = window.confirm(confirmMessage);
                if (!confirmed) {
                event.preventDefault();
                }
            }
            
        };
    
        window.addEventListener('beforeunload', handleBeforeUnload);
    
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
    
        };
    }, [selection]);

    const addToDone = () => {
        setCheckedFolder([])
        if(newCreatedFolder.current){
            setYourUploads()
            getLibraryData(false)
        }
        setPrintSelection(false)
        getBookingData()
        setIsAddToOpen(false); 
        cancelSelection()
        setCollection()
        setCollectionData()
        setRecallCollection(true)
    }

    function mergeUniqueFloatingBars(newBars = [], existingBars = []) {
        const combinedBars = [...newBars, ...existingBars];

        const uniqueBarsMap = new Map();
        combinedBars.forEach(bar => {
            const key = `${bar.title}-${bar.btn?.text}-${bar.btn?.url}`;
            if (!uniqueBarsMap.has(key)) {
                uniqueBarsMap.set(key, bar);
            }
        });

        return Array.from(uniqueBarsMap.values());
    }

    const tncApproved = () => {
        if(isAdmin()){
            return;
        }
        setLoading(true);
        const authToken = getAuthToken();
        const headers = {
        Authorization: authToken,
        };
        axios
        .get(`${process.env.REACT_APP_STAG_URL}/api/work/guest/gallery/tnc/agree/`, {
            headers,
        })
        .then((response) => {
            setLoading(false);
            if(response?.data?.success){
                setCollectionData()
                setCollection()
                getBookingData()
            }else{
                setShowToast(true)
                setToastMessage(response?.data?.toast_data)
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error(error);
        });
    }


    const handleClickOutside = (event) => {
        if (shareRef.current && !shareRef.current.contains(event.target)) {
            setShareDropdown(false);
        }
        if (moreRef.current && !moreRef.current.contains(event.target)) {
            setMoreDropdown(false);
        }
        if(likeViewRef.current && !likeViewRef.current.contains(event.target)){
            setLikeViewPopup(false)
        }
    };
    
    // The URL markers that mean "the face-search view is valid here".
    const isFaceSearchUrl = () => {
        const p = new URLSearchParams(window.location.search);
        return p.get('face-search') === 'true' || p.get('tab') === past_face_searches || p.get('face_only') === 'true';
    }

    const exitFaceSearch = ()=>{
        // Before handleCollections() below starts the photo drain, so a late face page can't land
        // on the Photos grid or turn that drain's loader off.
        cancelPastFacePagination()
        faceFilterRequestRef.current = false;
        loadedFaceIdRef.current = null;
        getToTop()
        setShowFilters(true)
        setShareFaceFilter(false)
        setFaceSearchState(false)
        setFaceSearchOn(false)
        setFaceSearchData()
        // Retake bar renders on (faceSearchOn || pastFaceSearchesOn), so both must go.
        setPastFaceSearchesOn(false)
        const bodyDiv = document.getElementsByTagName('body')[0];
        bodyDiv.style.overflow = 'auto';
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.delete('face-search')
        if(queryParams.get('tab')==past_face_searches){
            // Prefer the tab we came from; entering from guest upload leaves photo-collection unpopulated.
            const returnNav = getFaceSearchReturnNav(JSON.parse(localStorage.getItem('nav_history')) || [], CONST?.HOME_URL);
            if (returnNav) {
                navigateToUrl(returnNav)
                return;
            }
            const photoCollectionWorkId = data?.data?.['photo-collection']?.[0]?.work_id;
            if (photoCollectionWorkId) {
                queryParams.set('tab', photos)
                queryParams.set('work_id', photoCollectionWorkId)
                handleCollections(photoCollectionWorkId)
                setPastFaceSearchesOn(false)
            } else {
                // Cold deep link: no origin and no photo-collection, so leave the face-search view.
                navigateToUrl('/')
                return;
            }
        }
        navigate({ search: queryParams.toString()}, { replace: true });
        setCollectionData()
        setRecallCollection(true)
    }

    const pastFaceData = (fid) => {
        queryParams.set('tab', past_face_searches)
        queryParams.set('work_id', fid)
        // queryParams.delete('face_only')
        setFaceOnly(false)
        setFaceFilter(false)
        setShowTooltip(false)
        // Switching between past searches replaces, so Back never lands on a previous result.
        navigate({ search: queryParams.toString()}, { replace: isFaceSearchUrl() });
        // Reset + drain run inside `indiFaceData` (page 0) so tab switch / story / filter all load the rest.
        indiFaceData(fid, 0, false)
        document.getElementsByTagName('body')[0].style.overflow = 'auto'   
    }

    const indiFaceData = async (fid, current_page = 0, append = false) => {
        // From the live URL, not `queryParams`: popstate's closure can hold another tab's params.
        const liveParams = new URLSearchParams(window.location.search);
        const faceId = fid || liveParams.get("work_id")
        if(!isValidId(faceId))return;

        let expectedReqIdForDrain = null
        if (!append && current_page === 0) {
            // The face results replace the grid, so stop paging the collection we came from.
            cancelPhotoPagination()
            pastFacePaginationRequestIdRef.current += 1
            expectedReqIdForDrain = pastFacePaginationRequestIdRef.current
            pastFaceActiveFaceIdRef.current = faceId
            pastFaceNextPageRef.current = 1
            hasMorePastFacePagesRef.current = true
            pastFaceTotalPagesRef.current = 0
            pastFaceFetchedPageNumbersRef.current = new Set([0])
            isFetchingPastFacePageRef.current = false
            setUpdateLoader(true)
        }

        liveParams.set("work_id", faceId)
        navigate({ search: liveParams.toString()}, { replace: true });
        const form = new FormData();
        form.append("id", faceId);
        if(shared_key){
            form.append("key", shared_key);
        }
        form.append("current_page", current_page)
        const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/face/search/results/photos/`;
        try{
            const response = await axios.post(apiUrl, form, {
                headers: {
                    Authorization: getAuthToken(),
                },
            });
            // Discard a late response: the user left face search or is now on another face id (e.g. Back
            // mid-load, then a different past search). Clear the loader updateFaceSearchResult() would have.
            const urlFaceId = new URLSearchParams(window.location.search).get('work_id');
            if(!isFaceSearchUrl() || String(urlFaceId) !== String(faceId)){ setUpdateLoader(false); return; }
            // Only when the data is actually applied, so a failed load still retries on the next nav.
            loadedFaceIdRef.current = response?.data?.success === false ? null : faceId;
            setPastFaceSearchesOn(true)
            if(append){
                appendPastFaceSearchResultPage(response?.data)
            }else{
                updateFaceSearchResult(response?.data)
                setSelectImages((prev) => ({
                    ...prev,
                    [faceId]: {
                        ...(prev[faceId] || {}),
                        [faceId]: []
                    }
                }));
            }

            const entries = Array.isArray(response?.data?.photo_data) ? response?.data?.photo_data : []
            // total_pages/next_page are returned at the top level of the response; fall back
            // to a photo_data entry that carries them.
            const firstEntryWithMeta = (response?.data?.total_pages !== undefined && response?.data?.total_pages !== null)
                ? response?.data
                : (entries?.find((e) => e?.total_pages !== undefined && e?.total_pages !== null) || entries?.[0])
            const parsedTotalPages = Number(firstEntryWithMeta?.total_pages)

            pastFaceNextPageRef.current = current_page + 1
            if(Number.isFinite(parsedTotalPages) && parsedTotalPages > 0){
                pastFaceTotalPagesRef.current = parsedTotalPages
                hasMorePastFacePagesRef.current = current_page < parsedTotalPages - 1
            }else{
                const nextFromApi = firstEntryWithMeta?.next_page
                hasMorePastFacePagesRef.current = !(
                    nextFromApi === '' || nextFromApi === null || nextFromApi === undefined
                )
            }

            if (!append && current_page === 0 && expectedReqIdForDrain !== null) {
                if (pastFacePaginationRequestIdRef.current === expectedReqIdForDrain) {
                    void drainRemainingPastFacePages(faceId, expectedReqIdForDrain)
                }
            }

            return response?.data
        }catch(error){
            loadedFaceIdRef.current = null;
            catchError(error)
            return null
        }
    }

    const getPhotoCountFaceSearch = (option = selectedOption) => {
        switch (option) {
            case allPhotos:
                return faceSearchData?.photo_count
            case privatePhotos:
                return Object.values(faceHide).reduce((sum, arr) => sum + arr.length, 0)
            case publicPhotos:
                return (faceSearchData?.photo_count-Number(Object.values(faceHide).reduce((sum, arr) => sum + arr.length, 0)))
        }
    }

    const renderRetakeSelfieThumb = () => {
        if (queryParams.get('for_selfie') !== 'true') {
            return uploadedSelfie
                ? <img src={uploadedSelfie} style={{width:"30px", height:"30px", borderRadius:"50%"}} alt="" />
                : <FontAwesomeIcon icon={faRotateRight} style={{color: "#000000"}} />;
        }

        const faceIndex = pastFaceSearches?.findIndex((e) => e._id == collection_id) ?? -1;
        const face = faceIndex >= 0 ? pastFaceSearches[faceIndex] : null;

        if (croppedImages[faceIndex]) {
            return <img src={croppedImages[faceIndex]} style={{width:"30px", height:"30px", borderRadius:"50%"}} alt="" />;
        }
        if (face?.img_url && face?.bounding_box) {
            const box = face.bounding_box;
            return (
                <div style={{ width: 30, height: 30, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                    <img
                        src={face.img_url}
                        alt=""
                        style={{
                            width: `${100 / box.Width}%`,
                            height: `${100 / box.Height}%`,
                            maxWidth: 'none',
                            marginLeft: `${-(box.Left / box.Width) * 100}%`,
                            marginTop: `${-(box.Top / box.Height) * 100}%`,
                        }}
                    />
                </div>
            );
        }
        if (uploadedSelfie) {
            return <img src={uploadedSelfie} style={{width:"30px", height:"30px", borderRadius:"50%"}} alt="" />;
        }
        return <FontAwesomeIcon icon={faRotateRight} style={{color: "#000000"}} />;
    };

    // Counts come from the server payload, so a confirmed hide leaves them stale. Only some pages may be
    // loaded, so apply the committed change as a delta to the server's counts instead of recounting.
    // The delta comes from multipleSelect (exactly what was sent): pages keep landing during a
    // selection, so comparing two hidden-set snapshots would also count photos that just arrived.
    // Mutates the payload and the collectionData cache entry so returning shows it.
    const syncVisibilityCounts = () => {
        const applyDelta = (target, privateKey, publicKey, delta) => {
            const hidden = Number(target?.[privateKey])
            const shown = Number(target?.[publicKey])
            if (!Number.isFinite(hidden) || !Number.isFinite(shown)) return
            target[privateKey] = Math.max(0, hidden + delta)
            target[publicKey] = Math.max(0, shown - delta)
        }
        const isFace = faceSearchOn || pastFaceSearchesOn
        const hiddenBefore = new Set(Object.values((isFace ? faceHide : hideSelectedObj) || {}).flat().map((p) => p?.photo_id))
        const hiding = new Set()
        const unhiding = new Set()
        ;(multipleSelect || []).forEach((item) => {
            (item?.select_list || []).forEach((id) => !hiddenBefore.has(id) && hiding.add(id))
            ;(item?.unselect_list || []).forEach((id) => hiddenBefore.has(id) && unhiding.add(id))
        })
        const delta = hiding.size - unhiding.size
        if (delta === 0) return
        if (isFace) {
            if (faceSearchData) applyDelta(faceSearchData, 'private_photo_count', 'public_photo_count', delta)
            return
        }
        if (!collection) return
        // collection can be a shallow copy of the cache entry (album edits copy it), and returning to
        // this collection reads the cache, so update both. Entries may be shared: apply each once.
        const targets = [collection, collectionData?.[collection_id]].filter((t, i, arr) => t && arr.indexOf(t) === i)
        const updatedEntries = new Set()
        targets.forEach((target) => {
            const entries = Array.isArray(target.photo_data) ? target.photo_data : []
            if (entries.length === 1 && !updatedEntries.has(entries[0])) {
                updatedEntries.add(entries[0])
                applyDelta(entries[0], 'private_count', 'public_count', delta)
            }
            applyDelta(target, 'private_photo_count', 'public_photo_count', delta)
        })
    }

    // Whole-collection totals, whatever has loaded: single-work payloads carry the split on the
    // entry, multi-work ones at the top level. Null when absent, so callers count what is loaded.
    const getServerCounts = (payload) => {
        const entries = Array.isArray(payload?.photo_data) ? payload.photo_data : []
        if (entries.length === 1) {
            const total = Number(entries[0]?.total_count)
            const hidden = Number(entries[0]?.private_count)
            const shown = Number(entries[0]?.public_count)
            if ([total, hidden, shown].every(Number.isFinite)) return { total, hidden, shown }
        }
        const total = Number(payload?.photo_count)
        const hidden = Number(payload?.private_photo_count)
        const shown = Number(payload?.public_photo_count)
        if ([total, hidden, shown].every(Number.isFinite)) return { total, hidden, shown }
        return null
    }

    // Guest galleries report the requesting user's own upload total. The paginated `my_uploads`
    // lists only cover the pages fetched so far, so counting them under-reports while loading.
    const getMyUploadsTotal = () => {
        const entries = Array.isArray(collection?.photo_data) ? collection.photo_data : []
        if (entries.length !== 1) return null
        const n = Number(entries[0]?.my_uploads_count)
        return Number.isFinite(n) ? n : null
    }

    const pickServerCount = (counts, option) => {
        if (option === privatePhotos) return counts.hidden
        if (option === publicPhotos) return counts.shown
        return counts.total
    }

    // ignoreWorkFilter: the Visibility radios describe the whole collection, so the Bookings boxes
    // must not move them - only the pill and "Show (N) results" narrow, as on main.
    const getFilterDisplayCount = (option = selectedOption, { ignoreWorkFilter = false } = {}) => {
        const hasWorkFilter = !ignoreWorkFilter && Array.isArray(filterWorkId) && filterWorkId.length > 0
        const allowedWorkIds = new Set((filterWorkId || []).map(String))
        const isAllowedWork = (workId) => !hasWorkFilter || allowedWorkIds.has(String(workId))

        const getWorkTotalCount = (workId) => {
            // bookings_name carries each collection's real total. photo_data's work_photo_count is
            // only the current page's share, so it must never be used here.
            const booking = Object.values(collection?.bookings_name || {}).find(
                (b) => b?.collections?.[workId] !== undefined
            )
            const fromBooking = Number(booking?.collections?.[workId]?.work_photo_count)
            if (Number.isFinite(fromBooking)) return fromBooking
            const match = (collection?.photo_data || []).find((e) => String(e?.work_id) === String(workId))
            const fromEntry = Number(match?.total_count)
            if (Number.isFinite(fromEntry)) return fromEntry
            const fromFormatted = collectionFormattedData?.[workId]?.length
            return Number.isFinite(fromFormatted) ? fromFormatted : 0
        }

        if (faceSearchOn) {
            if (hasWorkFilter) {
                if (option === allPhotos) {
                    return Object.entries(faceFormattedData || {}).reduce((sum, [workId, arr]) => (
                        isAllowedWork(workId) ? sum + (arr?.length || 0) : sum
                    ), 0)
                }
                if (option === privatePhotos) {
                    return Object.entries(faceHide || {}).reduce((sum, [workId, arr]) => (
                        isAllowedWork(workId) ? sum + (arr?.length || 0) : sum
                    ), 0)
                }
                const allCount = Object.entries(faceFormattedData || {}).reduce((sum, [workId, arr]) => (
                    isAllowedWork(workId) ? sum + (arr?.length || 0) : sum
                ), 0)
                const privateCount = Object.entries(faceHide || {}).reduce((sum, [workId, arr]) => (
                    isAllowedWork(workId) ? sum + (arr?.length || 0) : sum
                ), 0)
                return Math.max(0, allCount - privateCount)
            }
            const faceCounts = getServerCounts(faceSearchData)
            if (faceCounts) return pickServerCount(faceCounts, option)
            return getPhotoCountFaceSearch(option) || 0;
        }

        const serverCounts = (!hasWorkFilter && allGuestPhotos) ? getServerCounts(collection) : null
        if (serverCounts) return pickServerCount(serverCounts, option)

        if (option === allPhotos) {
            if (hasWorkFilter && allGuestPhotos) {
                return [...allowedWorkIds].reduce((sum, workId) => sum + getWorkTotalCount(workId), 0)
            }
            if (hasWorkFilter && !allGuestPhotos) {
                return isAllowedWork(collection_id) ? (getMyUploadsTotal() ?? (yourUploads?.length || 0)) : 0
            }
            return allGuestPhotos ? (collection?.photo_count || 0) : (getMyUploadsTotal() ?? (yourUploads?.length || 0));
        }

        if (option === privatePhotos) {
            if (allGuestPhotos) {
                return Object.keys(collectionFormattedData || {}).reduce((sum, collectionId) => {
                    if (!isAllowedWork(collectionId)) return sum;
                    const length = hideSelectedObj?.[collectionId]?.length || 0;
                    return sum + length;
                }, 0);
            }
            if (!isAllowedWork(collection_id)) return 0
            return (yourUploads || []).reduce((count, item) => {
                const exists = hideSelectedObj?.[collection_id]?.some(
                    other => other.photo_id === item.photo_id
                );
                return count + (exists ? 1 : 0);
            }, 0);
        }

        // publicPhotos
        if (allGuestPhotos) {
            const privateCount = Object.keys(collectionFormattedData || {}).reduce((sum, collectionId) => {
                if (!isAllowedWork(collectionId)) return sum;
                const length = hideSelectedObj?.[collectionId]?.length || 0;
                return sum + length;
            }, 0);
            const allCount = hasWorkFilter
                ? [...allowedWorkIds].reduce((sum, workId) => sum + getWorkTotalCount(workId), 0)
                : Number(collection?.photo_count || 0);
            return Math.max(0, allCount - privateCount);
        }

        if (!isAllowedWork(collection_id)) return 0
        const privateCount = (yourUploads || []).reduce((count, item) => {
            const exists = hideSelectedObj?.[collection_id]?.some(
                other => other.photo_id === item.photo_id
            );
            return count + (exists ? 1 : 0);
        }, 0);
        return (getMyUploadsTotal() ?? (yourUploads?.length || 0)) - privateCount;
    }

    const syncUserFolderFilterWorkIds = (folderResponse) => {
        if (tab !== userFolders) return

        const allowedIds = new Set()

        Object.values(folderResponse?.bookings_name || {}).forEach((booking) => {
            Object.keys(booking?.collections || {}).forEach((id) => {
                if (id !== undefined && id !== null) {
                    allowedIds.add(String(id))
                }
            })
        })

        // Fallback: also include work_ids from returned photo_data.
        ;(folderResponse?.photo_data || []).forEach((entry) => {
            if (entry?.work_id !== undefined && entry?.work_id !== null) {
                allowedIds.add(String(entry.work_id))
            }
        })

        if (allowedIds.size === 0) return

        setFilterWorkId((prev) => (prev || []).filter((id) => allowedIds.has(String(id))))
    }

    const guestUploadTab = (type) => {
        if(faceSearchOn)exitFaceSearch()
        setSelectedOption(allPhotos)
        if(type==all){
            setAllGuestPhotos(true);
            setImages(collection?.photo_data?.flatMap((e)=>e.data));
        }else{
            setAllGuestPhotos(false);
            if(collectionData){
                yourUploads ? setImages(yourUploads) : setImages()
            }
            fetchImages()
        }
        getToTop();
    }

    const updateAlbum = (albumId, isChecked, photoId=null) => {
        const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData
        const selectedWorkId = get_selected_workId(selectedData, photoId)
        let apiUrl, option;
        if(addToSelection){ // addToSelection will check if the select button is triggered to move in add To selection mode or not
            if(isChecked){
                option = 'add_photo_album'
            }else{
                option = 'remove_photo_album'
            }
            apiUrl = getApiUrlFromSelectionType(addTo)
            apiUrl = `${apiUrl}${albumId}/${option}/`
            setUpdateLoader(true)
            const authToken = getAuthToken();
            const headers = {
                Authorization: authToken,
                "Content-Type": "application/json",
            };
            var data;
            if(photoId){
                data = { photo_id_data: [{work_id: selectedWorkId, select_list: [photoId], unselect_list: []}]}
            }else{
                data = { photo_id_data: structuredClone(multipleSelect) };
            }
            data?.photo_id_data?.forEach((each) => {
                const match = faceSearchData?.photo_data?.find(e => e.work_id === each.work_id);
                if (match && !match.is_album_required) {
                  each.select_list = [];
                  each.unselect_list = [];
                }
            });
            setReloadDelete(true)
            axios
            .put(`${apiUrl}`, data, { headers })
            .then((response) => {
                setUpdateLoader(false)
                if(response?.data?.toast_data){
                    setShowToast(true)
                    setToastMessage(response?.data?.toast_data)
                }
                setSingleAlbumData(response?.data?.photo_id_map)
                let tempAlbumData = albumData;
                if(tempAlbumData[albumId])tempAlbumData[albumId]['is_checked'] = isChecked
                setAlbumData(tempAlbumData)
                if(response?.data?.success){
                    setCollection(prev => {
                        const updatedCollection = { ...prev };
                        const albumData = updatedCollection?.album_data?.album_data;
                
                        if (albumData && albumData[albumId]) {
                            albumData[albumId] = {
                                ...albumData[albumId],
                                album_photo_count: response.data.photo_count
                            };
                        }
                
                        return updatedCollection;
                    });
                }
                if(printSelection){
                    const booking_id = printSelectedData['booking_id']
                    setAlbumBookingData(prev => ({
                        ...prev,
                        [booking_id]: {
                            ...prev[booking_id],
                            albums: {
                            ...prev[booking_id].albums,
                            [albumId]: {
                                ...prev[booking_id].albums[albumId],
                                album_photo_count: response.data.photo_count
                            }
                            }
                        }
                    }));
                }
            })
            .catch((error) => {
                console.error('Error removing image:', error);
                setUpdateLoader(false)
                setShowToast(true)
                setToastMessage({'title': error.message})
            });
        }
    }

    const updateFolders = (folderId, isChecked, photoId=null) => {
        const selectedData = faceSearchOn ? faceFormattedData : collectionFormattedData
        const selectedWorkId = get_selected_workId(selectedData, photoId)
        let apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/folder/${folderId}/modify/user/`;
        if (addToSelection){
            setUpdateLoader(true)
            const authToken = getAuthToken();
            const headers = {
                Authorization: authToken,
                "Content-Type": "application/json",
            };
            var data;
            if(photoId){
                data = { photo_id_data: [{work_id: selectedWorkId, select_list: isChecked ? [photoId] : [], unselect_list: isChecked ? [] : [photoId]}]}
            }else{
                if (!isChecked) {
                    const updated = multipleSelect.map(item => ({
                      ...item,
                      unselect_list: item.select_list,
                      select_list: [],
                    }));
                    data = { photo_id_data: updated };
                } else {
                    const updated = multipleSelect.map(item => ({
                        ...item,
                        unselect_list: []
                    }));
                    setMultipleSelect(updated)
                    data = { photo_id_data: updated };
                }
            }
            axios
            .put(`${apiUrl}`, data, { headers })
            .then((response) => {
                setUpdateLoader(false)
                if(response?.data?.toast_data){
                    setShowToast(true)
                    setToastMessage(response?.data?.toast_data)
                }
                if(response?.data?.success){
                    setLibraryData(response?.data?.data);
                }
                setReloadDelete(true)
            })
            .catch((error) => {
                console.error('Error removing image:', error);
                setUpdateLoader(false)
                setShowToast(true)
                setToastMessage({'title': error.message})
            });
        }
    }

    const checkSelectionLengthValid = () => {
        if(multipleSelect.length==0){
            setShowToast(true);
            setToastMessage({'title':'Select atleast one image!'})
            return false;
        }else{
            const allSelectedImagesAreEmpty = multipleSelect.every(item => item.select_list.length === 0)
            if(allSelectedImagesAreEmpty){
                setShowToast(true);
                setToastMessage({'title':'Select atleast one image!'})
                return false;
            }
        }
        return true;
    }

    const handleTabClick = (tab, options = {}) =>{
        // Before anything else: the collection we were on is going away, so its drain must not keep
        // fetching. Safe here because handleCollections() below allocates a fresh id afterwards.
        cancelPhotoPagination()
        cancelPastFacePagination()
        queryParams.delete('face-search')
        setPastFaceSearchesOn(false)
        setFaceSearchOn(false)
        // These view filters are per-collection; leaking them into another tab hides its photos.
        tab!==guestUpload && setAllGuestPhotos(true)
        setSelectedOption(allPhotos)
        setFilterWorkId([])
        if(tab != blacklistReview){
            queryParams.delete('work_id')
        }
        queryParams.set('tab', tab)
        const photosWorkId = data?.data?.['photo-collection']?.[0]?.work_id;
        if (tab==photos && photosWorkId) queryParams.set('work_id', photosWorkId);
        const guestWorkId = data?.data['guest-gallery']?.[0]?.work_id;
        const albumWorkId = data?.data['draft-album']?.[0]?.work_id;
        tab==guestUpload && guestWorkId && queryParams.set('work_id', guestWorkId);
        tab==albumSelection && albumWorkId && queryParams.set('work_id', albumWorkId);
        // the list can come back empty, so keep the current work_id rather than crashing on [0]
        tab==past_face_searches && pastFaceSearches?.[0]?._id && queryParams.set('work_id', pastFaceSearches[0]._id)
        tab==userFolders && !showTrash && (newCreatedFolder.current ? queryParams.set('work_id', data?.data['folders']?.[1]?.work_id) : queryParams.set('work_id', data?.data['folders']?.[0]?.work_id));
        const finalSearch = queryParams.toString();
        if (options.replaceInHistory) {
            navigate({ search: finalSearch }, { replace: true });
        } else {
            navigate({ search: finalSearch });
        }
        if(tab==photos && prevCollection == undefined){	
            handleCollections(data?.data?.['photo-collection']?.[0]?.work_id)	
        }else if(tab==photos && prevCollection){
            handleCollections(prevCollection)
        }else if(tab==guestUpload){
            handleCollections(data?.data?.['guest-gallery']?.[0]?.work_id)
        }else if(tab==albumSelection){
            handleCollections(data?.data?.['draft-album']?.[0]?.work_id)
        }else if(tab==userFolders && !showTrash){
            newCreatedFolder.current ? handleCollections(data?.data?.['folders']?.[1]?.work_id) : handleCollections(data?.data?.['folders']?.[0]?.work_id)
        }else if(tab==past_face_searches){
            pastFaceSearches?.[0]?._id && indiFaceData(pastFaceSearches[0]._id)
        }

        if(tab==photos){
            setTimeout(() => {
                getToTop(photoScroll)
            }, 100);
        }else{
            getToTop()
            setShowFilters(true)
        }
    }
    
    const faceFilterPhoto = async () => {
        if (faceFilterRequestRef.current) {
            return;
        }
        faceFilterRequestRef.current = true;
        setShareFaceFilter(false)
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'
        const form = new FormData();
        var apiUrl
        if(shared_key){
            apiUrl = `${process.env.REACT_APP_STAG_URL}/api/face/search/results/shared/${shared_key}/`;
        }else{
            apiUrl = `${process.env.REACT_APP_STAG_URL}/api/face/search/results/${data?.booking_pk || id}/`;
        }
        tab!=past_face_searches && queryParams.get('face-search')!='true' && setFaceFilter(true)
        tab==past_face_searches && setUpdateLoader(true)
        setLoading(true)
        try {
            const response = await axios.post(apiUrl, form, {
                headers: {
                    Authorization: getAuthToken()
                },
            });
            setPastFaceSearches(response?.data)
            !response?.data?.length>0 && !faceSearchOnly && faceSearch()
            if(tab==past_face_searches){
                if(!isValidId(collection_id)){
                    response?.data?.[0]?._id && indiFaceData(response.data[0]._id)
                }else{
                    indiFaceData(collection_id)
                }
            }
        } catch (error) {
            setLoading(false)
            catchError(error)
        }finally{
            faceFilterRequestRef.current = false;
            tab==past_face_searches && setUpdateLoader(false)
        }

    }

    const shareMedia = () => {
        tab==guestUpload ? shareSelection() : (tab==userFolders ? shareDeliverable('selective') : setShareDropdown(!shareDropdown))
    }

    const getPrintAlbumData = () => {
        setUpdateLoader(true)
        const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/all/bookings/albums/user/`
        const authToken = getAuthToken();
        const headers = {
            Authorization: authToken,
            "Content-Type": "application/json",
        };
        if(shared_key){
            data['shared_key'] = shared_key
        }
        axios({
            method: "GET",
            url: `${apiUrl}`,
            headers
        })
        .then((response) => {
            setUpdateLoader(false)
            setAlbumBookingPopup(true)
            setAlbumBookingData(response?.data?.data)
        }).catch((error) => {
            setUpdateLoader(false)
            console.error('Error fetching print album data:', error);
        })
    }


    const getShareSelectiveLinkData = async (type, shareData) => {
        var apiUrl = `${process.env.REACT_APP_STAG_URL}/api/share/url/`;
        if(tab!==userFolders){
            apiUrl += `${data.booking_pk}/`;
        }
        setShareSelectList([])
        shareData['type'] = data.share_type
        try{
            const response = await axios.post(apiUrl, shareData, {
                headers: {
                    Authorization: getAuthToken(),
                },
            });
            if(response.data.success){
                setShareLinkData({
                    ...response.data,
                    note_type: type,
                });
                setShareLinkPopup(true)
                setUpdateLoader(false)
            }else{
                alert(response.data.message)
                setUpdateLoader(false)
            }
        }catch(error){
            catchError(error)
        }
    }

    const switchShareTabs = (switchTabs) => {
        setShareTab(switchTabs)
    }

 
    const shareDeliverable = (type) => {
        setShareTab(tab)
        const data = { data_id_list: [] };
        if(type!=='selective'){
            data[type] = true;
            setUpdateLoader(true)
        }else{
            setShareSelective(true)
            return;
        }
        getShareSelectiveLinkData(type, data)
    }

    const shareSelection = () => {
        const data = {data_id_list: tab==guestUpload ? [collection_id] : Object.values(shareSelectList).flat()}
        if(Object.values(shareSelectList).flat().length == 0 && tab!==guestUpload){
            setShowToast(true)
            setToastMessage({'title':'Select atleast one!'})
        }else{
            setShareSelective(false)
            getShareSelectiveLinkData('', data)
        }
    }

    const shareSelectMedia = (type, id) => {
        if(hiddenWork[id]) return;
        const ele = id.toString();
        setShareSelectList((prevState) => {
            const currentArray = prevState[type] || [];
            return {
                ...prevState,
                [type]: currentArray.includes(ele)
                    ? currentArray.filter((item) => item !== ele)
                    : [...currentArray, ele]
            };
        });
    };

    const redirectToPastFace = (tp) => {
        if(tp.past_face_url){
            setCollection()
            setCollectionData()
            setFaceSearchData()
            // Replace, so the camera/previous results do not become a Back destination.
            navigate(tp.past_face_url, { replace: true })
            window.location.reload()
        }else{
            if(tp.data){
                updateFaceSearchResult(tp.data)
            }else{
                setShowToast(true)
                setToastMessage('No data found!')
            }
        }
    }

    const updateFaceSearchResult = (res) => {
        if(res.success === false){
            setShowToast(true)
            setToastMessage(res?.toast_data)
            if(faceSearchOnly){
                setUpdateLoader(true)
                faceFilterPhoto()
                setUpdateLoader(false)
            }
        }else{
            setFaceOnly(false)
            setFaceSearchOn(true)
            setFaceSearchState(false)
            setFaceCollection(res)
            setFaceSearchData(res)
            let tempData = res?.album_data?.album_data || {};
            setDefAlbumData(JSON.parse(JSON.stringify(tempData))); // Create a deep copy
            setAlbumData(tempData);
            setSingleAlbumData(res?.album_data?.photo_id_map || {})
            setFaceFilter(false)
            setFaceSelect({})
            setImages([])
            setSelectedOption(allPhotos)
            res?.photo_data.map((e) => {
                setFaceFormattedData((prevImages) => ({
                    ...prevImages,
                    [e.work_id]: e.data,
                }));
            });
            res?.photo_data.map((e) => {
                setFaceSelect((prevImages) => ({
                    ...prevImages,
                    [e.work_id]: e.private_data,
                }));
            });
            setFaceHide({})
            res?.photo_data.map((e) => {
                setFaceHide((prevImages) => ({
                    ...prevImages,
                    [e.work_id]: e.private_data,
                }));
            });
            if(res?.photo_data){
                res?.photo_data?.forEach((e)=>{
                        setImages((prev)=>([
                            ...prev,
                            ...e.data
                        ]))
                })
            }else{
                setImages([])
            }
            if(faceSearchOnly){
                if(res?.photo_data){
                    const newImages = {};

                    res.photo_data.forEach((e) => {
                        newImages[e.work_id] = { [e.work_id]: [] };
                    });

                    setSelectImages(newImages);
                    navigate({ search: queryParams.toString() });
                }
            }
        }
        setUpdateLoader(false)
    }

    const selectAllUpdateMultiple = (status, work_id) => {
        const selectedWorkId = Number(work_id);
        const index = multipleSelect.findIndex((obj) => obj.work_id === selectedWorkId);
        const allData = returnFilteredData()?.[selectedWorkId] || [];
        const photoIds = allData.map(obj => obj.photo_id);
        const canDeleteFiltered = deleteSelection ? yourUploads?.filter(item => item?.can_delete) : allData;
        const allGuestFiltered = allGuestPhotos ? allData : canDeleteFiltered;
        const selectedFromImages = (selectImages?.[collection_id]?.[selectedWorkId] || []).map(obj => obj.photo_id);

        const buildItem = (existingItem = {}) => ({
            work_id: selectedWorkId,
            select_list: status
            ? tab === albumSelection
                ? [...new Set([...(existingItem.select_list || []), ...photoIds])]
                : allGuestFiltered.map(obj => obj.photo_id)
            : (tab === albumSelection || tab === userFolders)
                ? (existingItem.select_list || []).filter(id => !selectedFromImages.includes(id))
                : [],
            unselect_list: status ? [] : photoIds
        });

        setMultipleSelect((prev) => {
            if (index === -1) {
            return [...prev, buildItem()];
            }

            return prev.map((item, idx) => {
            if (idx !== index) return item;

            const updatedItem = buildItem(item);

            return {
                work_id: selectedWorkId,
                select_list: status
                ? [...new Set([...(item.select_list || []), ...(updatedItem.select_list || [])])]
                : (tab === albumSelection || tab === userFolders)
                    ? updatedItem.select_list
                    : [],
                unselect_list: (hideSelection && status) ? [] : [...new Set([...(item.unselect_list || []), ...(updatedItem.unselect_list || [])])]
            };
            });
        });
    };


    const closeFacePopup = () => {
        faceFilterRequestRef.current = false;
        setFaceFilter(false)
        document.getElementsByTagName('body')[0].style.overflow = 'auto'
    }

    const lockAlbum = () => {
        setUpdateLoader(true)
        const authToken = getAuthToken();
        const headers = {
            Authorization: authToken,
            "Content-Type": "application/json",
        };
        const api_url = `${process.env.REACT_APP_STAG_URL}/api/work/my/${collection_id}/lock/`
        axios
        .put(`${api_url}`, {} , { headers })
        .then((response)=>{
            setUpdateLoader(false)
            setShowToast(true)
            setToastMessage(response.data.toast_data)
            setAlbumLocked(response.data.data.is_locked)
        })
        .catch((error)=>{
            setUpdateLoader(false)
            catchError(error)
        })
    }

    const faceSearch = () => {
        faceFilterRequestRef.current = false;
        if(queryParams.get('for_selfie')==='true'){
            selfieFetchedRef.current = false;
            sessionStorage.setItem('selfieRetakeReturnUrl', window.location.pathname + window.location.search);
            navigate(`/${id}/registerselfie?retake=true`, { replace: true });
            return;
        }
        setSelection(false)
        setDownloadSelection(false)
        setHideSelection(false)
        if(faceSearchOnly){
            setFaceOnly(true);
            // faceFilterPhoto();
        }else{
            const queryParams = new URLSearchParams(window.location.search);
            queryParams.set('face-search', true)
            // The whole face-search flow stays on one history entry, so Back always leaves it.
            navigate({ search: queryParams.toString()}, { replace: isFaceSearchUrl() });
            setFaceFilter(false)
            setFaceSearchState(true)
            setShowTooltip(false);
            document.getElementsByTagName('body')[0].style.overflow = 'auto'
        }
    }

    const galleryHandler = (event) => {
        if(!hideSelection){
            const bodyDiv = document.getElementsByTagName('body')[0];
            bodyDiv.style.overflow = 'hidden';
            photoIndex && setCurrentPhotoLiked(get_user_liked_photos(likeData, galleryImages[photoIndex-1]?.photo_id))
            setCurrentPhotoFlagged(flaggedData?.[queryParams.get("work_id")]?.includes(galleryImages[photoIndex-1]?.photo_id))
            setFilterDropdown(false)
            setPhotoIndex(parseInt(event?.currentTarget.id, 10));
            setIndexDisplay(event?.currentTarget.id);
            if(!event){
                setPhotoIndex(parseInt(location.hash.split('=')[1], 10))
                setIndexDisplay(location.hash.split('=')[1])
            }
            setShowGallery(true);
            setInitialCarousel(true);
        }
    };

    const updateSelectedPhotos = () => {
        if(isAdmin()){
            return;
        }else{
            if(downloadSelection || deleteSelection || approveFlagSelection){
                if(!checkSelectionLengthValid()){
                    return;
                }
            }
            if(deleteSelection && !deleteConfirm){
                setDeletePopup(true)
                return;
            }
            var apiUrl = '';

            if(selectionType !== addTo){
                if(tab==userFolders && selectionType==deleteUploads){
                    apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/folder/${collection_id}/modify/user/`;
                }else if((faceSearchOn || pastFaceSearchesOn) && selectionType==download){
                    apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/url/face_search_imgs/`;
                }else if(tab==userFolders && selectionType==download){
                    apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/url/custom_imgs/`;
                }else{
                    apiUrl = tab==albumSelection && selectionType==deleteUploads ? `${getApiUrlFromSelectionType(addTo)}${collection_id}/remove_photo_album/` : getApiUrlFromSelectionType(selectionType)
                }
            }else{
                return;
            }
            if(tab==blacklistReview && selectionType==approvePhoto){
                apiUrl += `${queryParams.get('work_id')}/`
            }
            // No blocking loader for likes: the heart already updated optimistically on click.
            selectionType!=viewPhotos && selectionType!=likePhotos && setUpdateLoader(true)
            const authToken = getAuthToken();
            const headers = {
                Authorization: authToken,
                "Content-Type": "application/json",
            };
            let formData = { photo_id_data: multipleSelect };
            if(tab==userFolders && selectionType==deleteUploads){
                const updated = multipleSelect.map(item => ({
                    ...item,
                    unselect_list: item.select_list,
                    select_list: [],
                }));
                formData = { photo_id_data: updated };
            }
            if(shared_key){
                formData['shared_key'] = shared_key
            }
            if((faceSearchOn || pastFaceSearchesOn) && selectionType==download){
                const pastFaceSearchIds = pastFaceSearches?.map((item) => item._id);
                formData['face_search_key'] = pastFaceSearchIds
            }
            if(tab==userFolders && selectionType==download){
                const customFolderKeys = getSelectedData(data, tab)?.map((item) => item.work_id);
                formData['custom_folder_key'] = customFolderKeys
            }
            const method = getApiMethod(selectionType, tab)
            axios({
                method: method,
                url: `${apiUrl}`,
                data: method === "GET" ? null : formData,
                headers
            })
            .then((response) => {
                setDeleteConfirm(false)
                // selectedImages is this render's copy; keep hidden photos from pages that arrived
                // while the request was in flight, or they would drop out of the Hidden grid.
                setHideSelectedObj((latest) => {
                    const next = { ...selectedImages }
                    Object.keys(latest || {}).forEach((workId) => {
                        const known = new Set([...(hideSelectedObj?.[workId] || []), ...(selectedImages?.[workId] || [])].map((p) => p?.photo_id))
                        const arrived = (latest[workId] || []).filter((p) => !known.has(p?.photo_id))
                        if (arrived.length) next[workId] = [...(next[workId] || []), ...arrived]
                    })
                    return next
                })
                if(selectionType==hide && response?.data?.success){
                    syncVisibilityCounts()
                }
                if(collection)collection.private_data = selectedImages[collection_id]
                tab==userFolders && getLibraryData(true)
                // Same as setHideSelectedObj above: keep face pages that arrived mid-request.
                setFaceHide((latest) => {
                    const next = { ...faceSelect }
                    Object.keys(latest || {}).forEach((workId) => {
                        const known = new Set([...(faceHide?.[workId] || []), ...(faceSelect?.[workId] || [])].map((p) => p?.photo_id))
                        const arrived = (latest[workId] || []).filter((p) => !known.has(p?.photo_id))
                        if (arrived.length) next[workId] = [...(next[workId] || []), ...arrived]
                    })
                    return next
                })
                if((deleteSelection || selectionType==deleteUploads || (selectionType==approvePhoto && tab==blacklistReview)) && response?.data?.success){
                    if(!showGallery){
                        setCollectionData()
                        setCollection()
                        getBookingData()
                        setYourUploads()

                        if(galleryImages.length==multipleSelect.map(item => item.select_list).flat().length){
                            handleFilterCheckboxChange(allPhotos)
                        }else{
                            handleFilterCheckboxChange(selectedOption)
                        }
                    }else{
                        setReloadDelete(true)
                        if(galleryImages.length==photoIndex){
                            window.location.hash = `#gallery?index=${1}`;
                            setPhotoIndex(1)
                        }
                        if(galleryImages.length==multipleSelect.map(item => item.select_list).flat().length){
                            setShowGallery(false)
                            setCollectionData()
                            setCollection()
                            getBookingData()
                            setYourUploads()
                            closeGalleryHandler()
                            handleFilterCheckboxChange(allPhotos)
                        }
                        setGalleryImages(galleryImages.filter((image) => 
                            !multipleSelect.some((item) => item.select_list.includes(image.photo_id))
                        ));                        
                    }
                }
                if(tab==userFolders && selectionType!==viewPhotos && response?.data?.success){
                    setReloadDelete(true)
                }
                getFlaggedData()

                if(tab == guestUpload && selectionType == flagPhotos && response?.data?.success){
                    setFlaggedData(updateFlaggedData(flaggedData, multipleSelect, queryParams.get('work_id')));
                    setCurrentPhotoFlagged(prev => !prev)
                    getLikesData(true);
                    getFlaggedData();
                }


                setMultipleSelect((prevSelect)=>
                    prevSelect.map(item=>({
                        ...item,
                        select_list: [],
                        unselect_list: []
                })))
                setSelectImages((prev) => {
                    const cleared = {};
                    Object.keys(prev).forEach((collectionId) => {
                        cleared[collectionId] = {};

                        Object.keys(prev[collectionId]).forEach((key) => {
                        cleared[collectionId][key] = [];
                        });
                    });
                    return cleared;
                });
                setSelectionAll({})
                if(downloadSelection || selectionType==download){
                    setDownloadDetails(response.data)
                    setIsPopupOpen(true)
                }
                
                setHideSelection(false)
                setDownloadSelection(false)
                setDeleteSelection(false)
                setApproveFlagSelection(false);
                setSelection(false)
                selectedOption !== allPhotos && selectionType!==deleteUploads && selectionType!==likePhotos && handleFilterCheckboxChange(selectedOption)
                setUpdateLoader(false)
                setUpdateSinglePhoto(false)
                if(selectionType !== download && selectionType !== viewPhotos){         //don't show toast for view photos and downloads and show for like photos only it title key is present
                    if((selectionType==likePhotos || selectionType==deleteUploads) && !response.data.hasOwnProperty('toast_data'))return;
                    setShowToast(true)
                    setToastMessage(response.data.toast_data)
                }

            })
            .catch((error) => {
                console.error('Error removing image:', error);
                setUpdateLoader(false)
                if(selectionType == viewPhotos) return;
                setShowToast(true)
                setToastMessage({'title': selectionType == likePhotos ? 'Some error occurred while liking the photo' : error.message})
            });
        }
    }

    function updateFlaggedData(flaggedData, multipleSelect, myWorkId) {
        const updatedFlaggedData = { ...flaggedData };
      
        const flaggedWorkEntry = updatedFlaggedData[myWorkId] || [];
      
        const workSelection = multipleSelect.find(item => item.workId === myWorkId);
        
        if (!workSelection) {
          return updatedFlaggedData; // No changes needed if no selection exists
        }
      
        if (workSelection.selectList && workSelection.selectList.length > 0) {
          workSelection.selectList.forEach(photoId => {
            if (!flaggedWorkEntry.includes(photoId)) {
              flaggedWorkEntry.push(photoId);
            }
          });
        }
      
        if (workSelection.unselectList && workSelection.unselectList.length > 0) {
          updatedFlaggedData[myWorkId] = flaggedWorkEntry.filter(
            photoId => !workSelection.unselectList.includes(photoId)
          );
        } else {
          updatedFlaggedData[myWorkId] = flaggedWorkEntry;
        }
      
        return updatedFlaggedData;
    }

    const downloadFaceSearch = () => {
        setSelectionType(download)
        Object.keys(faceSearchOn ? faceFormattedData : collectionFormattedData).forEach((key) =>
            (faceSearchOn ? faceSearchData : collection)?.photo_data.map((e)=>{
                if(e.work_id==key){
                    if(selectionType==addTo){
                        (e.can_add_to || e.is_album_required) && selectAllUpdateMultiple(true, key)
                    }else if(selectionType==hide){
                        e.can_make_private && selectAllUpdateMultiple(true, key)
                    }else{
                        e.is_downloadable && selectAllUpdateMultiple(true, key)
                    }
                }
            })
        );
        setReadyFaceSearchDownload(true)
    }

    const okayHide = () => {
        document.getElementById('grideHidePopup').style.display = 'none';
        setGridFirstCheck(false)
    }

    const closeGalleryHandler = async () => {
        setShowGallery(false);
        const bodyDiv = document.getElementsByTagName('body')[0];
        bodyDiv.style.overflow = 'auto';
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname + window.location.search
        );
        location.hash=''
        if(reloadDelete || newCreatedFolder.current){
            setCollectionData()
            setCollection()
            getBookingData()
            setYourUploads()
            if(faceSearchOn){
                setFaceSearchData((prevData) => ({
                    ...prevData,
                    photo_data: prevData.photo_data.map((item) => ({
                      ...item,
                      data: item.data.filter((dataItem) =>
                        galleryImages.some((ref) => ref.photo_id === dataItem.photo_id)
                      ),
                    })),
                }));
            }
            setReloadDelete(false)
            return;
        }
        setFaceSearchState(false)
        fetchImages()
        handleFilterCheckboxChange(selectedOption)
    };

    const handleAlbum = (albumId) =>{
        handleCollections(albumId)
        queryParams.set('work_id', albumId)
        queryParams.set('album_status', true)
        navigate({ search: queryParams.toString()});
        setAlbumView(true)
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    }

    const closeAlbum = () =>{
        queryParams.delete('album_status')
        queryParams.delete('work_id')
        navigate({ search: queryParams.toString()});
        setAlbumView(false)
        setShowFilters(true)
        document.getElementsByTagName('body')[0].style.overflow = 'auto'
    }

    const handleVideo = (videoId) =>{
        handleCollections(videoId)
        queryParams.set('work_id', videoId)
        queryParams.set('video_status', true)
        navigate({ search: queryParams.toString() });
        setVideoView(true)
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    }

    const hideSelected = (workId, isHidden) =>{
        if (firstCheckMedia.current) {
            document.getElementById('mediaHidePopup').style.display = 'flex';
            document.getElementById('hideButtonMedia').innerText = isHidden ? 'Unhide' : 'Hide';
            document.getElementById('popupMediaTitle').innerText = isHidden ? 'Unhide' : 'Hide';
            document.getElementById('popupMediaDesc').innerText = isHidden ? 'Unhidden media are visible to everyone with whom they are shared' : 'Hidden media are invisible to everyone with whom they are shared';
            document.getElementById('hideButtonMedia').onclick = () => {
                handleHideMedia(workId, isHidden);
            };
        } else {
            const data = {'hide': !isHidden}
            const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/${workId}/visibility/update/`
            const authToken = getAuthToken();
            const headers = {
                Authorization: authToken,
                "Content-Type": "application/json",
            };
            axios
            .post(`${apiUrl}`, data, { headers })
            .then((response) => {
                const updatedVideos = { ...hiddenWork, [workId]: !hiddenWork[workId] };
                setHiddenWork(updatedVideos);
                setUpdateLoader(false)
                setShowToast(true)
                setToastMessage(response.data.toast_data)
            })
            .catch((error) => {
                console.error('Error removing image:', error);
                setUpdateLoader(false)
                setShowToast(true)
                setToastMessage({'title': error.message})
            });
        }
    }


    const closeVideo = () =>{
        queryParams.delete('video_status')
        queryParams.delete('work_id')
        window.location.replace(window.location.pathname + '?' + queryParams.toString())
    }

    const getSelectionData = (key) => {
        setSelection(true)

        setSelectionType(key)
        if(key == hide){
            setHideSelection(true)
            selectionMode('', hide)
        }else if(key == download){
            setDownloadSelection(true)
            selectionMode('', download)
        }else if(key == addTo){
            setAddToSelection(true)
            selectionMode('', addTo)
        }else if(key==deleteUploads){
            setDeleteSelection(true)
            selectionMode('', deleteUploads)
        }else if(key == approvePhoto){
            setApproveFlagSelection(true)
            selectionMode('', approvePhoto)
        }
    }

    const qualityPopup = (list) => {
        setVideoDetails(list)
        setQualityVideo(true)
        list.map((e)=>{
            if(e.quality==1080){
                setCurrentQualityUrl(e.url)
            }
        })
    }

    const downloadCollection = () => {
        setUpdateLoader(true)
        const authToken = getAuthToken();
        const headers = {
            Authorization: authToken,
            "Content-Type": "application/json",
        };
        const data = { photo_id_data: [{work_id: Number(collection_id), select_list: [], unselect_list: []}]}
        if(shared_key){
            data['shared_key'] = shared_key
        }

        const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/url/collection_imgs/${collection_id}/`

        axios
        .post(`${apiUrl}`, data, { headers })
        .then((response) => {
            setDownloadDetails(response?.data)
            setIsPopupOpen(true)
            setUpdateLoader(false)
        })
        .catch((error) => {
            console.error('Error removing image:', error);
            setUpdateLoader(false)
            setShowToast(true)
            setToastMessage({'title': error.message})
        });
    }

    const toggleAddToPopup = () => {
        if(checkSelectionLengthValid()){
            setIsAddToOpen(!isAddToOpen);
        }
    };

    const selectionTypeData = (selectionType, currId) => {
        if(selectionType==hide){
            if(selectionAll[currId]){
                return returnFilteredData()
            }else{
                return faceSearchOn ? faceHide : selectedImages;
            }
        }else if(selectionType==download || selectionType==addTo || selectionType==deleteUploads || selectionType==approvePhoto){
            if(selectionAll[currId]){
                return returnFilteredData()
            }else{
                return faceSearchOn ? Object.keys(faceFormattedData).reduce((acc, key) => {
                    acc[key] = [];
                    return acc;
                }, {}) : Object.keys(collectionFormattedData).reduce((acc, key) => {
                    acc[key] = multipleSelect?.find(item => item.work_id == key)?.select_list || [];
                    return acc;
                }, {})
            }
        }
    }

    const selectionMode = (status, selectionType) => {
        if (images?.length === 0) return;
        const currId = queryParams.get('work_id');
        if (gridFirstCheck && selectionType==hide) {
            document.getElementById('grideHidePopup').style.display = 'flex';
        }
        const data = Object.values(returnFilteredData()).flat() || [];
        const selectedData = selectionType==download || selectionType==addTo || selectionType==deleteUploads || selectionType==approvePhoto ? selectImages[collection_id]?.[currId] : (selectedImages[currId] ? selectedImages[currId] : collection?.photo_data.flatMap(e=>e.private_data));
        const totalItems = faceSearchOn && selectionType!==download && selectionType!==deleteUploads && selectionType!==approvePhoto &&  selectionType!==addTo
        ? Object.values(faceSelect).reduce((sum, arr) => sum + arr.length, 0)
        : selectedData.length;
        let arrayToBeUpdated;

        if (status === '') {
            !faceSearchOn ? setSelectionAll((prev) => ({
                ...prev,
                [currId]: totalItems === data?.length
            })) : setSelectionAll((prev) => ({
                ...prev,
                [currId]: totalItems === images.length || totalItems === data?.length
            }));
            arrayToBeUpdated = selectionTypeData(selectionType, currId);
        } else if (status === true) {
            const canSelect = deleteSelection ? yourUploads?.filter(item => item?.can_delete) : yourUploads
            arrayToBeUpdated = faceSearchOn ? returnFilteredData() : ((tab==guestUpload && !allGuestPhotos) ? canSelect : returnFilteredData());
            if(filterWorkId.length > 0){
                arrayToBeUpdated = filterWorkIdData(arrayToBeUpdated)
            }
            Object.keys(returnFilteredData()).forEach((key) =>
                (faceSearchOn? faceSearchData : collection)?.photo_data.map((e)=>{
                    if(e.work_id==key && (filterWorkId.length == 0 || filterWorkId.includes(String(key)))){
                        if(selectionType==addTo){
                            if(printSelection){
                                (e.can_add_to || e.is_album_required) && printSelectedData?.work_id_list.includes(e.work_id) && selectAllUpdateMultiple(true, key)
                            }else{
                                (e.can_add_to || e.is_album_required) && selectAllUpdateMultiple(true, key)
                            }
                        }else if(selectionType==download){
                            e.is_downloadable && selectAllUpdateMultiple(true, key)
                        }else if(selectionType==hide){
                            e.can_make_private && selectAllUpdateMultiple(true, key)
                        }else if(selectionType==deleteUploads){
                            selectAllUpdateMultiple(true, key)
                        }else if(selectionType==approvePhoto){
                            selectAllUpdateMultiple(true, key)
                        }
                    }
                })
            );
        } else if (status === false) {
            arrayToBeUpdated = faceSearchOn
                ? Object.keys(faceSelect).reduce((acc, key) => ({ ...acc, [key]: [] }), {})
                : (hideSelection ? Object.keys(selectedImages).reduce((acc, key) => {
                    if (collection_id == key) {
                        acc[key] = [];
                    }else {
                        acc[key] = selectedImages[key]
                    }
                    return acc;
                }, {}) : Object.keys(selectImages[collection_id]).reduce((acc, key) => {
                    acc[key] = [];
                    return acc; 
                }, {}));

            Object.keys(returnFilteredData()).forEach((key) => {
                if (Object.keys(selectImages[collection_id] || {}).includes(key)) {
                    selectAllUpdateMultiple(false, key);
                }
            });
        }
        
        if (status === 'selectAll') {
            const compareCount = downloadSelection || addToSelection || deleteSelection ? tileCountsRef.current.checked : collectionData[currId]?.photo_data.flatMap(e=>e.private_data)?.length
            setSelectionAll((prev) => ({
                ...prev,
                [currId]: faceSearchOn ? totalItems === images.length : compareCount === data?.length - tileCountsRef.current.blocked
            }));
            
        }

        if (status !== 'selectAll') {
            const selectedObj = selectionModeArray(arrayToBeUpdated)
            setClassObj(selectedObj);
        }
    };


    const cancelSelection = () => {
        if(selection){
            setMultipleSelect((prevSelect)=>
                prevSelect.map(item=>({
                    ...item,
                    select_list: [],
                    unselect_list: []
            })))
            setSelectImages((prev) => {
                const cleared = {};
                Object.keys(prev).forEach((collectionId) => {
                    cleared[collectionId] = {};

                    Object.keys(prev[collectionId]).forEach((key) => {
                    cleared[collectionId][key] = [];
                    });
                });
                return cleared;
            });
        }
        setHideSelection(false)
        setDownloadSelection(false)
        setDeleteSelection(false)
        setApproveFlagSelection(false)
        setAddToSelection(false)
        setSelection(false)
        setDeletePopup(false)
        setPrintSelection(false)
        setSelectionAll({})
        if(faceSearchOn){
            setFaceSelect(faceHide)
        }else{
            setSelectedImages(hideSelectedObj)
        }
        setImages([])
        selectImages && setSelectImages((prev) => {
            const cleared = {};
            Object.keys(prev).forEach((collectionId) => {
                cleared[collectionId] = {};

                Object.keys(prev[collectionId]).forEach((key) => {
                cleared[collectionId][key] = [];
                });
            });
            return cleared;
        });
        if(!faceSearchData?.photo_data){
            getFilteredData()
        }else{
            faceSearchData?.photo_data?.forEach((e)=>{
                setImages((prev)=>([
                    ...prev,
                    ...e.data
            ]))
        })
        }
    }

    const handleNextCollection = (next, resetIndex=false) => {
        setGalleryNextCollectionPopup(false)
        getToTop();
        const selected_data = getSelectedData(data, tab)
        selected_data?.forEach((e, index)=>{
            const goto = next ? index+1 : index-1
            if(e.work_id == collection_id && goto < selected_data?.length){
                if (selected_data[goto].work_id && window.location.hash.includes('#gallery')) {
                    // moving collection in full screen: back should drop us here, not where the
                    // history entry points. Recorded here, not in handleCollections(), which also
                    // runs as a back unwinds through the previous collection.
                    galleryWorkIdRef.current = selected_data[goto].work_id;
                }
                selected_data[goto].work_id && handleCollections(selected_data[goto].work_id, resetIndex)
            }
        })
        setShowFilters(true)
    }

    const handleNextVideo = useCallback(() => {
        const videoData = data?.data['video']
        if (!videoData) return
        const idx = videoData.findIndex(e => e.work_id == collection_id)
        if (idx !== -1 && videoData[idx + 1]) {
            setCollection(null)
            handleCollections(videoData[idx + 1].work_id)
        }
    }, [data, collection_id])

    const handleFilterCheckboxChange = (filter, ids) => {
        setFilterWorkId((prev) => {
            if (!ids || ids.length === 0) return prev;
            const allPresent = ids.every((id) => prev.includes(id));
            if (allPresent) {
              return prev.filter((id) => !ids.includes(id));
            } else {
              return Array.from(new Set([...prev, ...ids]));
            }
        });

        setSelectedOption(filter)
        if(faceSearchOn){
            setFaceSearchData(faceCollection)
        }else{
            const currentData = allGuestPhotos ? collection?.photo_data?.flatMap(e=>e.data) : collection?.photo_data?.flatMap(e=>e.my_uploads)
            if(filter == allPhotos){
                setImages(currentData)
            }else if(filter == privatePhotos){
                setImages(selectedImages[collection_id])
            }else if(filter == publicPhotos){
                setImages(currentData?.filter(img => !selectedImages[collection_id]?.some(el=> img.photo_id === el.photo_id)))
            }
        }
    }

    const mergeUniqueByPhotoId = (existingArr, incomingArr) => {
        const existingList = Array.isArray(existingArr) ? existingArr : []
        const incomingList = Array.isArray(incomingArr) ? incomingArr : []
        if (incomingList.length === 0) return existingList

        const existingIds = new Set(
            existingList.map((x) => x?.photo_id).filter(Boolean)
        )
        const filteredIncoming = incomingList.filter(
            (x) => x?.photo_id && !existingIds.has(x.photo_id)
        )
        return [...existingList, ...filteredIncoming]
    }

    const appendPastFaceSearchResultPage = (pageResponseData) => {
        const incomingEntries = Array.isArray(pageResponseData?.photo_data) ? pageResponseData.photo_data : []
        if (incomingEntries.length === 0) return

        const mergePage = (prev) => {
            const prevEntries = Array.isArray(prev?.photo_data) ? prev.photo_data : []
            const orderedWorkIds = prevEntries.map((e) => String(e?.work_id))
            const entryMap = new Map(prevEntries.map((e) => [String(e?.work_id), { ...(e || {}) }]))

            incomingEntries.forEach((incoming) => {
                const workId = String(incoming?.work_id)
                if (!workId || workId === 'undefined') return

                const incomingData = incoming?.data || []
                const incomingPrivate = incoming?.private_data || []

                if (!entryMap.has(workId)) {
                    orderedWorkIds.push(workId)
                    entryMap.set(workId, {
                        ...(incoming || {}),
                        data: incomingData,
                        private_data: incomingPrivate
                    })
                    return
                }

                const existing = entryMap.get(workId) || {}
                const mergedData = mergeUniqueByPhotoId(existing?.data, incomingData)
                const mergedPrivate = mergeUniqueByPhotoId(existing?.private_data, incomingPrivate)

                entryMap.set(workId, {
                    ...existing,
                    ...incoming,
                    data: mergedData,
                    private_data: mergedPrivate
                })
            })

            const mergedPhotoData = orderedWorkIds
                .map((id) => entryMap.get(id))
                .filter(Boolean)

            return {
                ...(prev || {}),
                ...(pageResponseData || {}),
                photo_data: mergedPhotoData,
                photo_count: pageResponseData?.photo_count ?? prev?.photo_count,
                // Whole-search totals come with page 0. A later page was requested before any hide
                // the user has since made, so its counts would undo that hide's +1/-1.
                private_photo_count: prev?.private_photo_count ?? pageResponseData?.private_photo_count,
                public_photo_count: prev?.public_photo_count ?? pageResponseData?.public_photo_count,
            }
        }
        setFaceSearchData(mergePage)
        // The filters restore faceSearchData from faceCollection, so it must hold every page too.
        setFaceCollection(mergePage)

        incomingEntries.forEach((entry) => {
            const workId = entry?.work_id
            if (!workId && workId !== 0) return

            const pageData = entry?.data || []
            const pagePrivateData = entry?.private_data || []

            setFaceFormattedData((prev) => ({
                ...(prev || {}),
                [workId]: mergeUniqueByPhotoId(prev?.[workId], pageData)
            }))
            setFaceHide((prev) => ({
                ...(prev || {}),
                [workId]: mergeUniqueByPhotoId(prev?.[workId], pagePrivateData)
            }))
            setFaceSelect((prev) => ({
                ...(prev || {}),
                [workId]: mergeUniqueByPhotoId(prev?.[workId], pagePrivateData)
            }))
        })

        const incomingAllPublic = incomingEntries.flatMap((e) => Array.isArray(e?.data) ? e.data : [])
        setImages((prev) => mergeUniqueByPhotoId(prev, incomingAllPublic))
    }

    const appendPhotoPageToUI = (workId, pagePhotoData) => {
        const pageData = pagePhotoData?.data || []
        const pagePrivateData = pagePhotoData?.private_data || []
        const pageMyUploads = pagePhotoData?.my_uploads || []

        setCollectionFormattedData((prev) => ({
            ...(prev || {}),
            [workId]: mergeUniqueByPhotoId(prev?.[workId], pageData),
        }))
        setHideSelectedObj((prev) => ({
            ...(prev || {}),
            [workId]: mergeUniqueByPhotoId(prev?.[workId], pagePrivateData),
        }))
        setSelectedImages((prev) => ({
            ...(prev || {}),
            [workId]: mergeUniqueByPhotoId(prev?.[workId], pagePrivateData),
        }))
        setYourUploads((prev) => mergeUniqueByPhotoId(prev, pageMyUploads))

        const privateIdSet = new Set((pagePrivateData || []).map((p) => p?.photo_id).filter(Boolean))
        const selectedOption = selectedOptionRef.current
        const allGuestPhotos = allGuestPhotosRef.current

        if (selectedOption === allPhotos) {
            const nextVisibleItems = allGuestPhotos ? pageData : pageMyUploads
            setImages((prev) => {
                const merged = mergeUniqueByPhotoId(prev, nextVisibleItems)
                if (photoCountRef.current && allGuestPhotos && merged.length >= photoCountRef.current) {
                    hasMorePhotoPagesRef.current = false
                }
                return merged
            })
            return
        }

        if (selectedOption === privatePhotos) {
            setImages((prev) => mergeUniqueByPhotoId(prev, pagePrivateData))
            return
        }

        if (selectedOption === publicPhotos) {
            const incomingBase = allGuestPhotos ? pageData : pageMyUploads
            const nextPublicItems = (incomingBase || []).filter((p) => p?.photo_id && !privateIdSet.has(p.photo_id))
            setImages((prev) => mergeUniqueByPhotoId(prev, nextPublicItems))
            return
        }
    }

    // Builds new objects rather than editing the stored ones, so it does not depend on the store's
    // auto-freeze being off.
    const mergePhotoPageIntoEntry = (existing, pageResponseData) => {
        const newEntries = Array.isArray(pageResponseData?.photo_data) ? pageResponseData.photo_data : []
        if (newEntries.length === 0) return existing

        const mergedEntries = Array.isArray(existing?.photo_data) ? [...existing.photo_data] : []
        newEntries.forEach((newEntry) => {
            if (!newEntry?.work_id) return
            const matchIndex = mergedEntries.findIndex(
                (e) => String(e?.work_id) === String(newEntry.work_id)
            )

            if (matchIndex === -1) {
                mergedEntries.push(newEntry)
                return
            }

            const existingEntry = mergedEntries[matchIndex]
            mergedEntries[matchIndex] = {
                ...existingEntry,
                data: mergeUniqueByPhotoId(existingEntry.data, newEntry.data),
                private_data: mergeUniqueByPhotoId(existingEntry.private_data, newEntry.private_data),
                my_uploads: mergeUniqueByPhotoId(existingEntry.my_uploads, newEntry.my_uploads),
                next_page: newEntry.next_page,
            }
        })
        return { ...existing, photo_data: mergedEntries }
    }

    const mergePhotoPageIntoCollectionDataCache = (workId, pageResponseData) => {
        if (!pageResponseData) return
        let cached
        let merged
        setCollectionData((prev) => {
            cached = prev?.[workId]
            merged = cached ? mergePhotoPageIntoEntry(cached, pageResponseData) : pageResponseData
            return { ...(prev || {}), [workId]: merged }
        })
        // collection is the cache entry, or a shallow copy of it, and the grid reads its pages too.
        // Keep it sharing photo_data with the cache, as it did before the page came in.
        setCollection((prev) => {
            if (!prev || !cached || merged === cached) return prev
            let next = prev
            if (prev === cached) next = merged
            else if (prev.photo_data === cached.photo_data) next = { ...prev, photo_data: merged.photo_data }
            if (next !== prev) pageMergedCollectionRef.current = next
            return next
        })
    }

    const getPhotoPageUrl = (workId) => {
        const currentTab = queryParams?.get('tab')
        if (currentTab === albumSelection) return getAPIUrl(`/api/work/my/${workId}/`)
        if (currentTab === userFolders) return getAPIUrl(`/api/work/folder/${workId}/user/`)
        if (currentTab === blacklistReview) return getAPIUrl(`/api/work/blacklist/${workId}/`)
        return getAPIUrl(`/api/work/${workId}/`)
    }

    const getPhotoPageKey = (workId, pageNumber) => `${getPhotoPageUrl(workId)}|${shared_key || ''}|${pageNumber}`

    const fetchPhotoPage = async (workId, pageNumber) => {
        const currentTab = queryParams?.get('tab')
        const api_url = getPhotoPageUrl(workId)

        if (currentTab === albumSelection || currentTab === blacklistReview) {
            const params = {
                current_page: pageNumber,
                client_type: "mobile",
            }
            if (shared_key) params.key = shared_key

            const response = await axios.get(api_url, {
                headers: {
                    Authorization: getAuthToken(),
                },
                params,
                timeout: CONST.PAGE_REQUEST_TIMEOUT_MS,
            })
            return response?.data
        }

        const form = new FormData()
        form.append("client_type", "mobile")
        if (shared_key) form.append("key", shared_key)
        form.append("current_page", pageNumber)

        const response = await axios.post(api_url, form, {
            headers: {
                Authorization: getAuthToken(),
                "Content-Type": "multipart/form-data",
            },
            timeout: CONST.PAGE_REQUEST_TIMEOUT_MS,
        })
        return response?.data
    }

    const requestPhotoPage = (workId, pageNumber) => {
        const pending = pendingPhotoPagesRef.current
        if (pageNumber === 0) {
            // A fresh first page means a fresh load, so pages kept from an earlier visit are stale.
            const prefix = getPhotoPageKey(workId, '')
            ;[...pending.keys()].forEach((key) => key.startsWith(prefix) && pending.delete(key))
            return fetchPhotoPage(workId, pageNumber)
        }
        const key = getPhotoPageKey(workId, pageNumber)
        if (!pending.has(key)) {
            pending.set(key, fetchPhotoPage(workId, pageNumber).catch((error) => {
                pending.delete(key)
                throw error
            }))
        }
        return pending.get(key)
    }

    const getTotalPagesFromPhotoDataEntry = (entry) => {
        const raw = entry?.total_pages
        const parsed = Number(raw)
        return Number.isFinite(parsed) && parsed > 0 ? parsed : 0
    }

    // For endpoints where `photo_data` can contain multiple work entries,
    // read `total_pages` from the matching entry if possible.
    const getTotalPagesFromResponse = (responseData, targetWorkId) => {
        // The API returns total_pages at the top level of the response, not inside
        // photo_data. Read it there first; the per-entry lookup below is a fallback.
        const topLevelTotalPages = getTotalPagesFromPhotoDataEntry(responseData)
        if (topLevelTotalPages > 0) return topLevelTotalPages

        const entries = responseData?.photo_data || []
        if (!Array.isArray(entries) || entries.length === 0) return 0

        if (targetWorkId !== undefined && targetWorkId !== null) {
            const match = entries.find((e) => String(e?.work_id) === String(targetWorkId))
            if (match) return getTotalPagesFromPhotoDataEntry(match)
        }

        return getTotalPagesFromPhotoDataEntry(entries[0])
    }

    const getMaxPageIndex = (workId) => {
        const totalPages = Number(totalPagesByWorkIdRef.current?.[workId] || 0)
        if (totalPages <= 0) return null
        return totalPages - 1
    }

    const buildPageBatch = (startPage, workId, batchSize = CONST.PAGINATION_BATCH_SIZE) => {
        if (startPage === null || startPage === undefined) return []
        const maxPageIndex = getMaxPageIndex(workId)
        const pages = []
        for (let page = startPage; page < startPage + batchSize; page++) {
            if (maxPageIndex !== null && page > maxPageIndex) break
            if (!fetchedPageNumbersRef.current.has(page)) {
                pages.push(page)
            }
        }
        return pages
    }

    const fetchAndAppendPageBatch = async (workId, pagesToFetch, expectedReqId) => {
        if (!Array.isArray(pagesToFetch) || pagesToFetch.length === 0) return
        // Re-check immediately before dispatching, so a cancel that landed while the previous
        // batch was in flight cannot still fire one more round of requests.
        if (photoPaginationRequestIdRef.current !== expectedReqId || !isStillOnWorkId(workId)) return
        const results = await Promise.allSettled(pagesToFetch.map((pageNum) => requestPhotoPage(workId, pageNum)))

        if (photoPaginationRequestIdRef.current !== expectedReqId || !isStillOnWorkId(workId)) return true

        // Keep pages up to the first failure, so the grid stays in page order; the next batch
        // starts again from the failed page.
        const firstFailed = results.findIndex((r) => r.status !== 'fulfilled')
        const loadedCount = firstFailed === -1 ? results.length : firstFailed
        const responses = results.slice(0, loadedCount).map((r) => r.value)
        if (loadedCount > 0) setPhotoPagesVersion((v) => v + 1)
        pagesToFetch.slice(0, loadedCount).forEach((pageNum) => pendingPhotoPagesRef.current.delete(getPhotoPageKey(workId, pageNum)))
        responses.forEach((pageResponseData) => {
            mergePhotoPageIntoCollectionDataCache(workId, pageResponseData)

            const entries = Array.isArray(pageResponseData?.photo_data) ? pageResponseData.photo_data : []
            entries.forEach((entry) => {
                if (!entry?.work_id) return
                appendPhotoPageToUI(entry.work_id, entry)

                const tp = getTotalPagesFromPhotoDataEntry(entry)
                if (tp > 0) {
                    totalPagesByWorkIdRef.current = {
                        ...(totalPagesByWorkIdRef.current || {}),
                        [entry.work_id]: tp,
                    }
                }
            })
        })
        pagesToFetch.slice(0, loadedCount).forEach((pageNum) => fetchedPageNumbersRef.current.add(pageNum))

        if (firstFailed !== -1) {
            photoNextPageRef.current = pagesToFetch[firstFailed]
            return getFailureKind(results)
        }

        const maxPageIndex = getMaxPageIndex(workId)
        const lastFetchedPage = pagesToFetch[pagesToFetch.length - 1]
        photoNextPageRef.current = lastFetchedPage + 1
        if (maxPageIndex !== null) {
            setHasMorePhotoPages(photoNextPageRef.current <= maxPageIndex)
        } else {
            const nextFromApi = responses?.[responses.length - 1]?.photo_data?.[0]?.next_page
            setHasMorePhotoPages(!(nextFromApi === '' || nextFromApi === null || nextFromApi === undefined))
        }
        return true
    }

    const drainRemainingPhotoPages = async (workId, expectedReqId, resume = false) => {
        if (!workId) return
        if (isFetchingPhotoPageRef.current) return

        isFetchingPhotoPageRef.current = true
        setIsPhotoPageLoading(true)
        try {
            let failedAttempts = 0
            // After a failure, probe with one page: a whole failed batch counts 3 toward the axios
            // guard's 5-failures block, and every photo page shares one URL.
            let singlePage = resume
            while (
                photoPaginationRequestIdRef.current === expectedReqId &&
                hasMorePhotoPagesRef.current &&
                isStillOnWorkId(workId)
            ) {
                const nextPage = photoNextPageRef.current
                if (nextPage === null || nextPage === undefined) break

                const batchPages = buildPageBatch(nextPage, workId, singlePage ? 1 : CONST.PAGINATION_BATCH_SIZE)
                if (batchPages.length === 0) {
                    setHasMorePhotoPages(false)
                    break
                }
                const result = await fetchAndAppendPageBatch(workId, batchPages, expectedReqId)
                if (result === true) {
                    failedAttempts = 0
                    singlePage = false
                    continue
                }
                failedAttempts += 1
                singlePage = true
                if (!(await waitBeforePageRetry(failedAttempts, result === 'blocked'))) break
            }
        } catch (e) {
            catchError(e)
        } finally {
            if (photoPaginationRequestIdRef.current === expectedReqId) {
                isFetchingPhotoPageRef.current = false
                setIsPhotoPageLoading(false)
                // appendPhotoPageToUI can end it from inside a setImages updater, which only sets the ref.
                setHasMorePhotoPagesState(hasMorePhotoPagesRef.current)
            }
        }
    }

    const handleCollections = async (workId, resetIndex=false)=>{
        if (!isValidId(workId)) {
            return;
        }
        loadedWorkIdRef.current = workId;
        setRecallCollection(false)
        tab==photos && setPrevCollection(workId)
        setCollection(null)
        setFilterDropdown(false)
        setAlbumTitle('')
        setShowFilters(true)
        setSelectedOption(selectedOption)
        const imagesLength = images?.length
        setImages([])
        setIsPhotoPageLoading(false)
        setPageLoadFailed(false)
        isFetchingPhotoPageRef.current = false
        let dataStore = collectionData ? { ...collectionData } : {};
        const shouldPaginatePhotos = [photos, guestUpload, albumSelection, userFolders, blacklistReview].includes(queryParams?.get('tab'));
        queryParams.set('work_id', workId)
        const navigateData = { search: queryParams.toString() }
        if(window.location.hash && resetIndex){
            setPhotoIndex(1)
            navigateData.hash = 'gallery?index=1';
        }
        const targetSearch = `?${navigateData.search}`;
        const targetHash = navigateData.hash || '';
        if (window.location.search !== targetSearch || window.location.hash !== targetHash) {
            navigate(navigateData);
        }
        if(Object.keys(dataStore) && Object.keys(dataStore)?.length !== 0 && 
        dataStore.hasOwnProperty(workId) && 
        dataStore[workId]?.expires_at > Date.now() && tab!==albumSelection && tab!==videos){
            tab!==userFolders && dataStore[workId]?.photo_data?.forEach((e)=>e.private_data=selectedImages[workId] || [])
            setCollection(dataStore[workId])
            syncUserFolderFilterWorkIds(dataStore[workId])
            if(tab==userFolders){     // if library is selected then show photos sorted by epoch time i.e most recent first
                getTimeSortedData(dataStore[workId])
            }
            setAlbumLocked(dataStore[workId].is_locked)
            setAlbumTitle(dataStore[workId].title)
            !hideSelection && tab!==guestUpload && tab!==userFolders && setSelectedImages((prevState) => ({
                ...prevState,
                [workId]: hideSelectedObj[workId]
            }));
            if(tab==userFolders){
                dataStore[workId]?.photo_data?.forEach((e) => {
                    setHideSelectedObj((prevHideData) => ({
                        ...prevHideData,
                        [e.work_id]: e.private_data,
                    }));
                });
                dataStore[workId]?.photo_data?.forEach((e) => {
                    setSelectedImages((prevSelectedData) => ({
                        ...prevSelectedData,
                        [e.work_id]: e.private_data,
                    }));
                });
            }
            setCollectionFormattedData({})
            dataStore[workId]?.photo_data?.map((e) => {
                    setCollectionFormattedData((prevImages) => ({
                        ...prevImages,
                        [e.work_id]: e.data,
                    }));
                });
            let tempImg = dataStore[workId]?.photo_data?.flatMap((e) => e.data) || [];
            (queryParams?.get('tab')==photos || queryParams?.get('tab')==guestUpload) && setImages(tempImg)
            if (shouldPaginatePhotos) {
                const paginationRequestId = ++photoPaginationRequestIdRef.current;
                const cachedNextPage = dataStore[workId]?.photo_data?.[0]?.next_page;
                totalPagesByWorkIdRef.current = {
                    ...(totalPagesByWorkIdRef.current || {}),
                    [workId]: getTotalPagesFromResponse(dataStore[workId], workId),
                };
                if (cachedNextPage === '' || cachedNextPage === null || cachedNextPage === undefined) {
                    setHasMorePhotoPages(false);
                    photoNextPageRef.current = CONST.PAGINATION_BATCH_SIZE;
                    fetchedPageNumbersRef.current = new Set([0]);
                } else {
                    const nextPageNum = Number(cachedNextPage);
                    const maxPageIndex = getMaxPageIndex(workId);
                    setHasMorePhotoPages(maxPageIndex === null ? true : nextPageNum <= maxPageIndex);
                    photoNextPageRef.current = nextPageNum;
                    const preloaded = new Set();
                    for (let p = 0; p < Math.max(0, nextPageNum); p++) preloaded.add(p);
                    fetchedPageNumbersRef.current = preloaded;
                }
                isFetchingPhotoPageRef.current = false;
                if (hasMorePhotoPagesRef.current) {
                    void drainRemainingPhotoPages(workId, paginationRequestId);
                }
            }
            if(faceSearchData?.photo_data){
                faceSearchData?.photo_data.map((e)=>{
                    if(e.work_id==workId){
                        setImages(e.data)
                    }
                })
            }
            setBookingPK(dataStore[workId].booking_pk);
            setYourUploads(dataStore[workId]?.photo_data?.flatMap((e) => e?.my_uploads))
            if(tab==videos && dataStore[workId].url_list){
                for(let i = dataStore[workId].url_list?.length; i>0; i--){
                    if(dataStore[workId].url_list[i-1].quality===defQuality){
                        setVideoUrl(dataStore[workId].url_list[i-1].url)
                    }
                }
            }
            selectedOption !== allPhotos && setFilteredData(true)
        }else{
            const form = new FormData();
            form.append("client_type", "mobile");
            if (shouldPaginatePhotos) {
                form.append("current_page", 0);
            }
            setLoading(true)
            if (shared_key) {
                form.append("key", shared_key);
            }
            var api_url;
            if(queryParams.get('tab')==albumSelection){
                api_url = `${process.env.REACT_APP_STAG_URL}/api/work/my/${workId}/`
            }else if(queryParams.get('tab')==userFolders){
                api_url = `${process.env.REACT_APP_STAG_URL}/api/work/folder/${workId}/user/`
            }else if(tab == blacklistReview){
                api_url = `${process.env.REACT_APP_STAG_URL}/api/work/blacklist/${workId}/`
            }else{
                api_url = `${process.env.REACT_APP_STAG_URL}/api/work/${workId}/`
            }
            setContentLoading(true)
            let paginationRequestId = photoPaginationRequestIdRef.current;
            const initialBatchKey = `${tab}-${workId}`;
            if (shouldPaginatePhotos) {
                if (activeInitialBatchKeyRef.current === initialBatchKey) {
                    return;
                }
                activeInitialBatchKeyRef.current = initialBatchKey;
                paginationRequestId = ++photoPaginationRequestIdRef.current;
                setHasMorePhotoPages(true);
                isFetchingPhotoPageRef.current = true;
                photoNextPageRef.current = CONST.PAGINATION_BATCH_SIZE;
                fetchedPageNumbersRef.current = new Set();
            } else {
                paginationRequestId = ++photoPaginationRequestIdRef.current;
            }
            try {
                var response;
                if(workId){
                    if (shouldPaginatePhotos) {
                        const firstPageResponse = await requestPhotoPage(workId, 0);
                        if (photoPaginationRequestIdRef.current !== paginationRequestId) {
                            // Superseded by a newer load. Release the guard, otherwise this
                            // tab+work can never start an initial batch again.
                            if (activeInitialBatchKeyRef.current === initialBatchKey) {
                                activeInitialBatchKeyRef.current = '';
                            }
                            return;
                        }
                        response = { data: firstPageResponse };
                    } else if(queryParams.get('tab')==albumSelection || queryParams.get('tab')==blacklistReview){
                        response = await axios.get(api_url, {
                            headers: {
                                Authorization: getAuthToken(),
                                "Content-Type": "multipart/form-data",
                            },
                        });
                    } else {
                        response = await axios.post(api_url, form, {
                            headers: {
                                Authorization: getAuthToken(),
                                "Content-Type": "multipart/form-data",
                            },
                        });
                    }
                }
                if (response?.data?.success == false && tab==guestUpload) {
                    setWorkIdError(true);
                    setWorkIdErrorMessage(response?.data?.message);
                    if (activeInitialBatchKeyRef.current === initialBatchKey) {
                        activeInitialBatchKeyRef.current = '';
                    }
                    return;
                }
                if(response && !response?.data?.success){
                    if(tab!=blacklistReview){
                        queryParams.delete('work_id')
                        navigate({ search: queryParams.toString()}, { replace: true });
                        window.location.reload();
                    }
                }

                if (tab === guestUpload) {
                    const uniqueBars = mergeUniqueFloatingBars(
                        response?.data?.bottom_float_bar || [],
                        floatingBars
                    );

                    setFloatingBars(uniqueBars);
                    setData(prev => ({
                        ...prev,
                        can_flag_pics: response?.data?.photo_data?.[0]?.['can_flag_pics'] || false,
                        bottom_float_bar: uniqueBars,
                    }));
                }

                dataStore[workId] = response?.data
                setCollectionData(dataStore)
                setCollection(response?.data);
                syncUserFolderFilterWorkIds(response?.data)
                if(queryParams.get('tab')==userFolders){
                    getTimeSortedData(response?.data)
                }
                setAlbumLocked(response?.data?.is_locked)
                setAlbumTitle(response?.data?.title)
                setCollectionFormattedData({})
                response?.data?.photo_data?.map((e) => {
                    setCollectionFormattedData((prevImages) => ({
                        ...prevImages,
                        [e.work_id]: e.data,
                    }));
                });
                let tempData = response?.data?.album_data?.album_data || {};
                setDefAlbumData(JSON.parse(JSON.stringify(tempData))); // Create a deep copy
                setAlbumData(tempData);
                setSingleAlbumData(response?.data?.album_data?.photo_id_map || {})
                response?.data?.photo_data?.forEach((e) => {
                    setHideSelectedObj((prevHideData) => ({
                      ...prevHideData,
                      [e.work_id]: e.private_data,
                    }));
                });
                response?.data?.photo_data?.forEach((e) => {
                    setSelectedImages((prevSelectedData) => ({
                      ...prevSelectedData,
                      [e.work_id]: e.private_data,
                    }));
                });
                setSelectImages((prev) => ({
                    ...prev,
                    [workId]: {
                        ...(prev[workId] || {}),
                        [workId]: []
                    }
                }));
                hideSelection && selectionMode('selectAll', hide);
                let tempImages = response?.data?.photo_data?.flatMap((e) => e.data) || [];
                let tempMyUploads = response?.data?.photo_data?.flatMap(e=>e?.my_uploads) || [];
                if(queryParams?.get('tab')!==albumSelection)(queryParams?.get('tab')==photos || queryParams?.get('tab')==guestUpload || queryParams?.get('tab')==blacklistReview) && setImages(allGuestPhotos ? tempImages : tempMyUploads);
                setYourUploads(tempMyUploads)
                if(location.hash.includes('#gallery') && !resetIndex){
                    setShareFaceFilter(false)
                    setShowGallery(true)
                    window.location.hash = location.hash
                    galleryHandler()
                }
                setBookingPK(response?.data?.booking_pk)
                if(queryParams.get('tab')==videos){
                    for(let i = response?.data?.url_list?.length; i>0; i--){
                        if(response?.data?.url_list[i-1].quality===defQuality){
                            setVideoUrl(response?.data?.url_list[i-1].url)
                        }
                    }
                }
                setContentLoading(false)
                setLoading(false)
                selectedOption !== allPhotos && setFilteredData(true)
                if(tab==userFolders && (response?.data?.private_photo_count==0 || response?.data?.public_photo_count==0)){
                    handleFilterCheckboxChange(allPhotos)
                }
                newCreatedFolder.current = false;
                if (shouldPaginatePhotos) {
                    totalPagesByWorkIdRef.current = {
                        ...(totalPagesByWorkIdRef.current || {}),
                        [workId]: getTotalPagesFromResponse(response?.data, workId),
                    };
                    fetchedPageNumbersRef.current.add(0);
                    photoNextPageRef.current = 1;
                    const maxPageIdx = getMaxPageIndex(workId);
                    setHasMorePhotoPages(maxPageIdx === null ? true : photoNextPageRef.current <= maxPageIdx);
                    if (activeInitialBatchKeyRef.current === initialBatchKey) {
                        activeInitialBatchKeyRef.current = '';
                    }
                    isFetchingPhotoPageRef.current = false;
                    if (hasMorePhotoPagesRef.current) {
                        void drainRemainingPhotoPages(workId, paginationRequestId);
                    }
                }
            } catch (error) {
                setContentLoading(false)
                setLoading(false)
                if (activeInitialBatchKeyRef.current === initialBatchKey) {
                    activeInitialBatchKeyRef.current = '';
                }
                catchError(error)
                // While the axios guard has this URL blocked every request rejects instantly, so
                // re-opening the tab would retry in a loop that never yields and freezes the page.
                // The effect on `blocked` reloads it when the lockout ends.
                if (error?.blocked) {
                    blockedGalleryLoadRef.current = workId
                    return
                }
                if(tab){
                    handleTabClick(tab)
                }else{
                    handleTabClick(photos)
                }
            }
        }
        tab==guestUpload && !allGuestPhotos && guestUploadTab()
        tab!==videos && tab!==albums && getToTop()
    }
    
    useEffect(()=>{
        if(recallCollection){
            const unique = queryParams.get('work_id')
            const currTab = queryParams.get('tab')
            if(!data){
                getBookingData()
            }
            // handleTabClick() reloads prevCollection and pushes junk history; only needed with no work_id.
            if(isValidId(unique) && !faceSearchOn && currTab !== past_face_searches){
                handleCollections(unique)
            }else{
                handleTabClick(currTab)
                handleCollections(unique)
            }
        }
    },[recallCollection])

    useEffect(()=>{
        if(readyFaceSearchDownload || deleteConfirm){
            updateSelectedPhotos()
            setReadyFaceSearchDownload(false)
        }
    },[readyFaceSearchDownload, deleteConfirm])

    const handleOrientationChange = () => {
        setCurrentDimensions(window.innerWidth)
        const container = storyRef.current;
        const pastContainer = scrollContainerRef.current
        if(container?.clientWidth < container?.scrollWidth){
            if (window.innerWidth >= 1200) {
                if (container) {
                    const containerWidth = container.offsetWidth;
                    const pillWidth = 220 + 30;
                    const remainingSpace = containerWidth % pillWidth;
                    const pillsNum = containerWidth / pillWidth;
                    const visiblePillMargin = remainingSpace / 2;
                    var margin = Math.floor(visiblePillMargin/(pillsNum*2))
                    setPillMargin(10+margin)
                }
            }else if(window.innerWidth < 1200 && window.innerWidth >= 900){
                if (container) {
                    const containerWidth = container.offsetWidth;
                    const pillWidth = 100 + 74;
                    const remainingSpace = containerWidth % pillWidth;
                    const pillsNum = containerWidth / pillWidth;
                    var margin = Math.floor(remainingSpace/(pillsNum*2))
                    setPillMargin(18+margin)
                }
            }else if(window.innerWidth < 900 && window.innerWidth >= 600){
                if (container) {
                    const containerWidth = container.offsetWidth;
                    const pillWidth = 100 + 47;
                    const remainingSpace = containerWidth % pillWidth;
                    const pillsNum = containerWidth / pillWidth;
                    var margin = Math.floor(remainingSpace/(pillsNum*2))
                    setPillMargin(17+margin)
                }
            }else if(window.innerWidth < 600){
                if (container) {
                    const containerWidth = container.offsetWidth;
                    const pillWidth = 75 + 30;
                    const remainingSpace = containerWidth % pillWidth;
                    const pillsNum = containerWidth / pillWidth;
                    var margin = Math.floor(remainingSpace/(pillsNum*2))
                    setPillMargin(9+margin)
                }
            }
        }
        if(pastContainer?.clientWidth < pastContainer?.scrollWidth){
            if(window.innerWidth >= 600){
                if (pastContainer) {
                    const containerWidth = pastContainer.offsetWidth;
                    const pillWidth = 100 + 30;
                    const remainingSpace = containerWidth % pillWidth;
                    const pillsNum = containerWidth / pillWidth;
                    var margin = Math.floor(remainingSpace/(pillsNum*2))
                    setPastMargin(10+margin)
                }
            }else{
                if (pastContainer) {
                    const containerWidth = pastContainer.offsetWidth;
                    const pillWidth = 80 + 20;
                    const remainingSpace = containerWidth % pillWidth;
                    const pillsNum = containerWidth / pillWidth;
                    var margin = Math.floor(remainingSpace/(pillsNum*2))
                    setPastMargin(5+margin)
                }
            }
        }
    };

    const getTimeSortedData = (data) => {
        const mergedData = {
            work_id: queryParams.get('work_id'),
            data: data?.photo_data?.flatMap(obj => [...obj.data])?.sort((a, b) => b.epoch_time - a.epoch_time) || [],
            private_data : data?.photo_data?.flatMap(obj => [...obj.private_data])?.sort((a, b) => b.epoch_time - a.epoch_time) || []
        };
        // data already holds the hidden photos too; add private_data only for any it lacks.
        setImages(mergeUniqueByPhotoId(mergedData.data, mergedData.private_data));
        setUserFolderData([mergedData])
    }

    const getSelectionSortedData = () => {
        const data = userFolderData || [];
        const selectedWorkIds = printSelectedData?.work_id_list || [];

        const allPhotos = data.flatMap(item => item.data || []);
        const allPrivatePhotos = data.flatMap(item => item.private_data || []);

        const uniquePhotos = Array.from(
            new Map(allPhotos.map(photo => [photo.photo_id, photo])).values()
        );

        const uniquePrivatePhotos = Array.from(
            new Map(allPrivatePhotos.map(photo => [photo.photo_id, photo])).values()
        );

        const selected = [];
        const rest = [];
        const selectedPrivate = [];
        const restPrivate = [];

        for (const photo of uniquePhotos) {
            const workId = get_selected_workId(collectionFormattedData, photo?.photo_id);
            if (selectedWorkIds.includes(workId)) {
            selected.push(photo);
            } else {
            rest.push(photo);
            }
        }

        for (const photo of uniquePrivatePhotos) {
            const workId = get_selected_workId(collectionFormattedData, photo?.photo_id);
            if (selectedWorkIds.includes(workId)) {
            selectedPrivate.push(photo);
            } else {
            restPrivate.push(photo);
            }
        }

        setImages([...selected, ...rest]);

        setUserFolderData([
            {
            work_id: queryParams.get('work_id'),
            data: [...selected, ...rest],
            private_data: [...selectedPrivate, ...restPrivate],
            },
        ]);
    };



    const getLibraryData = (getFavourites, recall=true) => {
        var api_url = `${process.env.REACT_APP_STAG_URL}/api/work/folder/user/`
        let paramsData = getFavourites ? {'get_favourites': 1} : {'get_favourites': 0}
        if(tab==userFolders || addToSelection){
            setUpdateLoader(true)
        }
        axios({
            url: api_url,
            method: "get",
            params: paramsData,
                headers: {
                Authorization: getAuthToken(),
            },
        })
        .then((response) => {
            if(getFavourites){
                const updatedResponse = {
                    ...response.data,
                    data: {
                        ...response.data.data,
                        folders: response.data.data.folders?.slice(1) || []
                    }
                };
                setLibraryData(updatedResponse);
            }else{
                setLibraryData(response?.data)
            }
            setUpdateLoader(false)
            if(getFavourites && newCreatedFolder.current){
                queryParams.delete('work_id')
                navigate({ search: queryParams.toString()});
            }
            if(!showGallery && !isAddToOpen && tab==userFolders){
                getFavourites && setData(response?.data);
                setCollectionData()
                setCollection()
                recall && setRecallCollection(true)
            }
            })
            .catch((error) => {
                catchError(error)
        });
    }

    const filterWorkIdData = (data) => {
        return Object.fromEntries(
            Object.entries(data).filter(([key]) => filterWorkId.includes(String(key)))
        );
    }

    useEffect(() => {
        window.addEventListener('resize', handleOrientationChange);
    
        return () => {
          window.removeEventListener('resize', handleOrientationChange);
        };
    }, []);

    useEffect(()=>{
        handleOrientationChange()
    },[showArrow])

    useEffect(()=>{
            hideSelection && selectionMode('selectAll', hide)
            downloadSelection && selectionMode('selectAll', download)
            downloadSelection && selectionMode('selectAll', deleteUploads)
            addToSelection && selectionMode('selectAll', addTo)
    }, [collectionFormattedData])

    useEffect(()=>{
        if(photoScroll==0 && divRef.current && tab==photos && !contentLoading){  //it gets height of div from the top
            setDistanceFromTop(divRef.current.offsetTop+divRef.current.offsetHeight);
        }
    },[photoScroll, contentLoading]);

    useEffect(()=>{
        photoCountRef.current = Number(collection?.photo_count || 0)
    },[collection])

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const faceSearchEnabled = searchParams.get('face-search');
        if (faceSearchEnabled === 'true') {
          setFaceSearchState(true)
        }else {
            setFaceSearchState(false)
            faceFilterRequestRef.current = false;
        }
        // The face-search view is state-only; drop it whenever the URL is not a face-search URL.
        if (!isFaceSearchUrl()) {
            const wasFaceSearch = faceSearchOn || pastFaceSearchesOn;
            loadedFaceIdRef.current = null;
            setFaceSearchOn(false)
            setPastFaceSearchesOn(false)
            // faceSearchData stays: the page renders behind (data || faceSearchData) and data may be unloaded.
            // `images` still holds the face-search results though, so reload the collection the URL
            // points at - otherwise the grid keeps showing matched photos under the collection's name.
            if (wasFaceSearch) {
                const wid = searchParams.get('work_id');
                if (isValidId(wid)) handleCollections(wid)
            }
        }
    }, [location.search]);

    useEffect(()=>{
        if(data){
            if(tab==videos && data.data?.['video']){
                const videoList = data.data['video']
                const idx = videoList.findIndex(e => e.work_id == collection_id)
                setNextVideo(idx !== -1 && idx < videoList.length - 1)
            }else{
                setNextVideo(false)
            }
            const selected_data = getSelectedData(data, tab)
            selected_data?.forEach((e,index)=>{
                if(e.work_id == collection_id){
                    selected_data?.[index+1] ? setNextCollectionName(selected_data?.[index+1].title) : setNextCollectionName(null)
                    selected_data?.[index-1] ? setPrevCollectionName(selected_data?.[index-1].title) : setPrevCollectionName(null)
                }
            })
        }
        if(!collection?.user_agreement){
            const tncDiv = document.getElementsByClassName('tnCText')[0]
            if(tncDiv){
                tncDiv.innerHTML = collection?.tnc
            }
        }
    },[collection])

    useEffect(()=>{
        const fetchSelfieUpload = async () => {
            if(queryParams.get('for_selfie') != 'true' || !faceSearchData){
                return;
            }
            if (selfieFetchedRef.current) {
                return;
            }
            selfieFetchedRef.current = true;
            try{
                const response = await axios.get(`${process.env.REACT_APP_STAG_URL}/api/booking/selfie-upload/get/${faceSearchData?.booking_pk || id}/`, {
                    headers: {
                        Authorization: getAuthToken(),
                    },
                });
                setUploadedSelfie(response.data.selfie_url);
            }catch(error){
                console.error(error);
            }
        };
        fetchSelfieUpload();
    },[faceSearchData])

    useEffect(()=>{
        if(faceSearchOnly){
            faceFilterPhoto()
        }
    },[])

    useEffect(() => {
        if (window.location.hash.includes("#gallery")) {
            setShowGallery(true);
        }else{
            setShowGallery(false);
            // Leaving full screen dismisses any popup shown over it, and keeps us on the collection
            // we were viewing rather than the one the back landed on. Done here rather than in the
            // popstate listener: react-router's own listener runs first and re-registers ours
            // mid-dispatch, so it can be detached before the event reaches it.
            // the full-screen "Hide this Photo?" prompt is a raw DOM toggle, not react state
            const hideDiv = document.getElementById('hidePopupDiv');
            const hidePromptOpen = !!hideDiv && hideDiv.style.display === 'flex';
            if (galleryNextCollectionPopup || deletePopup || flagPhotoPopup || isSingleAddToOpen || likeViewPopup || hidePromptOpen) {
                if (hideDiv) hideDiv.style.display = 'none'
                setGalleryNextCollectionPopup(false)
                setDeletePopup(false)
                setFlagPhotoPopup(false)
                setIsSingleAddToOpen(false)
                setLikeViewPopup(false)
                // the Add-to modal turns on selection mode; closing it from here must undo that too,
                // exactly as its own close/Done buttons do
                setAddToSelection(false)
                setPrintSelection(false)
            }
            const p = new URLSearchParams(window.location.search);
            const stayOn = galleryWorkIdRef.current;
            // cleared either way, so a later grid-to-grid back is never pulled back here
            galleryWorkIdRef.current = null;
            if (isValidId(stayOn) && String(stayOn) !== p.get('work_id')) {
                p.set('work_id', stayOn)
                // navigate(), not history.replaceState: the recall below reads work_id off the
                // router's location, which a raw replaceState would leave stale
                navigate({ search: p.toString() }, { replace: true })
                // load it directly: recallCollection may already be true from the back, in which
                // case setting it again is a no-op and the recall would use the old work_id
                handleCollections(stayOn)
            }
            const bodyDiv = document.getElementsByClassName('my-masonry-grid');
            if(bodyDiv.length>0){
                Array.from(bodyDiv).forEach((e)=>{
                    e.style.display = 'flex'
                })
            }
        }
    }, [location]);

    useEffect(()=>{
        if(filteredData){
            getFilteredData(selectedOption)
            setFilteredData(false)
        }
    },[filteredData])

    // 'blocked' when the axios guard has shut the URL, 'offline' when there's no connection;
    // each gets its own toast text.
    const markPageLoadFailed = (blocked = false) => {
        setPageLoadFailed(blocked ? 'blocked' : (navigator.onLine === false ? 'offline' : true))
    }

    // Shared by both drains: back off before another try, or give up and offer Retry once the
    // limit is hit. Resolves false when the drain should stop.
    // blocked: the axios guard has shut this URL for a minute, so any further try only fails.
    const waitBeforePageRetry = async (failedAttempts, blocked) => {
        // Offline, a retry can only fail and add to the guard's count; the online listener resumes.
        if (blocked || failedAttempts > CONST.PAGE_RETRY_LIMIT || navigator.onLine === false) {
            markPageLoadFailed(blocked)
            return false
        }
        await new Promise((resolve) => setTimeout(resolve, CONST.PAGE_RETRY_DELAY_MS * failedAttempts))
        return true
    }

    const getFailureKind = (results) => (results.some((r) => r.status === 'rejected' && r.reason?.blocked) ? 'blocked' : false)

    // Resumes the stopped drain from its first missing page, under the current request id.
    const retryFailedPages = () => {
        // Sending while offline only fails, and enough failures trip the axios guard's 60s lockout.
        if (navigator.onLine === false) {
            setPageLoadFailed('offline')
            return
        }
        setPageLoadFailed(false)
        if (faceSearchOn) {
            void drainRemainingPastFacePages(pastFaceActiveFaceIdRef.current, pastFacePaginationRequestIdRef.current, true)
        } else {
            void drainRemainingPhotoPages(collection_id, photoPaginationRequestIdRef.current, true)
        }
    }

    // The lockout screen has gone: load the gallery it stopped, if the user is still on it.
    const handleCollectionsRef = useRef(handleCollections)
    handleCollectionsRef.current = handleCollections
    useEffect(() => {
        if (blocked || !blockedGalleryLoadRef.current) return
        const workId = blockedGalleryLoadRef.current
        blockedGalleryLoadRef.current = null
        if (isStillOnWorkId(workId)) handleCollectionsRef.current(workId)
    }, [blocked])

    // Back online: pick up the missing pages without waiting for a Retry tap.
    const retryFailedPagesRef = useRef(retryFailedPages)
    retryFailedPagesRef.current = retryFailedPages

    // Lockout over: resume a drain the guard stopped, as the blocked toast promises.
    useEffect(() => {
        if (!blocked && pageLoadFailedRef.current === 'blocked') retryFailedPagesRef.current()
    }, [blocked])
    useEffect(() => {
        if (!pageLoadFailed) return
        const handleOnline = () => retryFailedPagesRef.current()
        window.addEventListener('online', handleOnline)
        return () => window.removeEventListener('online', handleOnline)
    }, [pageLoadFailed])

    const loadNextPhotoPage = async () => {
        if (!hasMorePhotoPagesRef.current || isFetchingPhotoPageRef.current) return;
        // After a failure only Retry fetches again, so scrolling can't push the URL into the guard's block.
        if (pageLoadFailedRef.current) return;
        if (!collection_id) return;

        const nextPage = photoNextPageRef.current;
        if (nextPage === null || nextPage === undefined) return;

        const localReqId = photoPaginationRequestIdRef.current;
        isFetchingPhotoPageRef.current = true;
        setIsPhotoPageLoading(true);
        try {
            const batchPages = buildPageBatch(nextPage, collection_id, CONST.PAGINATION_BATCH_SIZE);
            if (batchPages.length === 0) {
                setHasMorePhotoPages(false);
                return;
            }
            const result = await fetchAndAppendPageBatch(collection_id, batchPages, localReqId);
            if (result !== true && result !== undefined) markPageLoadFailed(result === 'blocked');
        } catch (e) {
            catchError(e)
        } finally {
            if (photoPaginationRequestIdRef.current === localReqId) {
                setIsPhotoPageLoading(false);
                isFetchingPhotoPageRef.current = false;
                setHasMorePhotoPagesState(hasMorePhotoPagesRef.current);
            }
        }
    }

    useEffect(()=>{
        if(!showGallery) return;
        if(faceSearchOn) return;
        if(selectedOption !== allPhotos) return;
        if(!(tab === photos || tab === guestUpload)) return;
        if(!photoIndex || photoIndex < 1) return;
        if(!hasMorePhotoPagesRef.current) return;
        if(isFetchingPhotoPageRef.current) return;

        const loadedCount = galleryImages?.length || 0;
        if(photoIndex >= loadedCount - 2){
            loadNextPhotoPage();
        }
    },[showGallery, faceSearchOn, selectedOption, tab, photoIndex, galleryImages])

    const requestPastFaceSearchPage = async (faceId, pageNumber) => {
        const form = new FormData();
        form.append("id", faceId);
        if (shared_key) {
            form.append("key", shared_key);
        }
        form.append("current_page", pageNumber);

        const apiUrl = getAPIUrl('/api/face/search/results/photos/');
        const response = await axios.post(apiUrl, form, {
            headers: {
                Authorization: getAuthToken(),
            },
            timeout: CONST.PAGE_REQUEST_TIMEOUT_MS,
        });
        return response?.data;
    }

    const getMaxPastFacePageIndex = () => {
        const totalPages = Number(pastFaceTotalPagesRef.current || 0)
        if (totalPages <= 0) return null
        return totalPages - 1
    }

    const buildPastFacePageBatch = (startPage, batchSize = CONST.PAGINATION_BATCH_SIZE) => {
        const maxPageIndex = getMaxPastFacePageIndex()
        const pages = []
        for (let page = startPage; page < startPage + batchSize; page++) {
            if (maxPageIndex !== null && page > maxPageIndex) break
            if (!pastFaceFetchedPageNumbersRef.current.has(page)) {
                pages.push(page)
            }
        }
        return pages
    }

    const fetchAndAppendPastFaceBatch = async (faceId, pagesToFetch, expectedReqId) => {
        if (!Array.isArray(pagesToFetch) || pagesToFetch.length === 0) return
        if (pastFacePaginationRequestIdRef.current !== expectedReqId || !isStillOnWorkId(faceId)) return

        const results = await Promise.allSettled(
            pagesToFetch.map((pageNum) => requestPastFaceSearchPage(faceId, pageNum))
        )

        if (pastFacePaginationRequestIdRef.current !== expectedReqId || !isStillOnWorkId(faceId)) return true

        // Same as the photo drain: keep pages up to the first failure, retry from there.
        const firstFailed = results.findIndex((r) => r.status !== 'fulfilled')
        const loadedCount = firstFailed === -1 ? results.length : firstFailed
        const responses = results.slice(0, loadedCount).map((r) => r.value)
        responses.forEach((pageResponseData) => {
            appendPastFaceSearchResultPage(pageResponseData)
        })

        pagesToFetch.slice(0, loadedCount).forEach((pageNum) => pastFaceFetchedPageNumbersRef.current.add(pageNum))

        if (firstFailed !== -1) {
            pastFaceNextPageRef.current = pagesToFetch[firstFailed]
            return getFailureKind(results)
        }

        const lastFetchedPage = pagesToFetch[pagesToFetch.length - 1]
        pastFaceNextPageRef.current = lastFetchedPage + 1

        const maxPageIndex = getMaxPastFacePageIndex()
        if (maxPageIndex !== null) {
            hasMorePastFacePagesRef.current = pastFaceNextPageRef.current <= maxPageIndex
            return true
        }

        const lastResp = responses[responses.length - 1]
        const entries = Array.isArray(lastResp?.photo_data) ? lastResp.photo_data : []
        const firstEntryWithMeta = entries?.find((e) => e?.total_pages !== undefined && e?.total_pages !== null) || entries?.[0]
        const nextFromApi = firstEntryWithMeta?.next_page
        hasMorePastFacePagesRef.current = !(
            nextFromApi === '' || nextFromApi === null || nextFromApi === undefined
        )
        return true
    }

    const drainRemainingPastFacePages = async (faceId, expectedReqId, resume = false) => {
        if (!faceId) return
        if (isFetchingPastFacePageRef.current) return
        isFetchingPastFacePageRef.current = true
        setIsPhotoPageLoading(true)
        try {
            let failedAttempts = 0
            // After a failure, probe with one page: a whole failed batch counts 3 toward the axios
            // guard's 5-failures block, and every photo page shares one URL.
            let singlePage = resume
            while (
                pastFacePaginationRequestIdRef.current === expectedReqId &&
                hasMorePastFacePagesRef.current &&
                isStillOnWorkId(faceId)
            ) {
                const nextPage = pastFaceNextPageRef.current
                if (nextPage === null || nextPage === undefined) break

                const batchPages = buildPastFacePageBatch(nextPage, singlePage ? 1 : CONST.PAGINATION_BATCH_SIZE)
                if (batchPages.length === 0) {
                    hasMorePastFacePagesRef.current = false
                    break
                }

                const result = await fetchAndAppendPastFaceBatch(faceId, batchPages, expectedReqId)
                if (result === true) {
                    failedAttempts = 0
                    singlePage = false
                    continue
                }
                failedAttempts += 1
                singlePage = true
                if (!(await waitBeforePageRetry(failedAttempts, result === 'blocked'))) break
            }
        } catch (e) {
            catchError(e)
        } finally {
            if (pastFacePaginationRequestIdRef.current === expectedReqId) {
                setIsPhotoPageLoading(false)
                isFetchingPastFacePageRef.current = false
            }
        }
    }

    useEffect(()=>{
        if(!collection || faceSearchOn) return;
        const handleScroll = () => {
            const position = window.scrollY;
            setScrollPosition(position);
            if(tab === photos)setPhotoScroll(position)
            if (position > prevScrollPosition && scrollPosition > 200) {
                setShowFilters(false)
            } else {
                setShowFilters(true)
            }
            setPrevScrollPosition(position);
            const nearBottom = window.innerHeight + document.documentElement.scrollTop + 200 > document.documentElement.offsetHeight;
            if (
                nearBottom &&
                (selectedOption == allPhotos || selectedOption == privatePhotos || selectedOption == publicPhotos) &&
                (tab == photos || tab == guestUpload) &&
                hasMorePhotoPagesRef.current &&
                !isFetchingPhotoPageRef.current
            ) {
                setNextCollection(false);
                loadNextPhotoPage();
            }
            if(selectedOption !== allPhotos || tab!==guestUpload){
                setNextCollection(true)
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    },[collection, faceSearchOn, prevScrollPosition, tab, selectedOption, allGuestPhotos])

    const leftDiv = document.getElementById('storyNav')
    useEffect(()=>{
        if(leftDiv){
            if(leftDiv.scrollWidth > leftDiv.clientWidth){
                setShowArrow(true)
            }else{
                setShowArrow(false)
            }
        }else{
            setShowArrow(false)
        }
    // Re-measure when the pills change, not just when the element is replaced: navigating
    // between tabs reuses the same #storyNav node, so a leftDiv-only dep kept a stale value.
    },[leftDiv, data, tab, currentDimensions, contentLoading, pastFaceSearches, pastFaceSearchesOn])

    useEffect(()=>{
        if(downloadSelection){
            document.getElementById('hideDiv').innerText = 'Download'
        }else if(hideSelection){
            document.getElementById('hideDiv').innerText = 'Update'
        }else if(deleteSelection){
            document.getElementById('hideDiv').innerText = 'Delete'
        }else if(approveFlagSelection){
            document.getElementById('hideDiv').innerText = 'Approve'
        }
        if(!selection){
            (tab==photos || tab==guestUpload || tab==blacklistReview) && fetchImages()
        }
    },[selection])

    useEffect(() => {
        const body = document.getElementsByTagName('body')[0];
        if (shareSelective || showGallery || videoView || albumView || isAddToOpen || showMenuSidebar || filterDropdown) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = 'auto';
        }
    
        return () => {
            body.style.overflow = 'auto';
        };
    }, [shareSelective, showGallery, galleryImages, videoView, albumView, isAddToOpen, showMenuSidebar, filterDropdown]);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer && scrollContainer.scrollWidth > scrollContainer.clientWidth) {
            setIsScrollable(true);
        } else {
            setIsScrollable(false);
        }
    }, [loading, pastFaceSearches]);

    const scrollLeft = () => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.scrollLeft -= 100;
        }
    };

    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollLeft += 100;
        }
    };

    const scrollStory = (direction) =>{
        if(direction=='left'){
            leftDiv.scrollLeft = leftDiv.scrollLeft - 0.20*leftDiv.scrollWidth
        }else if(direction=='right'){
            leftDiv.scrollLeft = leftDiv.scrollLeft + 0.20*leftDiv.scrollWidth
        }
    }


    const toggleSelection = () => {
        var selectionType;
        if(hideSelection)selectionType=hide
        if(downloadSelection)selectionType=download
        if(deleteSelection)selectionType=deleteUploads
        if(approveFlagSelection)selectionType=approvePhoto
        if(addToSelection)selectionType=addTo
        setSelectionAll((prevState) => ({
            ...prevState,
            [collection_id]: !selectionAll[collection_id]
        }));
        if(!selectionAll[collection_id]){
            if(hideSelection){
                if(faceSearchOn){
                    selectedOption == publicPhotos ? setFaceSelect(faceFormattedData) : setFaceSelect(returnFilteredData())
                }else{
                    selectedOption == publicPhotos ? setSelectedImages((prevSelectedImages) => ({
                        ...prevSelectedImages,
                        ...Object.keys(collectionFormattedData).reduce((acc, key) => {
                          acc[key] = [
                            ...(prevSelectedImages[key] || []),
                            ...collectionFormattedData[key].filter(
                              (newItem) =>
                                !newItem?.processing &&
                                !(prevSelectedImages[key] || []).some(
                                  (existingItem) => existingItem.photo_id === newItem.photo_id
                                )
                            ),
                          ];
                          return acc;
                        }, {}),
                      })) : setSelectedImages((prevSelectedImages) => ({
                        ...prevSelectedImages, 
                        ...Object.keys(returnFilteredData()).reduce((acc, key) => {
                          acc[key] = [
                            ...(prevSelectedImages[key] || []),
                            ...returnFilteredData()[key].filter(
                              (newItem) =>
                                !newItem?.processing &&
                                !(prevSelectedImages[key] || []).some(
                                  (existingItem) => existingItem.photo_id === newItem.photo_id
                                )
                            ),
                          ];
                          return acc;
                        }, {}),
                      }))
                }
            }
            
            if(downloadSelection || addToSelection || deleteSelection || approveFlagSelection){
                var result = (addToSelection || downloadSelection) ? (faceSearchOn ? faceSearchData : collection)?.photo_data.reduce((acc, item) => {
                    if (addToSelection && (item.can_add_to || item.is_album_required)) {
                        if(printSelection){
                            if(printSelectedData?.work_id_list?.includes(item.work_id)){
                                acc[item.work_id] = item?.data;
                            }
                        }else{
                            acc[item.work_id] = item?.data;
                        }
                    }
                    if(downloadSelection && item.is_downloadable){
                        acc[item.work_id] = item?.data;
                    }
                    return acc
                }, {}) : returnFilteredData()
                if(filterWorkId.length > 0){
                    result = filterWorkIdData(result)
                }
                setSelectImages((prevState) => {
                    const updatedState = { ...prevState };
                    const finalResult = {[collection_id]: result}
                    Object.keys(finalResult).forEach((collectionId) => {
                        const works = finalResult[collectionId];
                        if (!updatedState[collectionId]) {
                            updatedState[collectionId] = {};
                        }

                        Object.keys(works).forEach((workId) => {
                            const newItems = works[workId];
                            const existingItems = updatedState[collectionId][workId] || [];

                            const existingIds = new Set(existingItems.map((item) => item.photo_id));

                            let filteredItems = newItems.filter((item) => !existingIds.has(item.photo_id));

                            if (deleteSelection) {
                            filteredItems = filteredItems.filter((item) => item.can_delete !== false);
                            }

                            updatedState[collectionId][workId] = [...existingItems, ...filteredItems];
                        });
                    });

                    return updatedState;
                });

            }
            selectionMode(true, selectionType)
        }else{
            !faceSearchOn && !downloadSelection && !addToSelection && !deleteSelection && !approveFlagSelection && setSelectedImages((prevState) => {
                const newState = Object.keys(prevState).reduce((acc, key) => {
                  acc[key] = Object.keys(collectionFormattedData).includes(key)
                    ? (selectedOption==publicPhotos && hideSelection ? hideSelectedObj[key] : [])
                    : prevState[key];
                    return acc;
                }, {});
                return newState;
            });
            (downloadSelection || addToSelection || deleteSelection || approveFlagSelection) && setSelectImages((prevState) => {
                const newState = JSON.parse(JSON.stringify(prevState));
                const formattedData = faceSearchOn ? faceFormattedData : collectionFormattedData;

                Object.keys(prevState).forEach((collectionId) => {
                    if (collectionId === collection_id) {
                        const inner = prevState[collectionId];

                        Object.keys(inner).forEach((workId) => {
                            const shouldClear = Object.keys(formattedData).includes(workId);

                            if (shouldClear) {
                                const photoIdsToClear = inner[workId]?.map(p => p.photo_id) || [];
                                
                                newState[collectionId][workId] = [];

                                Object.keys(prevState).forEach((otherCollectionId) => {
                                    if (otherCollectionId !== collectionId) {
                                        const otherInner = newState[otherCollectionId];
                                        if (otherInner?.[workId]) {
                                            newState[otherCollectionId][workId] = otherInner[workId].filter(
                                                item => !photoIdsToClear.includes(item.photo_id)
                                            );
                                        }
                                    }
                                });
                            }
                        });
                    }
                });

                return newState;
            });

            faceSearchOn && setFaceSelect(prevState => {
                const newState = Object.keys(prevState).reduce((acc, key) => {
                  acc[key] = (selectedOption==publicPhotos && hideSelection ? faceHide[key] : []);;
                  return acc;
                }, {});
                return newState;
              });
            selectionMode(false, selectionType)
        }
    }

    const cancelMediaHide = () => {
        firstCheckMedia.current = false
        document.getElementById('mediaHidePopup').style.display='none'
    }

    const handleHideMedia = async (work_id, isHidden) => {
        firstCheckMedia.current = false
        document.getElementById('mediaHidePopup').style.display='none'
        hideSelected(work_id, isHidden)
    }

    const indirectUpload = () => {
        const targetUpload = document.getElementsByClassName('uploadButton')[0]
        if(targetUpload){
            targetUpload.click()
        }
    }


    const handleTrashRestore = (folderIds) => {
        if(isAdmin()){
            return;
        }

        if (folderIds && folderIds.length > 0) {
            const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/folder/trash/restore/`;
            const authToken = getAuthToken();
            const headers = {
                Authorization: authToken,
                "Content-Type": "application/json",
            };

            axios.put(apiUrl, { folder_ids: folderIds }, { headers })
                .then((res) => {
                    if (res?.data?.success) {
                        getTrashFolders();
                        setShowToast(true);
                        setToastMessage(res?.data?.toast_data);
                    } else {
                        catchError(res?.data?.error || 'Something went wrong');
                    }
                })
                .catch((error) => {
                    console.error('Error restoring the folders:', error);
                });
        }
    };


    const handleTrashDelete = (folderIds) => {
        if(isAdmin()){
            return;
        }

        if (folderIds && folderIds.length > 0) {
            const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/folder/delete/`;
            const authToken = getAuthToken();
            const headers = {
                Authorization: authToken,
                "Content-Type": "application/json",
            };

            axios.put(apiUrl, { folder_ids: folderIds }, { headers })
                .then((res) => {
                    if (res?.data?.success) {
                        getTrashFolders();
                        setShowToast(true);
                        setToastMessage(res?.data?.toast_data);
                    } else {
                        catchError(res?.data?.error || 'Something went wrong');
                    }
                })
                .catch((error) => {
                    console.error('Error deleting the folders:', error);
                });
        }
    };


    const getLikesData = (initial=false) => {    // initial is used to call this function on first mount and when selection type is likePhotos or viewPhotos
        if(selectionType==likePhotos || selectionType==viewPhotos || initial){
            const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/photo/likes/`;
            // Face results arrive via a full reload where `data` is unset, so use the face payload's list.
            const likesSource = (faceSearchOn || pastFaceSearchesOn) ? (faceSearchData || data) : data;
            const workIdLst = likesSource?.work_id_lst;
            const params = { work_id_lst: JSON.stringify(workIdLst) };
            if(shared_key){
                params['shared_key'] = shared_key
            }
            if(!workIdLst || workIdLst.length==0){
                return;
            }
            const authToken = getAuthToken();
            const headers = {
                Authorization: authToken,
                "Content-Type": "application/json",
            };
            axios
            .get(apiUrl, { params, headers })
            .then((response) => {
                setLikeData(response.data.data);
                if(showGallery && photoIndex){
                    setCurrentPhotoLiked(get_user_liked_photos(response.data.data, galleryImages[photoIndex-1]?.photo_id))
                }
            })
            .catch((error) => {
                console.error('Error fetching likes data:', error);
                setUpdateLoader(false);
            });

        }
    }

    const getFlaggedData = () => {
        const flaggedApiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/images/flagged/`;
        const params = { work_id_lst: JSON.stringify(data?.work_id_lst) };
        if(!data?.work_id_lst || data?.work_id_lst.length==0){
            return;
        }
        const authToken = getAuthToken();
        const headers = {
            Authorization: authToken,
            "Content-Type": "application/json",
        };

        if(tab == guestUpload){
            axios
            .get(flaggedApiUrl, { params, headers })
            .then((response) => {
                setFlaggedData(response?.data?.data?.["flagged_photo_ids"]);
                if(showGallery){
                    setCurrentPhotoFlagged(isCurrentPhotoFlagged(response?.data?.data?.["flagged_photo_ids"], galleryImages[photoIndex-1]?.photo_id));
                }
            })
            .catch((error) => {
            });
        }   
    }

    const returnFilteredData = () => {
        if(faceSearchOn){
            switch (selectedOption) {
                case allPhotos:
                    return faceFormattedData
                case privatePhotos:
                    return faceHide
                case publicPhotos:
                    return Object.fromEntries(
                        Object.entries(faceFormattedData).map(([key, dataArray]) => [
                          key,
                          dataArray.filter(
                            (item) => !faceHide[key]?.some((privateItem) => privateItem.photo_id === item.photo_id)
                          ),
                        ])
                    )
            }
        }else{
            const refrenceObj = new Set(yourUploads?.map(item => item?.photo_id));
            const filteredArray = hideSelectedObj[collection_id]?.filter(item => refrenceObj.has(item.photo_id));
            const filteredYourUploads = yourUploads?.filter(item => !item?.processing);
            switch (selectedOption) {
                case allPhotos:
                    return (allGuestPhotos ? collectionFormattedData : {[collection_id]: filteredYourUploads})
                case privatePhotos:
                    return Object.keys(collectionFormattedData).reduce((acc, key) => {
                        if (hideSelectedObj[key]) {
                          acc[key] = allGuestPhotos ? hideSelectedObj[key] : filteredArray;
                        }
                        return acc;
                      }, {}) 
                case publicPhotos:
                    return Object.fromEntries(
                        Object.entries(allGuestPhotos ? collectionFormattedData : {[collection_id]: filteredYourUploads}).map(([key, dataArray]) => [
                          key,
                          dataArray.filter(
                            (item) => !(allGuestPhotos ? hideSelectedObj[key] : filteredArray)?.some((privateItem) => privateItem.photo_id === item.photo_id)
                          ),
                        ])
                    )
            }
        }
    }
    
    const cropImage = (imageUrl, boundingBox, index) => {
        const originalCanvas = document.createElement('canvas');
    
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.src = imageUrl;
    
        image.onload = function () {
          const ctx = originalCanvas.getContext('2d');
          originalCanvas.width = image.width;
          originalCanvas.height = image.height;
    
          ctx.drawImage(image, 0, 0, image.width, image.height);
    
          const cropX = boundingBox.Left * image.width;
          const cropY = boundingBox.Top * image.height;
          const cropWidth = boundingBox.Width * image.width;
          const cropHeight = boundingBox.Height * image.height;
    
          const croppedCanvas = document.createElement('canvas');
          croppedCanvas.width = cropWidth;
          croppedCanvas.height = cropHeight;
          const croppedCtx = croppedCanvas.getContext('2d');
    
          croppedCtx.drawImage(originalCanvas, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
    
          const croppedImageDataUrl = croppedCanvas.toDataURL('image/png');
          setCroppedImages(prev => ({ ...prev, [index]: croppedImageDataUrl }));
        };
        
        setTimeout(()=>{
            setLoading(false)
        },100)
        
        image.onerror = function (err) {
          console.error('Failed to load the image', err);
        };
    };

    const downloadMethod = () => {
        if(tab==userFolders || faceSearchOn || pastFaceSearchesOn){
            getSelectionData(download)
            tab!==userFolders && faceFilterPhoto()
        }else{
            setDownloadPopup(true)
        }
    }


    const fetchImages = async () => {
        var galleryImagesArr;
        if (faceSearchOn) {
            const galleryAll = faceSearchData?.photo_data?.flatMap((imageObj) => 
                imageObj?.data?.map((image) => ({
                  src: hdUrl ? image.download_url : image.view_url,
                  alt: image.identifier,
                  photo_id: image.photo_id,
                  download_url: image.download_url,
                  image_name: image.image_name
            })))
            const galleryPrivate = Object.values(faceHide).flatMap((imageObj) =>
                imageObj.map((image) => ({
                  src: hdUrl ? image.download_url : image.view_url,
                  alt: image.identifier,
                  photo_id: image.photo_id,
                  download_url: image.download_url,
                  image_name: image.image_name
                }))
              )
            if(selectedOption==privatePhotos){
                galleryImagesArr = galleryPrivate
            }else if(selectedOption==publicPhotos){
                galleryImagesArr = galleryAll?.filter(
                    image => !galleryPrivate.some(hiddenImage => hiddenImage.photo_id === image.photo_id)
                );
            }else{
                galleryImagesArr = galleryAll
            }
            
        }else{
            const galleryAll = (tab==userFolders ? userFolderData : collection?.photo_data)?.flatMap((imageObj) => 
                imageObj[allGuestPhotos ? "data" : "my_uploads"].map((image) => ({
                  src: hdUrl ? image.download_url : image.view_url,
                  alt: (tab==guestUpload || tab==blacklistReview) ? image.user_full_name : image.identifier,
                  photo_id: image.photo_id,
                  epoch_time: image?.epoch_time || null,
                  download_url: image.download_url,
                  image_name: image.image_name
            })))
            const refrenceObj = new Set(yourUploads?.map(item => item?.photo_id));
            const validWorkIds = new Set(collection?.photo_data?.map(item => item?.work_id));
            const filteredObject = Object.keys(hideSelectedObj)
                .map(Number)
                .filter(work_id => validWorkIds.has(work_id))
                .reduce((acc, work_id) => {
                    acc[work_id] = hideSelectedObj[work_id];
                    return acc;
                }, {});
            const filteredArray = hideSelectedObj[collection_id]?.filter(item => refrenceObj.has(item.photo_id));
            const galleryPrivate = Object.values(filteredObject).flatMap((imageObj) =>
                (allGuestPhotos ? imageObj : filteredArray)?.map((image) => ({
                  src: hdUrl ? image.download_url : image.view_url,
                  alt: image.identifier,
                  photo_id: image.photo_id,
                  epoch_time: image?.epoch_time || null,
                  download_url: image.download_url,
                  image_name: image.image_name
                }))
            )
            if(selectedOption===privatePhotos){
                const sortedPrivateGallery = galleryPrivate?.sort((a, b) => b?.epoch_time - a?.epoch_time)
                galleryImagesArr = tab==userFolders ? sortedPrivateGallery : galleryPrivate
            }else if(selectedOption == publicPhotos){
                const galleryPublic = galleryAll?.filter(
                    image => !galleryPrivate.some(hiddenImage => hiddenImage.photo_id === image.photo_id)
                );
                const sortedPrivateGallery = galleryPublic?.sort((a, b) => b?.epoch_time - a?.epoch_time)
                galleryImagesArr = tab==userFolders ? sortedPrivateGallery : galleryPublic
            }
            else{
                galleryImagesArr = galleryAll
            }
        }
        const selectedFormattedData = faceSearchOn? faceFormattedData : collectionFormattedData
        if(filterWorkId?.length > 0){
            galleryImagesArr = galleryImagesArr.filter((e)=>filterWorkId.includes(String(get_selected_workId(selectedFormattedData, e.photo_id))))
        }
        setGalleryImages(galleryImagesArr);
        if(photoIndex && showGallery){
            const img = new Image();
            img.src = galleryImagesArr?.[Number(photoIndex-1)]?.src
            img.onload = function() {
                setLoadingHD(false);
            };
        }
    };

    const getBookingData = (flag=true) => {
        if(tab==past_face_searches){
            faceFilterPhoto()
            return;
        }
        if((tab==guestUpload || tab==blacklistReview) && !shared_key){
            setLoading(true)
            const authToken = getAuthToken();
            const headers = {
            Authorization: authToken,
            };
            params={}
            if(for_passkey) {
                params['passcode'] = for_passkey
            }
            axios
            .get(`${process.env.REACT_APP_STAG_URL}/api/work/guest-gallery/booking/${id}/`, {
                headers,
                params
            })
            .then((response) => {
                if (response?.data?.success == false) {
                    setWorkIdError(true);
                    setWorkIdErrorMessage(response?.data?.message);
                    return;
                }

                setData(response.data);
                setLoading(false);
                setCollectionData();
                setCollection();

                // No else: writing back this closure's allGuestPhotos undoes handleTabClick()'s reset.
                if (!flag) {
                    setAllGuestPhotos(flag);
                }

                if (response?.data?.bottom_float_bar) {
                    setFloatingBars(prev =>
                        mergeUniqueFloatingBars(response.data.bottom_float_bar, prev)
                    );
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error(error);
            });
        }else{
            var api_url
            var params = {}
            // only this branch raises the overlay, so only this branch may lower it
            var isLibraryFetch = false
            if(shared_key){
                if(faceSearchOnly){
                    return;
                }
                api_url = `${process.env.REACT_APP_STAG_URL}/api/share/${shared_key}/`
            }else if(tab==albumSelection){
                api_url = `${process.env.REACT_APP_STAG_URL}/api/work/draft-album/booking/${id}/`
            }else if(tab==userFolders){
                api_url = `${process.env.REACT_APP_STAG_URL}/api/work/folder/user/`
                if(for_passkey) {
                    params['passcode'] = for_passkey
                }
                // This path skips getLibraryData(), which normally raises the overlay.
                isLibraryFetch = true
                setUpdateLoader(true)
            }else{
                api_url = `${process.env.REACT_APP_STAG_URL}/api/work/booking/${id}/`
                if(for_passkey) {
                    params['passcode'] = for_passkey
                }
            }
            if((id || shared_key || tab==userFolders) && id!=='null'){
                axios({
                    url: api_url,
                    method: "get",
                    params,
                    headers: {
                        Authorization: getAuthToken(),
                    },
                    })
                    .then((response) => {
                        if(isLibraryFetch) setUpdateLoader(false)
                        if(!response?.data?.success){
                            setWorkIdError(true);
                            setWorkIdErrorMessage(response?.data?.message);
                            return
                        }

                        if(Object.keys(response?.data?.data).length == 0){
                            setWorkIdError(true);
                            setWorkIdErrorMessage(response?.data?.message);
                            return
                        }
                        
                        if((queryParams.get('tab') == photos && !response?.data?.data?.['photo-collection']) || (queryParams.get('tab') == videos && !response?.data?.data?.['video']) || (queryParams.get('tab') == albums && !response?.data?.data?.['album'])){
                            queryParams.delete('tab')
                            queryParams.delete('work_id')
                            navigate({ search: queryParams.toString()}, { replace: true });
                            window.location.reload();
                        }

                        setData(response?.data);

                        if(response?.data?.bottom_float_bar){
                            setFloatingBars(prev => {
                                const combinedBars = [...prev, ...response.data.bottom_float_bar];
                            
                                const uniqueBarsMap = new Map();
                            
                                combinedBars.forEach(bar => {
                                  const key = `${bar.title}-${bar.btn?.text}-${bar.btn?.url}`;
                                  if (!uniqueBarsMap.has(key)) {
                                    uniqueBarsMap.set(key, bar);
                                  }
                                });
                            
                                return Array.from(uniqueBarsMap.values());
                              });
                        }

                        setCollectionData()
                        setCollection()
                        // no else: see note above
                        if(!flag){
                            setAllGuestPhotos(flag)
                        }
                    })
                    .catch((error) => {
                        if(isLibraryFetch) setUpdateLoader(false)
                        catchError(error)
                    });
            }
        }
    }
        
    const addNickname = async (nicknameValue) => {
        try {
            const trimmedValue = (nicknameValue || "").trim();

            if(trimmedValue === ""){
                setShowToast(true)
                setToastMessage({'title': "need to enter some text for the title"})
                return;
            }
    
            const response = await fetch(getAPIUrl(`/api/share/url/nickname/${shareLinkData?.share_passcode}/`), {
                method: 'PUT',
                headers: {
                    Authorization: getAuthToken(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ nickname: trimmedValue, booking_pk: bookingPK }),
            });
    
            const res = await response.json();
    
            if (res.success) {
                setLoading(false);
                setNickname(trimmedValue)
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error('error while adding nickname:', error);
            setNickname("");
        }
    }

    const createNewFolder = async () => {
        if(isAdmin()){
            return;
        }
        setNewFolderPopup(false); 
        if(folderName){
            const form = new FormData();
            form.append("folder_name", folderName);
            const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/folder/create/user/`;
            try{
                const response = await axios.post(apiUrl, form, {
                    headers: {
                        Authorization: getAuthToken(),
                    },
                });
                if(response?.data?.toast_data){
                    setShowToast(true)
                    setToastMessage(response?.data?.toast_data)
                }
                if(isAddToOpen || isSingleAddToOpen){
                    if(tab==userFolders){
                        newCreatedFolder.current = true;
                    }
                    getLibraryData(false)
                }else{
                    newCreatedFolder.current = true;
                    getLibraryData(true)
                }
            }catch(error){
                catchError(error)
            }
        }
    }

    const trashFolder = async () => {
        if(isAdmin()){
            return;
        }
        setFolderDeletePopup(false)        
        const data = { folder_ids: [parseInt(collection_id)] };
        const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/folder/trash/`;
        try{
            const response = await axios.put(apiUrl, data, {
                headers: {
                    Authorization: getAuthToken(),
                },
            });
            if(response?.data?.toast_data){
                setShowToast(true)
                setToastMessage(response?.data?.toast_data)
            }
            if(nextCollectionName){
                handleNextCollection(true)
            }
            setCollectionData()
            setCollection()
            getBookingData()
            setYourUploads()
            getLibraryData(false)
        }catch(error){
            catchError(error)
        }    
    }

    const disableDownload = () => {
        setToastMessage({'title': "Download is disabled!"});
        setShowToast(true);
    }

    const getTrashFolders = async () => {

        const apiUrl = `${process.env.REACT_APP_STAG_URL}/api/work/folder/trash/user/`;
        setTrashLoading(true);
        try{
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: getAuthToken(),
                },
            });
            
            if(response?.data?.success && response?.data?.data?.folders){
                setTrashFoldersInfo(response?.data);
            }
            
        }catch(error){
            catchError(error)
        } finally {
            setTrashLoading(false);
        }    
    }

    useEffect(() => {
        setexpiryDate(collection?.alert_message);
      }, [collection]);

    useEffect(()=>{
        updateSinglePhoto && updateSelectedPhotos()
    },[updateSinglePhoto])

    useEffect(()=>{
        if(printSelection){
            getSelectionSortedData(collection)
        }else{
            tab==userFolders && getTimeSortedData(collection)
        }
        if(selectImages || selectedImages){
            if(hideSelection){
                const compareSelectAllData = (selectedImages[collection_id] && selectedOption==publicPhotos) ? selectedImages[collection_id].filter(item =>!hideSelectedObj[collection_id].some(h => h.photo_id === item.photo_id)): selectedImages[collection_id];
                setSelectionAll((prev)=>({
                    ...prev,
                    [collection_id]: compareSelectAllData?.length == tileCountsRef.current.total
                }))
            }else{
                setSelectionAll((prev)=>({
                    ...prev,
                    [collection_id]: selectImages && tileCountsRef.current.checked == tileCountsRef.current.total - tileCountsRef.current.blocked
                }))
            }
        }
    },[printSelection, collection, selectedImages, selectImages, photoPagesVersion])
    
    useEffect(() => {
        (tab==photos || faceSearchOnly || tab==guestUpload || tab==albumSelection || tab==userFolders || tab==blacklistReview || tab==past_face_searches) && fetchImages(); 
    // userFolderData: the Library grid renders it, but an effect above writes it - without it here
    // galleryImages lags a list behind, so a high index fell outside the carousel.
    }, [hdUrl, collection, selectedOption, faceSearchOn, faceSearchData, yourUploads, filterWorkId, allGuestPhotos, userFolderData, photoPagesVersion]);
   
    useEffect(() => {
        getBookingData()
    }, [id, shared_key]);

    // getBookingData() no-ops on the past-face tab and the effect above never re-runs, so data stays unset.
    const loadedWorkIdRef = useRef(null);
    // The face-search id currently on screen, so back/forward can tell if it still matches the URL.
    const loadedFaceIdRef = useRef(null);
    const galleryWorkIdRef = useRef(null);
    const prevTabRef = useRef(tab);
    useEffect(() => {
        const prevTab = prevTabRef.current;
        prevTabRef.current = tab;
        if (prevTab === tab) return;

        // No work_id means the new tab is still loading; with one, handleCollections() owns it.
        if (!isValidId(queryParams.get('work_id'))) {
            setCollection(null)
            // fetchImages() re-runs now, before handleTabClick() gets to reset this.
            tab !== guestUpload && setAllGuestPhotos(true)
        }

        // The Library tab overwrites `data` with the folder list, so any tab we go back to would
        // read a payload that has none of its keys. past-face never loads `data` at all.
        if (tab && (prevTab === userFolders || (!data && prevTab === past_face_searches))) {
            getBookingData()
        }
    }, [tab, data]);

    // A new grid starts with one window of tiles again.
    useEffect(() => {
        setTileLimit(CONST.GRID_RENDER_WINDOW)
    }, [collection_id, tab, selectedOption, faceSearchOn])

    // Grow the grid by a window as the user nears its end, before they reach the last tile.
    useEffect(() => {
        const handleScroll = () => {
            const nearEnd = window.innerHeight + document.documentElement.scrollTop + 1500 > document.documentElement.offsetHeight
            if (nearEnd && tileCountsRef.current.drawn >= tileLimit) {
                setTileLimit((prev) => prev + CONST.GRID_RENDER_WINDOW)
            }
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [tileLimit])

    // The viewer scrolls the grid to its photo, so that tile has to be drawn.
    const showTilesUpTo = (index) => {
        setTileLimit((prev) => (index > prev ? Math.ceil(index / CONST.GRID_RENDER_WINDOW) * CONST.GRID_RENDER_WINDOW : prev))
    }

    // Leaving WorkDetail altogether (dashboard, account, a share link) must stop the drain too.
    // Refs only, not the cancel helpers: this runs on unmount, where setState would be pointless.
    useEffect(() => () => {
        photoPaginationRequestIdRef.current += 1
        pastFacePaginationRequestIdRef.current += 1
        isFetchingPhotoPageRef.current = false
        isFetchingPastFacePageRef.current = false
    }, []);

    // bfcache restores without remounting, so undo what handleGuestUplaods left behind.
    useEffect(() => {
        const handlePageShow = (e) => {
            if (!e.persisted) return;
            setUpdateLoader(false)
            setRecallCollection(true)
        };
        window.addEventListener('pageshow', handlePageShow);
        return () => window.removeEventListener('pageshow', handlePageShow);
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            const params = new URLSearchParams(window.location.search);
            const urlWorkId = params.get('work_id');
            const inGallery = window.location.hash.includes('#gallery');
            // next/prev-collection changes work_id while the gallery stays open, so compare against
            // what handleCollections last loaded - the closure's `collection` here is stale.
            // Not on the face tab: work_id is a face-search id there, so it never matches and every
            // photo opened would recall and close the gallery again.
            const collectionChanged = !isFaceSearchUrl() && isValidId(urlWorkId) && String(loadedWorkIdRef.current) !== String(urlWorkId);

            if (inGallery) {
                const idx = parseInt(window.location.hash.split('=')[1], 10);
                if (!isNaN(idx)) { setPhotoIndex(idx); setIndexDisplay(String(idx)); }
            }

            if (showGallery && !inGallery) {
                if (collectionChanged) setRecallCollection(true)
                closeGalleryHandler();
                return;
            }

            // Back/forward can land on a face URL whose results differ from what is rendered; reload them.
            if (isFaceSearchUrl() && !inGallery && isValidId(urlWorkId)
                && String(loadedFaceIdRef.current) !== String(urlWorkId)) {
                indiFaceData(urlWorkId);
                return;
            }

            if (faceSearchOn && !faceSearchOnly) {
                // `showGallery` is stale here and back may already have left, so trust the live URL.
                if (!showGallery && !inGallery && isFaceSearchUrl()) {
                    exitFaceSearch();
                    return;
                }
            }
            
            // On the face tab `work_id` is a face id, so recalling would strip it and empty the grid.
            if(urlWorkId && params.get('face_only') !== 'true' && !isFaceSearchUrl() && (!inGallery || collectionChanged)){
                setRecallCollection(true)
            }
            if(queryParams.get('face_only') == 'true' && !window.location.hash.includes('#gallery')){
                queryParams.delete('tab')
                queryParams.delete('work_id')
                setFaceOnly(true)
                navigate({ search: queryParams.toString() })
            }

            if (videoView || albumView) {
                setVideoView(false);
                setAlbumView(false);
                document.getElementsByTagName('body')[0].style.overflow = 'auto';
            }

            
        };
        
        window.addEventListener('popstate', handlePopState);
    
        return () => {
          window.removeEventListener('popstate', handlePopState);
        };
    }, [videoView, albumView, showGallery, faceSearchState, faceSearchOn, reloadDelete, faceSearchOnly]);
    
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const currentTab = searchParams.get("tab");
        const currentWorkId = searchParams.get("work_id");
    
        if (!data) return;
    
        if (!currentTab) {
            // Replace, not push: this effect only runs when `data` loads, so Back onto a tab-less
            // entry would never pick a tab again and leave a blank page.
            const firstTab = { replaceInHistory: true };
            if (data.data?.['photo-collection']) {
                handleTabClick(photos, firstTab);
            } else if (data.data?.['video']) {
                handleTabClick(videos, firstTab);
            } else if (data.data?.['album']) {
                handleTabClick(albums, firstTab);
            } else if (data.data?.['guest-gallery']) {
                handleTabClick(guestUpload, firstTab);
            } else if (data.data?.['folders']) {
                handleTabClick(userFolders, firstTab);
            } else if (data.data?.['blacklist-review']) {
                handleTabClick(blacklistReview, firstTab);
            }
            return;
        }
    
        const needsWorkId = [photos, guestUpload, albumSelection, userFolders, blacklistReview, past_face_searches];
        if (!isValidId(currentWorkId) && needsWorkId.includes(currentTab)) {
            handleTabClick(currentTab, { replaceInHistory: true });
            return;
        }
    
        if (currentTab && isValidId(currentWorkId)) {
            if (currentTab === past_face_searches) {
                faceFilterPhoto();
            } else {
                if (collection?.work_id !== currentWorkId) {
                    handleCollections(currentWorkId); 
                }
            }
        }
    
        var processedData = {}
        if (data?.data?.video) {
            data.data.video.forEach((e) => {
                processedData[e.work_id] = e.is_hidden;
            });
        }
        if (data?.data?.album) {
            data.data.album.forEach((e) => {
                processedData[e.work_id] = e.is_hidden;
            });
        }
        setHiddenWork(processedData);
    
    }, [data]);

    useEffect(() => {
        if (pastFaceSearches && pastFaceSearches.length > 0) {
          pastFaceSearches.forEach((ele, index) => {
            cropImage(ele.img_url, ele.bounding_box, index);
          });
        }else{
            setLoading(false)
        }
    }, [pastFaceSearches]);

    useEffect(()=>{
        if(tab==guestUpload){
            getFilteredData()
        }
    },[yourUploads])

    useEffect(() => {
        setShowTooltip(true);
        const timer = setTimeout(() => {
          setShowTooltip(false);
        }, 15000);
    
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (shareDropdown || moreDropdown || likeViewPopup) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [shareDropdown, moreDropdown, likeViewPopup]);

    useEffect(()=>{
        if(data){
            const initial = true;
            getLikesData(initial);
        }
    },[data]);

    // Same as above for the face-search view, whose likes hang off faceSearchData rather than data.
    useEffect(()=>{
        if(faceSearchData?.work_id_lst?.length){
            getLikesData(true);
        }
    },[faceSearchData]);

    useEffect(() => {
        if (!data) return;
        const intervalId = setInterval(() => {
            getLikesData();
        }, 300000);

        return () => clearInterval(intervalId);
    }, [data, selectionType, tab, shared_key]);

    useEffect(() => {
        // A page merged into the collection doesn't change what's flagged.
        if (collection && collection === pageMergedCollectionRef.current) return
        if(tab==guestUpload){
            getFlaggedData()
        }
    }, [collection, data])

    useEffect(() => {
        const storedHistory = JSON.parse(localStorage.getItem('nav_history')) || [];
        (tab==userFolders || tab==blacklistReview || tab==past_face_searches) ? setRedirectUrl(storedHistory) : setNavigationHistory(location, currentPage, data)
    }, [location, data]);

    useEffect(() => {
        if (photoIndex && showGallery && galleryImages) {
            setCurrentPhotoLiked(get_user_liked_photos(likeData, galleryImages[photoIndex-1]?.photo_id));
            setCurrentPhotoFlagged(flaggedData?.[queryParams.get("work_id")]?.includes(galleryImages[photoIndex-1]?.photo_id))
        }
    }, [likeData, galleryImages, photoIndex, showGallery]);

    useEffect(() => {
        if (tab == userFolders) {
            setShareTab(userFolders)
        }
        getLibraryData(false, false)
    },[])


    return (
        <>
            {isLoggedin && (data || faceSearchData) && !faceOnly ? 
                <>
                    <Navbar location={"/workDetails"} title={``}/>
                    <WorkDetailPopup
                        lockAlbum={lockAlbum}
                        addToDone={addToDone}
                        updateAlbum={updateAlbum}
                        updateFolders={updateFolders}
                        createNewFolder={createNewFolder}
                        handleNextCollection={handleNextCollection}
                        addNickname={addNickname}
                        downloadCollection={downloadCollection}
                        downloadFaceSearch={downloadFaceSearch}
                        getSelectionDataForDownload={getSelectionData}
                        getSelectionDataForDelete={getSelectionData}
                        trashFolder={trashFolder}
                        shareSelection={shareSelection}
                        hideSelected={hideSelected}
                        handleTrashDelete={handleTrashDelete}
                    />


                    {updateLoader && <div className="overlayLoader">{globalLoader()}</div>}
                    <div style={{display: workIdError && "none"}}>
                        {scrollPosition > 500 && <div className="scrollToTop" onClick={getToTop}><FontAwesomeIcon icon={faArrowUp} size="lg" style={{color: "#ffffff",}} /></div>}
                        {/* Hide the FAB in selection mode and across the whole face-search flow: sheet, camera and results. */}
                        {(tab == guestUpload && !selection && !faceSearchOn && !faceFilter && !faceSearchState) && (
                            <div id="UploadExpiry">
                                {collection?.is_upload_allowed && !faceSearchOn ? (<div><button onClick={indirectUpload} className="uploadFloatButton" style={{backgroundColor:get_platform_action_color(), padding: !showFilters && '13px', borderRadius: !showFilters && '50%', right: currentDimensions>600 && '0.9rem'}}><img style={{width: currentDimensions<600 ? '20px' : "25px", marginRight:showFilters && "5px"}} className={"invert-image"} src={uploadIcon}/>{" "}{showFilters && 'Upload'}</button></div>
                                ) : (
                                    <div>
                                    <button className="uploadFloatButton" onClick={() => { setUploadExpiryOpen(true) }} style={{ color: 'black', backgroundColor: 'lightgrey', padding: !showFilters && '13px', borderRadius: !showFilters && '50%', right: currentDimensions>600 && '0.9rem'}}>
                                        <img style={{ width: currentDimensions<600 ? '20px' : "25px", marginRight:showFilters && "5px"}} 
                                            src={cloudCrossMark} />{" "}
                                        {showFilters && 'Upload'}
                                    </button>
                                    </div>
                                )}
                            </div>
                        )}
                        {albumStatus!=='true' && videoStatus!=='true' && <WorkDetailHeader tabClick={handleTabClick} currentPage={currentPage} guestUploadTab={guestUploadTab}/>}
                        {(!faceSearchState ? 
                        <>
                        <div className={(showFilters && !showTrash) ? "filterOptions" : "hideFilters"} style={{paddingTop: !selection ? (currentDimensions <= 1200 ? (currentDimensions <= 600 ? "65px" : "75px") : "150px") : (currentDimensions <= 600 ? '55px' : '70px'), paddingBottom:"10px", backgroundColor: currentDimensions <= 1200 && get_platform_bg_color(), color: currentDimensions < 1200 && 'white'}}>
                            <div style={{display:"flex", alignItems:"center"}}><div className={selection ? 'displayNone' : "tooltip"}>{/* The selfie path full-reloads, leaving `data` unset, so being in the view is proof enough. */}
                            {(data?.can_face_search || faceSearchOn || pastFaceSearchesOn) && (tab==photos || tab==guestUpload || tab==albumSelection || tab==past_face_searches)  && <div className="faceFilterDiv" onClick={()=>{faceSearchOn ? exitFaceSearch() : faceFilterPhoto()}} style={{border: `${shared_key ? currentDimensions <1200 && '1px solid white' : 'none'}`}}>
                                <img className={`${currentDimensions < 1200 ? "invert-image" : ""} ${(selection || faceSearchOn) && 'displayNone'}`} src={selfieIcon} style={{width: currentDimensions > 600 ? "30px" : "22px", maxHeight:"30px"}}/>
                                {<p>
                                    {faceSearchOn ? (
                                        <span><FontAwesomeIcon icon={faArrowLeft} style={{color: currentDimensions > 1200 ? "#000000" : "#ffffff",}} /> Back</span>
                                    ) : (
                                        <span>{shared_key && 'My Photos'}</span>
                                    )}
                                </p>}

                            </div>}

                            {
                                tab==userFolders && showTrash && <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', width:'100vw'}}><span style={{marginLeft:'1rem', padding: currentDimensions>600?'0.35rem':'0.25rem', border: currentDimensions > 1200 ? "1px solid black" : "1px solid white", borderRadius: '7px', display:'flex', alignItems:'center', justifyContent:'center', gap:'5px'}} onClick={() => window.location.href = '/work-details?tab=userfolders'} ><FontAwesomeIcon icon={faArrowLeft} style={{color: currentDimensions > 1200 ? "#000000" : "#ffffff", fontSize: currentDimensions>600?'0.9rem':'0.8rem'}} /> Back</span>

                                {trashFoldersInfo?.data?.folders?.length > 0 && 
                                <div style={{display:'flex', gap: '10px', marginRight: '1rem', alignItems: 'center'}}>

                                    <button
                                        onClick={() => handleTrashRestore(trashFoldersInfo?.data?.folders?.map(folder => folder.work_id))}
                                        style={{
                                            backgroundColor: 'rgba(255, 255, 255, 1)',
                                            color: get_platform_action_color(),
                                            border: `1px solid ${get_platform_action_color()}`,
                                            padding: currentDimensions > 600 ? '6px 12px':'3px 6px',
                                            borderRadius: '6px',
                                            fontSize: currentDimensions > 600 ? '0.875rem' : '0.75rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <img className="tint-teal-from-black" src={trashIcon} style={{paddingRight: "5px", width: "18px"}}/>
                                        <span style={{fontWeight: '900'}}>Restore All</span>
                                    </button>

                                    <button
                                        style={{
                                            backgroundColor: 'rgba(255, 255, 255, 1)',
                                            color: '#952d2d',
                                            border: '1px solid #952d2d',
                                            padding: currentDimensions > 600 ? '6px 12px':'3px 6px',
                                            borderRadius: '6px',
                                            fontSize: currentDimensions > 600 ? '0.875rem' : '0.75rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            justifyContent: 'center'
                                        }}
                                        onClick={() => setAllTrashDeletePopup(true)}
                                    >
                                        <img className="tint-red-from-black" src={deleteIcon} style={{paddingRight: "5px", width: "22px"}}/>
                                        <span style={{fontWeight: '900'}}>Delete All</span>
                                    </button>
                                </div>
                                }
                                </div>
                            }

                            {tab==photos && data?.can_face_search && <span className={`tooltiptext ${showTooltip ? 'show' : hide}`}>Use this to filter photos by your face</span>}</div>
                            {document.getElementsByClassName('my-masonry-grid_column').length!==0 && (tab==photos || tab==guestUpload || tab==blacklistReview || tab == past_face_searches) && get_global_can_make_private(faceSearchOn ? faceSearchData : collection) &&  <div id='hideButton' onClick={()=>getSelectionData(hide)} style={{display: selection && "none"}}>
                                <img src={currentDimensions > 1200 ? hideIcon : whiteHideIcon}/>
                            </div>}

                            <div style={{ position: 'relative' }}>
                                {!contentLoading && !selection && tab == userFolders && !showTrash && (!shared_key || (shared_key && for_passkey)) && (
                                    <div
                                    className="menuBtn"
                                    onClick={() => setShowMenuSidebar(!showMenuSidebar)}
                                    style={{
                                        display: faceSearchOn ? 'none' : 'flex',
                                        color: currentDimensions < 1200 ? 'white' : 'black',
                                        minHeight: '30px',
                                        cursor: 'pointer',
                                        alignItems: 'center',
                                        minWidth: '30px',
                                        justifyContent: 'center',
                                        marginRight: currentDimensions > 600 ? '15px' : '10px',
                                        zIndex: 105
                                    }}
                                    >
                                    <GiHamburgerMenu
                                        style={{
                                        width: currentDimensions > 600 ? '25px' : '20px',
                                        height: currentDimensions > 600 ? '25px' : '20px'
                                        }}
                                    />
                                    </div>
                                )}

                                {showMenuSidebar && !showTrash &&  (
                                <>
                                    <div
                                        onClick={() => setShowMenuSidebar(false)}
                                        style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100vw',
                                        height: '100vh',
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)', 
                                        zIndex: 999, 
                                        }}
                                    />
                                    <NavigationPanel heading={false} left={true} showMenuSidebar={showMenuSidebar} setShowMenuSidebar={setShowMenuSidebar}>
                                        {!for_passkey &&
                                        !contentLoading &&
                                        !selection &&
                                        tab === userFolders &&
                                        collection?.can_create_new_folder && (
                                            <div
                                            className="menu-dropdown-item"
                                            onClick={() => {
                                                setNewFolderPopup(true);
                                                setShowMenuSidebar(false);
                                            }}
                                            style={{
                                                display: faceSearchOn ? 'none' : 'flex',
                                                color: 'black',
                                                padding: '15px 15px 15px 20px',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
                                                borderTop: '1px solid rgba(0, 0, 0, 0.2)'
                                            }}
                                            >
                                            <FontAwesomeIcon icon={faPlus} style={{ marginRight: '10px' }} />
                                            New Folder
                                            </div>
                                        )}

                                        {(!shared_key || (shared_key && for_passkey)) && (
                                            <div
                                            className="menu-dropdown-item"
                                            onClick={() => {
                                                navigate('/work-details?tab=userfolders&trash=true');
                                                setShowMenuSidebar(false);
                                            }}
                                            style={{
                                                display: faceSearchOn ? 'none' : 'flex',
                                                color: 'black',
                                                padding: '15px 15px 15px 20px',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
                                            }}
                                            >
                                                <img  src={deleteIcon} style={{maxWidth:currentDimensions > 1200 ? "22px" : "17px", marginRight: '7px'}} />
                                            Trash
                                            </div>
                                        )}
                                    </NavigationPanel>
                                </>
                                )}
                            </div>

                            {filterDropdown  &&
                            (<><div
                                onClick={() => setFilterDropdown(false)}
                                style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100vw',
                                height: '100vh',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', 
                                zIndex: 9, 
                                }}
                            />
                            <NavigationPanel heading="Filters" left={false} showMenuSidebar={filterDropdown} setShowMenuSidebar={setFilterDropdown}>
                                <div>
                                    {<>
                                    <div style={{padding: "30px 10px 10px 10px", fontWeight: "600", fontSize: "large"}}>
                                        Visibility
                                    </div>
                                    <div
                                    style={{
                                        border: "1px solid #ccc",
                                        backgroundColor: "#fff",
                                        padding: "0 10px",
                                        fontSize: currentDimensions<600 && '15px'
                                    }}
                                >
                                    <label onClick={() => handleFilterCheckboxChange(allPhotos)} htmlFor="all" style={{ display: "flex", justifyContent: "flex-start", alignItems:"center", margin:"7px" }}>
                                    <input
                                        id="all"
                                        type="radio"
                                        checked={selectedOption == allPhotos}
                                        onChange={() => handleFilterCheckboxChange(allPhotos)}
                                        style={{ marginRight: "10px", accentColor: get_platform_bg_color(), marginTop:"0px" }}
                                    />
                                    All Photos{` (${getFilterDisplayCount(allPhotos, { ignoreWorkFilter: true })})`}
                                    </label>
                                    <hr />
                                    <label onClick={() => handleFilterCheckboxChange(privatePhotos)} htmlFor="private" style={{ display: "flex", justifyContent: "flex-start", alignItems:"center", margin:"7px" }}>
                                    <input
                                        id="private"
                                        type="radio"
                                        checked={selectedOption == privatePhotos}
                                        onChange={() => handleFilterCheckboxChange(privatePhotos)}
                                        style={{ marginRight: "10px", accentColor: get_platform_bg_color(), marginTop:"0px" }}
                                    />
                                    Hidden{` (${getFilterDisplayCount(privatePhotos, { ignoreWorkFilter: true })})`}
                                    </label>
                                    <hr />
                                    <label onClick={() => handleFilterCheckboxChange(publicPhotos)} htmlFor="public" style={{ display: "flex", justifyContent: "flex-start", alignItems:"center", margin:"7px" }}>
                                    <input
                                        id="public"
                                        type="radio"
                                        checked={selectedOption == publicPhotos}
                                        onChange={() => handleFilterCheckboxChange(publicPhotos)}
                                        style={{ marginRight: "10px", accentColor: get_platform_bg_color(), marginTop:"0px" }}
                                    />
                                    Public{` (${getFilterDisplayCount(publicPhotos, { ignoreWorkFilter: true })})`}
                                    </label>
                                    </div></>}
                                    {tab==userFolders && <>{Object.entries(collection?.bookings_name || {}).length > 0 && <div style={{padding: "40px 10px 10px 10px", fontWeight: "600", fontSize: "large"}}>
                                        Bookings
                                    </div>}
                                    {Object.entries(collection?.bookings_name || {}).length > 0 && <div 
                                    style={{
                                        border: "1px solid #ccc",
                                        backgroundColor: "#fff",
                                        padding: "0 10px",
                                        fontSize: currentDimensions<600 && '15px'
                                    }}>{Object.entries(collection?.bookings_name || {}).map(([bookingId, data]) => (
                                        <div key={bookingId}>
                                            <label htmlFor={`booking`+bookingId} style={{ display: "flex", justifyContent: "flex-start", alignItems:"center", margin:"7px" }}>
                                                <input
                                                    id={`booking`+bookingId}
                                                    type="checkbox"
                                                    checked={Object.keys(data?.collections).every(key => filterWorkId.includes(key))}
                                                    onChange={() => handleFilterCheckboxChange(selectedOption, Object.keys(data?.collections))}
                                                    style={{ marginRight: "10px", accentColor: get_platform_bg_color(), marginTop:"0px", minWidth: "8%" }}
                                                />
                                                <div style={{ margin: "7px", textAlign: 'left' }}>
                                                    {data.booking_name.length > 35
                                                    ? `${data.booking_name.slice(0, 35)}...`
                                                    : data.booking_name} ({data.booking_photo_count})
                                                </div>
                                            </label>
                                            <hr />
                                        </div>
                                    ))}</div>}</>}
                                    {(tab==albumSelection || faceSearchOn) && <>{Object.entries((faceSearchOn ? faceSearchData : collection)?.bookings_name || {}).length > 0 && <div style={{padding: "40px 10px 10px 10px", fontWeight: "600", fontSize: "large"}}>
                                        Collections
                                    </div>}
                                    
                                    {Object.entries((faceSearchOn ? faceSearchData : collection)?.bookings_name || {}).length > 0 &&<div
                                    style={{
                                        border: "1px solid #ccc",
                                        backgroundColor: "#fff",
                                        padding: "0 10px",
                                        fontSize: currentDimensions<600 && '15px'
                                    }}>{Object.entries((faceSearchOn ? faceSearchData : collection)?.bookings_name || {}).map(([bookingId, data]) => (
                                        <div key={bookingId}>
                                            {Object.entries(data?.collections || {}).map(([collectionId, collectionName]) => (
                                                <div key={collectionId}>
                                                    <label htmlFor={`collections`+collectionId} style={{ display: "flex", justifyContent: "flex-start", alignItems:"center", margin:"7px" }}>
                                                        <input
                                                            id={`collections`+collectionId}
                                                            type="checkbox"
                                                            checked={filterWorkId.includes(collectionId)}
                                                            onChange={() => handleFilterCheckboxChange(selectedOption, [collectionId])}
                                                            style={{ marginRight: "10px", accentColor: get_platform_bg_color(), marginTop:"0px", minWidth: "8%" }}
                                                        />
                                                            <div style={{ margin: "7px", textAlign: 'left' }}>
                                                                {collectionName?.title.length > 35
                                                                ? `${collectionName?.title.slice(0, 35)}...`
                                                                : collectionName?.title} ({collectionName.work_photo_count})
                                                            </div>
                                                    </label>
                                                 <hr />
                                                </div>
                                            ))}
                                        </div>
                                    ))}</div>}</>}
                                </div>
                            </NavigationPanel>
                            </>
                            )}

                            {(selectedOption!==allPhotos || filterWorkId.length>0) && filterDropdown && <div className='panelFloating'>
                                <div className='clearButton' onClick={()=>{setFilterWorkId([]);handleFilterCheckboxChange(allPhotos)}}>Clear all</div>
                                <div 
                                    className='resultsButton' 
                                    onClick={() => setFilterDropdown(false)} 
                                    style={{backgroundColor: get_platform_bg_color(), border: `1px solid ${get_platform_bg_color()}`}}>
                                        {`Show (${getFilterDisplayCount()}) results`}
                                </div>
                            </div>}
                            {(
                                document.getElementsByClassName('my-masonry-grid_column').length !== 0 &&
                                (tab === photos || tab === guestUpload || tab === blacklistReview || tab === albumSelection || faceSearchOnly || (tab === userFolders && !showTrash) || tab == past_face_searches)
                                ) ? (
                                ((!faceSearchOn
                                    ? (get_global_is_downloadable(collection) && data?.selective_download)
                                    : (get_global_is_downloadable(faceSearchData) && faceSearchData?.selective_download)
                                    ) || faceSearchOnly
                                ) ? (
                                    <div
                                        id="allDownloadButton"
                                        className={
                                        faceSearchOn
                                            ? (shared_key
                                                ? (faceSearchData?.public_photo_count > 0 ? "" : "displayNone")
                                                : (getPhotoCountFaceSearch() > 0 ? "" : "displayNone"))
                                            : (shared_key
                                                ? (tab !== guestUpload ? "displayNone" : "")
                                                : (collection?.photo_count > 0 ? "" : "displayNone"))
                                        }
                                        onClick={downloadMethod}
                                        style={{
                                        display: ((faceSearchOn && !get_global_is_downloadable(faceSearchData)) || selection) && "none"
                                        }}
                                    >
                                        <img
                                        style={{
                                            height: currentDimensions > 600 ? "25px" : "18px",
                                            width: currentDimensions > 600 ? "25px" : "18px",
                                        }}
                                        src={downloadIcon}
                                        className={currentDimensions < 1200 ? "invert-image" : ""}
                                        alt="download"
                                        />
                                    </div>
                                ) : (
                                    <div
                                        id="allDownloadButton"
                                        onClick={disableDownload}
                                        style={{
                                        // The disabled icon is desktop-only; phones just don't show it.
                                        display: (selection || isMobile()) && "none",
                                        cursor: "not-allowed"
                                        }}
                                    >
                                        <img
                                        style={{
                                            height: currentDimensions > 600 ? "25px" : "18px",
                                            width: currentDimensions > 600 ? "25px" : "18px",
                                        }}
                                        src={downloadIcon}
                                        className="disabled-image"
                                        alt="disable download"
                                        />
                                    </div>
                                )
                            ) : null}

                            {(document.getElementsByClassName('my-masonry-grid_column').length!==0 || (tab==userFolders && !showTrash)) && (tab==guestUpload || tab==albumSelection || tab==userFolders || tab==blacklistReview) && !selection && !faceSearchOn && (allGuestPhotos ? (tab!==albumSelection ? collection?.admin_delete : (collection?.album_delete && !albumLocked && canEditDraftAlbum)) : collection?.delete) &&
                                <div 
                                    className="deleteDiv" 
                                    style={{display: images?.length==0 && tab!==albumSelection && "none", cursor:"pointer", marginRight: currentDimensions > 600 ? '15px': '10px', width:"30px", display:"flex", justifyContent:"center"}} 
                                    onClick={()=>{(tab==userFolders && document.getElementsByClassName('my-masonry-grid_column').length==0) ? setFolderDeletePopup(true) : (tab==userFolders ? setDeleteType(true) : getSelectionData(deleteUploads))}}>
                                        <img src={deleteIcon} style={{width:currentDimensions < 600 ? "22px" : "28px"}} className={currentDimensions<1200 ? 'invert-image' : ""} alt='delete'/>
                                </div>}
                            </div>
                            <div className={selection ? 'displayNone' : ' '} style={{display: showTrash ? "none" : "flex", alignItems: "center"}}>
                                {document.getElementsByClassName('my-masonry-grid_column').length!==0 && data?.print_album && <div className="tooltip" style={{position:'relative'}}><div className="printDiv" onClick={()=>{!contentLoading && getPrintAlbumData()}}>
                                    <img className={currentDimensions > 1200 ? '' : "invert-image"} style={{width: currentDimensions<600 && '18px'}} src={printAlbumIcon}/>Print</div><span className={`printAlbumTipLeft ${showPrintAlbumTipLeft ? 'show' : ''}`}>Add Photos here to get them printed</span></div>}
                                {document.getElementsByClassName('my-masonry-grid_column').length!==0 && (collectionData || faceSearchData) && <div className={
                                    faceSearchOn
                                    ? ((get_global_can_add_to(faceSearchData) || get_global_is_album_required(faceSearchData)) ? '' : "displayNone")
                                    : ((get_global_can_add_to(collection) || get_global_is_album_required(collection)) ? '' : 'displayNone')
                                    } onClick={()=>getSelectionData(addTo)} style={{marginRight: currentDimensions > 600 ? "20px" : "12px", border: currentDimensions > 1200 ? "1px solid black" : "1px solid white", padding: currentDimensions>600 ? "5px" : "4px", borderRadius: "10px", cursor: "pointer", display: ((tab==albumSelection && !canEditDraftAlbum) || (tab!==photos && tab!==albumSelection && tab!==guestUpload && tab!==userFolders && tab!=past_face_searches)) && 'none' }}>
                                    <FontAwesomeIcon icon={hollowCheck} style={{color: currentDimensions > 1200 ? '#000000' : "#ffffff"}}/> Select
                                </div>}
                                {
                                tab==photos && data?.data?.more?.length>0 && data?.data?.more?.some(item => item.hasOwnProperty(CONST.ALBUM_SELECTION)) && currentDimensions > 600 && 
                                    <div className={faceSearchOn && "displayNone"} onClick={()=>handleGuestUplaods(data?.data?.more?.find(item => item.album_selection)?.album_selection)} style={{marginRight: "20px", border: currentDimensions > 1200 ? "1px solid black" : "1px solid white", padding: "5px", borderRadius: "10px", cursor: "pointer", display: "flex", alignItems:'center', gap:'5px'}}>
                                        <img style={{height:"18px"}} src={get_more_logo(CONST.ALBUM_SELECTION)} className={currentDimensions<1200 && "invert-image"}/>    
                                        Photobooks
                                    </div>
                                }
                                {document.getElementsByClassName('my-masonry-grid_column').length!==0 && (tab==blacklistReview) && !selection && !faceSearchOn && <div className="approveDiv" style={{display: images?.length==0 && tab!==albumSelection && "none", cursor:"pointer", backgroundColor:get_platform_action_color() , color:"white"}} onClick={()=>getSelectionData(approvePhoto)}><img src={"https://assets.eventgraphia.com/site_media/react/approval.png"} style={{width:currentDimensions < 600 ? "20px" : "22px"}}  alt='approve'/><span>Approve</span></div>}

                                {data?.is_shareable && tab!=blacklistReview  && <div ref={shareRef} className="shareMediaDiv" onClick={()=>!contentLoading && shareMedia()} style={{display : (faceSearchOn || (tab==userFolders && !collection?.is_shareable)) && 'none', background: currentDimensions > 1200 ? get_platform_bg_color() : 'white', color:currentDimensions > 1200 ? "white" : "black"}}>
                                    <img className={currentDimensions < 1200 ? '' : "invert-image"} style={{width: currentDimensions < 1200 && '18px', marginRight:"7px"}} src={shareIcon} /> {" "}Share<>
                                    {shareDropdown && <div className="shareDropdown">
                                        <div className="shareOption" onClick={()=>{!isAdmin() && shareDeliverable('all')}}>Share Everything</div>
                                        <div className="shareOption" onClick={()=>shareDeliverable('selective')}>Share Selectively</div>
                                        {data?.can_face_search && <div className="shareOption" onClick={()=>{!isAdmin() && shareDeliverable('face_only')}}>Face Search Only</div>}
                                </div>}</></div>}
                                {tab==albumSelection && canEditDraftAlbum && <div className="lockDiv" onClick={()=>!albumLocked && setLockPopup(true)} style={{display : faceSearchOn && 'none', background: currentDimensions > 1200 ? get_platform_bg_color() : 'white', color:currentDimensions > 1200 ? "white" : "black"}}>
                                    <img className={currentDimensions < 1200 ? '' : "invert-image"} style={{width: currentDimensions < 1200 && '18px', marginRight:"4px"}} src={lockIcon}/>{" "}{albumLocked ? 'Locked' : 'Lock'}
                                </div>}
                            </div>
                            {(selection) && <div style={{width:"inherit", display:"flex", justifyContent:"space-between"}}>
                                <div>
                                    {(downloadSelection && !get_global_is_downloadable(faceSearchOn ? faceSearchData : collection)) || (hideSelection && !get_global_can_make_private(faceSearchOn ? faceSearchData : collection)) ? <></> : (document.getElementsByClassName('my-masonry-grid_column').length!==0 && 
                                    (tileCountsRef.current.blocked!==tileCountsRef.current.total) && (
                                        <div style={{position:"relative", display:"inline-block"}}>
                                            <button
                                                style={{border: currentDimensions < 1200 ? '1px solid white' : "1px solid black", padding:"5px 12px", borderRadius:"5px", marginRight:"10px", marginTop:"10px", opacity: (isPhotoPageLoading && (hasMorePhotoPagesRef.current || hasMorePastFacePagesRef.current)) ? 0.8 : 1}}
                                                onClick={()=>toggleSelection()}
                                                disabled={isPhotoPageLoading || pageLoadFailed}
                                            >
                                                <FontAwesomeIcon icon={selectionAll[collection_id] ? faCircleCheck : hollowCheck} style={{color: currentDimensions < 1200 ? "#fff" : "#000000",}} /> Select all
                                            </button>
                                            {(isPhotoPageLoading && (hasMorePhotoPagesRef.current || hasMorePastFacePagesRef.current)) && (
                                                <div className="shimmer-overlay" />
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <div style={{display:"flex"}}>
                                    <button style={{border: currentDimensions < 1200 ? '1px solid white' : "1px solid black", padding:"5px 12px", borderRadius:"5px", marginRight:"10px", marginTop:"10px"}} onClick={()=>{!contentLoading && cancelSelection()}}>Discard</button>
                                    {selection && (hideSelection || downloadSelection || deleteSelection || approveFlagSelection) && <button id="hideDiv" style={{display: addToSelection && 'none', backgroundColor: get_platform_action_color()}} onClick={()=>{!contentLoading && updateSelectedPhotos()}}>Update</button>}
                                    {addToSelection && <button id="addToDiv" style={{backgroundColor: get_platform_action_color(), marginRight:"10px", marginTop:"10px"}} onClick={toggleAddToPopup}>Add To</button>}
                                    {selection && addToSelection && downloadSelection && <button id="downloadDiv" style={{marginRight:"10px", marginTop:"10px"}} onClick={updateSelectedPhotos}>
                                        <img style={{height: currentDimensions > 600 ? "25px" : "20px"}} src={downloadIcon} className={currentDimensions < 1200 ? "invert-image" : ""} alt="download"/>
                                    </button>}
                                </div>
                             </div>}
                        </div>
                        

                        {(tab==photos || faceSearchOnly || tab==guestUpload || tab==albumSelection || (tab==userFolders && !showTrash) || tab==blacklistReview || tab==past_face_searches) && <div style={{display: "flex", justifyContent:"center", alignItems:"center", paddingTop:currentDimensions < 1200 || selection ? "130px" : "220px"}}>
                            {!(selection && selectionType==deleteUploads) && showArrow && !showTrash && currentDimensions>1200 && data?.data && !faceSearchOn && <div id='leftArrow' style={{cursor:"pointer"}} onClick={()=>scrollStory('left')}><FontAwesomeIcon icon={faChevronLeft} size="lg" style={{color: "#000000", padding:"0 10px"}} /></div>}

                            {!(selection && selectionType==deleteUploads) &&  !showTrash &&  (
                            <div className="work-detail-stories-column">
                                {renderInstallBanner()}
                                <WorkDetailStory handleCollections={handleCollections} indiFaceData={indiFaceData} />
                            </div>
                            )}
                            {!(selection && selectionType==deleteUploads) && showArrow && !showTrash && !faceSearchOn && currentDimensions>1200 && data?.data && <div id='rightArrow' onClick={()=>scrollStory('right')} style={{cursor:"pointer"}}><FontAwesomeIcon icon={faChevronRight} size="lg" style={{color: "#000000", padding:"0 10px"}} /></div>}
                        </div>}
                        {(faceSearchOn || pastFaceSearchesOn) && <div style={{width:"100%", display:"flex", justifyContent:"left", padding:"10px 20px"}}>
                            <button className='retrySearch' style={{display: selection && 'none'}} onClick={()=>faceSearch()}>{renderRetakeSelfieThumb()} Retake</button>
                        </div>}
                        {tab==albums && (
                        <div className="work-detail-media-top">
                            {renderInstallBanner()}
                        <div style={{height: data?.data?.['album']?.length == 1 && 0.7*window.innerHeight, gridTemplateColumns: data?.data?.['album']?.length == 1 && 'repeat(1, 1fr)'}} className="albumGrid">
                            {data.data['album'] && data.data['album'].map((e, index)=>(
                                <div key={index} id={e.work_id}  className="albumStoryDiv" onClick={()=>handleAlbum(e.work_id)}>
                                    {data?.can_make_private && hiddenWork && (
                                    <div onClick={(event) => { event.stopPropagation(); hideSelected(e.work_id, hiddenWork[e.work_id]);}} style={{ position: 'absolute', top: '10px', left: '10px', width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', }}>
                                    <img style={{ width: '35px', filter: hiddenWork[e.work_id]? 'drop-shadow(0px 0px 3px red)': 'drop-shadow(0px 0px 3px white)', }} src={ hiddenWork[e.work_id]?'https://assets.graphia.in/site_media/webapp/red_eye.png':'https://assets.graphia.in/site_media/webapp/white_eye.png'} alt={hiddenWork[e.work_id] ? 'Hidden Icon' : 'Visible Icon'}/>
                                    </div>)}
                                    <img style={{objectFit: "cover", height: "75%", width:"100%", borderRadius:"2%"}} src={e.cover_image} />
                                    <span style={{fontSize:currentDimensions>600 ? "1.3rem" : "1.1rem", height:"25%", display:"flex", alignItems:"center"}}>{e.title.length>50 ? e.title.slice(0,49)+'...' : e.title} {" "} </span>
                                </div>
                            ))}
                        </div>
                        </div>
                        )}
                        {tab==videos && (
                        <div className="work-detail-media-top">
                            {renderInstallBanner()}
                        <div style={{height: data?.data?.['video']?.length == 1 && 0.7*window.innerHeight, gridTemplateColumns: data?.data?.['video']?.length == 1 && 'repeat(1, 1fr)'}} className="videoGrid">
                            {data?.data?.['video'] && data?.data?.['video']?.map((e, index)=>(
                                <div key={index} id={e.work_id} className="videoStoryDiv" onClick={()=>handleVideo(e.work_id)}>
                                    {data?.can_make_private && hiddenWork && (
                                    <div onClick={(event) => { event.stopPropagation(); hideSelected(e.work_id, hiddenWork[e.work_id]);}} style={{ position: 'absolute', top: '10px', left: '10px', width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', }}>
                                    <img style={{ width: '35px', filter: hiddenWork[e.work_id]? 'drop-shadow(0px 0px 3px red)': 'drop-shadow(0px 0px 3px white)', }} src={ hiddenWork[e.work_id]?'https://assets.graphia.in/site_media/webapp/red_eye.png':'https://assets.graphia.in/site_media/webapp/white_eye.png'} alt={hiddenWork[e.work_id] ? 'Hidden Icon' : 'Visible Icon'}/>
                                    </div>)}
                                    <div style={{position:"absolute", top:"37.5%", left:"50%", transform: 'translateY(-50%)'}}><FontAwesomeIcon icon={faPlay} style={{color: "#ffffff",}} size="xl"/></div>
                                    <img style={{objectFit: "cover", height: "75%", width:"100%", borderRadius:"2%"}} src={e.thumb_url}/>
                                    <div style={{display:"flex", alignItems:"center", justifyContent:e.is_downloadable ? "space-between" : 'center', width:"90%", height:"25%"}}><span style={{fontSize: currentDimensions>600 ? "1.2rem" : "18px", marginRight:"5px"}}>{e.title.length>50 ? e.title.slice(0,49)+'...' : e.title} {" "} </span><span>
                                        {e.is_downloadable && <div onClick={(event)=>{event.stopPropagation();qualityPopup(e.url_list)}} className="cardDownload">Download</div>}
                                    </span></div>
                                </div>
                            ))} 
                        </div>
                        </div>
                        )}
                        {(tab==photos || tab==guestUpload || tab == blacklistReview || faceSearchOnly || tab==albumSelection || tab==userFolders || tab == past_face_searches) && !showTrash && (collection || faceSearchData) && <div ref={divRef} style={{fontSize: "large", fontWeight: "600", padding: "0 2% 10px 2%", display:"flex", justifyContent:(tab !== guestUpload || (tab === guestUpload && collection?.photo_data?.[0]?.can_make_private))? "space-between":"center", alignItems:"center"}}>
                            {(tab !== guestUpload || (tab === guestUpload && collection?.photo_data?.[0]?.can_make_private))&&<div style={{width: tab == blacklistReview ? '0' : currentDimensions > 900 ? '125px' : '70px'}}></div>}

                            <div style={{maxWidth:currentDimensions < 600 && "70%", fontSize:currentDimensions < 600 && '15px', display:"flex", alignItems:"center", flexDirection:"column"}}>
                                {(tab==guestUpload || shared_key) && <div>{data?.booking_name}</div>}
                                {isEditing ? <div style={{display:"flex"}}><input
                                                type="text"
                                                value={albumTitle}
                                                onChange={handleTitleChange}
                                                style={{padding:"0 10px", width:"180px", WebkitBorderBottomLeftRadius:"10px", borderTopLeftRadius:"10px", textAlign:"center", border: `1px solid ${get_platform_action_color()}`}}
                                                autoFocus
                                                className="border-b-2 border-blue-500 outline-none"
                                            /><div onClick={changeAlbumTitle} style={{display:"flex", alignItems:"center", background: get_platform_action_color(), padding:"5px", borderTopRightRadius:"10px", borderBottomRightRadius:"10px"}}><img className="invert-image" src={checkIcon} style={{width:"18px", minWidth:"18px"}}/></div></div> : 
                                            <div style={{fontSize:tab!==albumSelection && (currentDimensions>600 ? '18px' : "15px"), fontWeight:tab==albumSelection ? '900' : "100", fontStyle:"italic", display:"flex"}}>{!faceSearchOn && (tab==albumSelection ? albumTitle : collection?.title)}{faceSearchOn && images && `${faceSearchData?.photo_count} Photos Matched`} {(tab==albumSelection || (tab==userFolders && collection?.is_title_editable)) && <p onClick={()=>setIsEditing(true)} style={{ paddingLeft:"10px", display:"flex", alignItems:"center"}}><img style={{width: "15px", cursor:"pointer"}} src={pencilIcon}/></p>}</div>}
                                            {(tab==albumSelection || tab==userFolders) && <div style={{fontSize:"small",color:"grey", fontWeight:"100", display:"flex"}}>{collection?.subtitle}</div>}
                            </div>
                            {(tab !== guestUpload || (tab === guestUpload && collection?.photo_data?.[0]?.can_make_private)) &&<div ref={dropdownRef}>
                                {tab != blacklistReview && <div 
                                className={`${contentLoading ? 'inactiveClass' : ''}`} 
                                style={{
                                    display: 'flex', 
                                    alignItems: "center", 
                                    position: "relative", 
                                    cursor: "pointer", 
                                    padding: "0 10px", 
                                    visibility: selection && 'hidden', 
                                    fontSize: currentDimensions>600 ? "18px" : '15px', 
                                    fontWeight: "normal", 
                                }} 
                                onClick={() => {
                                    setFilterDropdown((prev) => !prev);
                                }}
                                >
                                <img style={{ height: currentDimensions>600 ? "25px" : "18px" }} src={filter} alt="Filter Icon" />
                                <p style={{ display: currentDimensions < 900 && 'none', marginLeft: '5px' }}>Filter</p>
                                {`(${getFilterDisplayCount()})`}
                                {(selectedOption !== allPhotos || filterWorkId.length>0) &&
                                    <sup>
                                    <div className="dot" style={{ backgroundColor: get_platform_bg_color() }}></div>
                                    </sup>}
                                </div>
                                }

                            </div>}
                        </div>}

                        {tab == userFolders && showTrash && <div>
                            <h1 style={{marginTop: currentDimensions < 1200 && "2rem"}}>{trashFoldersInfo?.heading}</h1>
                        </div>
                        }

                        {
                            (tab==videos && videoStatus=='true') && <div>
                                <div style={{position:"fixed", top:"20px", left:"20px", color:"white", zIndex:"201"}} onClick={()=>closeVideo()}>
                                    <FontAwesomeIcon icon={faXmark} size="xl" style={{color: "#ffffff",cursor:"pointer"}}/>
                                </div>
                                {(collection && videoUrl) ?
                                <div style={{position: "fixed", width: "100%", top: "0", zIndex: "200", display: "flex", flexDirection: isMobile() ? "column" : "row"}}><VideoPlayer data={collection} bookingPK={bookingPK} id={collection_id} videoUrl={videoUrl} onNextVideo={handleNextVideo} /></div> :
                                <div className='overlayLoader' style={{background:"rgba(0,0,0,1)"}}>{globalLoader()}</div>
                            }
                            </div>
                        }
                        {tab == userFolders && showTrash && <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            {(trashLoading || !trashFoldersInfo?.data) ?
                            <div className="skeleton-grid" style={{width: currentDimensions < 600 ? '100%' : '98%', marginBottom: '10rem', marginTop: '2rem'}}>
                                {[...Array(24)].map((_, index) => (
                                    <div key={index} className="skeleton-item">
                                        <Skeleton height={currentDimensions > 1200 ? 350 : 200} />
                                    </div>
                                ))}
                            </div> :
                            trashFoldersInfo?.data?.folders?.length > 0 ? 
                            <div style={{width: currentDimensions > 900 ? '87vw' : '98vw', marginBottom: '10rem', marginTop: '2rem'}} className="trash-grid">
                                {trashFoldersInfo?.data && trashFoldersInfo?.data?.folders?.map((folder, index) => (
                                    <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', height: currentDimensions > 900 ? '350px' : '180px' }}>
                                        <div
                                            style={{
                                            backgroundImage: `url('${folder?.cover_image}')`,
                                            backgroundSize: 'cover',
                                            height: '100%',
                                            width: '100%',
                                            }}
                                        ></div>

                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            width: 'fit-content',
                                            background: 'linear-gradient(to bottom, rgba(0,0,0,0.9), rgba(0,0,0,0.3))',
                                            color: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                            padding: '4px 7px',
                                            borderRadius: '0 0 0 10px',
                                            fontSize: currentDimensions > 900 ? '1.25rem' : '1rem',
                                        }}>
                                            <FontAwesomeIcon icon={faImage} />
                                            <span>{folder?.total_count}</span>
                                        </div>
                                        <div
                                            style={{
                                            position: 'absolute',
                                            bottom: 0,
                                            width: '100%',
                                            background: 'linear-gradient(to top, rgba(0,0,0,0.9), transparent)',
                                            color: 'white',
                                            padding: '10px',
                                            }}
                                        >

                                            <h1 style={{fontSize: currentDimensions>600?"1.5rem": "1rem"}}>{folder?.title?.length > 20 ? folder.title.slice(0, 20) + '…' : folder.title}</h1>
                                            <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '10px', marginBottom: '15px', alignItems: 'center', gap: currentDimensions < 600 && '5px' }}>
                                                <button
                                                onClick={() => handleTrashRestore([folder?.work_id])}
                                                style={{
                                                    backgroundColor: 'rgba(255, 255, 255, 1)',
                                                    color: get_platform_action_color(),
                                                    border: '1px solid rgba(255, 255, 255, 0.3)',
                                                    padding: currentDimensions > 600 ? '6px 12px':'3px 6px',
                                                    borderRadius: currentDimensions > 600 ? '6px':'2px',
                                                    fontSize: currentDimensions > 600 ? '0.875rem' : '0.75rem',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    justifyContent: 'center'
                                                }}
                                                >
                                                    <img className="tint-teal-from-black" src={trashIcon} style={{paddingRight: "5px", width: "18px"}}/>
                                                    <span style={{fontWeight: '900'}}>Restore</span>
                                                </button>

                                                <button
                                                    style={{
                                                        backgroundColor: 'rgba(255, 255, 255, 1)',
                                                        color: '#952d2d',
                                                        border: '1px solid rgba(255, 255, 255, 0.3)',
                                                        padding: currentDimensions > 600 ? '6px 12px':'3px 6px',
                                                        borderRadius: currentDimensions > 600 ? '6px':'2px',
                                                        fontSize: currentDimensions > 600 ? '0.875rem' : '0.75rem',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        justifyContent: 'center'
                                                    }}
                                                    onClick={() => {setTrashDeletePopup(folder?.work_id)}}
                                                >
                                                    <img className="tint-red-from-black" src={deleteIcon} style={{paddingRight: "5px", width: "22px"}}/>
                                                    <span style={{fontWeight: '900'}}>Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>   :
                            <div style={{display:"flex", flexDirection:"column",   justifyContent:"center", alignItems:"center", height:"60vh", width:"70vw", maxWidth:"900px"}}>
                                <img className='noDataImage' src={noData} alt='no data found'/>
                                <div style={{fontSize:"larger", fontWeight:"600", color:"#656363"}}>No Folders in Trash!</div>
                            </div>
                        }

                        </div>}

                        <MasonryGrid
                            handleNextCollection={handleNextCollection}
                            galleryHandler={galleryHandler}
                            selectionTypeData={selectionTypeData}
                            returnFilteredData={returnFilteredData}
                            // Missing pages mean this isn't the end of the collection yet.
                            paginationLoading={isPhotoPageLoading || pageLoadFailed || hasMorePhotoPages}
                            tileLimit={tileLimit}
                            onTileCounts={(counts) => { tileCountsRef.current = counts }}
                        />
                        {isPhotoPageLoading &&
                            (selectedOption == allPhotos || selectedOption == privatePhotos || selectedOption == publicPhotos) &&
                            (tab == photos || tab == guestUpload || tab == albumSelection || tab == userFolders || tab == blacklistReview || tab == past_face_searches) &&
                            images?.length > 0 &&
                            (tab == past_face_searches || !faceSearchOn) && (
                                <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", gap:"8px", padding:"0", color:"#656363", fontWeight:"500"}}>
                                    {globalLoader('lg')}
                                    <span>Loading more photos</span>
                                </div>
                            )}
                        
                        {
                            (tab==albums) && albumStatus=='true' && <div>
                                <div style={{position:"fixed", top:"10px", left:"5px", color:"white", zIndex:"201"}} onClick={()=>closeAlbum()}>
                                    <FontAwesomeIcon icon={faXmark} size="xl" style={{color: "#ffffff",cursor:"pointer"}} />
                                </div>
                                {(collection?.data?.length>0) ?
                                <div style={{position: "fixed", width: "100%", top: "0", zIndex: "200"}}><AlbumView data={collection} id={collection_id}/></div> :
                                <div className='overlayLoader' style={{background: "rgba(0,0,0,1)"}}>{globalLoader()}</div>
                            }
                            </div>
                        }</> : <FaceSearch redirectToPastFace={redirectToPastFace}/>)}
                        {shareFaceFilter && shared_key && !data?.bottom_float_bar?.find(bar => !bar.btn?.redirection) && ((tab==photos && data?.data?.['photo-collection'])) && data?.can_face_search && <div className="shareFirstPage">
                                <div style={{width:"inherit", height:"inherit", backgroundColor:"#FBF7F4", paddingTop:currentDimensions > 600 ? "20vh" : "15vh"}}>
                                    <div style={{display:"flex", justifyContent:"center", flexDirection:"column", alignItems:"center"}}>
                                        <div className="shareFaceDiv">
                                            <img style={{width:"200px", paddingBottom:"30px"}} src="https://assets.graphia.in/site_media/webapp/selfie_emoji.png" alt="faceSearch"/>
                                            <div className="faceFilterDiv" style={{border:`1px solid ${get_platform_bg_color()}`, backgroundColor: get_platform_bg_color(), cursor:"pointer", marginRight: shared_key && '0px'}} onClick={()=>{faceFilterPhoto()}}>
                                                <img className="invert-image" src={selfieIcon} style={{paddingRight: "5px", width: "35px"}}/>
                                                <span style={{color:"white", fontSize:currentDimensions < 600 && "17px"}}>My Photos</span>
                                            </div>
                                            <div style={{paddingTop:"30px", fontSize: currentDimensions > 600 ? "large" : '20px', maxHeight:"80%"}}>Take a selfie to view your photos.</div>
                                        </div>
                                        <div style={{fontSize:currentDimensions > 600 ? "large" : '20px', fontWeight:"900", padding: currentDimensions > 600 ? "20px" : '10px'}}>----- OR -----</div>
                                        <div className="allPhotosShare" onClick={()=>exitFaceSearch()}>View All Photos</div>
                                    </div>
                                </div>
                            </div>}
                        
                        
                    </div>
                    <GalleryCarousel closeGalleryHandler={closeGalleryHandler} updateAlbum={updateAlbum} updateFolders={updateFolders} handleFilterCheckboxChange={handleFilterCheckboxChange} filteredPhotoCount={getFilterDisplayCount()} showTilesUpTo={showTilesUpTo}/>
                    <div id="mediaHidePopup">
                        <div id="hideMediaPopup">
                            <h1><span id="popupMediaTitle">Hide</span> this Media?</h1>
                            <h2 id="popupMediaDesc">Hidden media won't be visible to everyone(except Admin)</h2>
                            <h3>Note</h3>
                            <li>Only Admin can hide/unhide media</li>
                            <div id="hideButtonDiv">
                                <button id="hideButtonMedia" style={{backgroundColor: get_platform_bg_color()}}>Hide</button>
                                <button id="cancelHideButton" onClick={cancelMediaHide}>Cancel</button>
                            </div>
                        </div>
                    </div>
                    <div id="grideHidePopup">
                        <div id="gridHidePopup">
                            <h3>Hide Photos</h3>
                            <li>Click on <span style={{verticalAlign:"sub"}}><img style={{width:"20px", display:"inline-block", verticalAlign:"center"}} src={hideIcon}/></span> to hide/show photos</li>
                            <li>Hidden photos won't be visible to everyone(except Admin)</li>
                            <li>Only Admin can hide/unhide photos</li>
                            <div id="grideHideButtonDiv">
                                <button style={{backgroundColor: get_platform_action_color(), 
                                                color: "#ffffff", 
                                                border: `1px solid ${get_platform_action_color()}`, 
                                                padding:"5px 12px",
                                                borderRadius:"5px"}} onClick={okayHide}>Okay</button>
                            </div>
                        </div>
                    </div>
                    {showToast && <Toast message={toastMessage} duration={toastMessage?.hide_in} onClose={() => setShowToast(false)}/>}
                    {/* Stays up while pages are missing; Retry is the only way to fetch them again. */}
                    {pageLoadFailed && !isPhotoPageLoading && (
                        <Toast
                            persistent
                            message={{
                                title: pageLoadFailed === 'blocked'
                                    ? "Couldn't load all photos. They'll load again in a minute."
                                    : pageLoadFailed === 'offline'
                                        ? "You're offline. Photos will load when you're back online."
                                        : "Couldn't load all photos.",
                                // Offline and blocked resume on their own (online event / lockout end), and a
                                // tap there can't do anything, so Retry is offered only for a plain failure.
                                ...(pageLoadFailed === true && { action: { title: 'Retry', onClick: retryFailedPages, color: '#ffffff' } }),
                            }}
                        />
                    )}
                    {faceFilter && <div className="filterBackdrop">
                            <div className={currentDimensions < 600 ? "drawer open" : "facePopup"}>
                                <div>
                                    <p style={{position:"absolute", top:"10px", right:"20px", cursor:"pointer"}} onClick={closeFacePopup}><FontAwesomeIcon icon={faXmark} size="lg"/></p>
                                    <div style={{fontWeight :"900", paddingBottom:"30px"}}>Past face searches</div>
                                    <div style={{display:"flex", alignItems:"center", width:"100%", justifyContent:"space-around"}}>
                                    {isScrollable && <p onClick={scrollLeft}><FontAwesomeIcon icon={faAngleLeft} size="lg" style={{color: "#000000",}} /></p>}
                                    {!loading ? (
                                    pastFaceSearches?.length > 0 && (
                                        <div id='pastFacesDiv' style={{justifyContent: pastFaceSearches?.length==1 && 'center'}} ref={scrollContainerRef}>
                                            {pastFaceSearches.map((ele, index) => (
                                                <p key={index} style={{margin: `10px ${pastMargin}px`}} className={pastFaceSearches.length == 1 ? "singleFacesPara" : "pastFacesPara"} onClick={() => pastFaceData(ele._id)}>
                                                    <img
                                                    style={{borderRadius:"50%", height: currentDimensions <600 ? "80px" : "100px"}}
                                                    src={croppedImages[index]}
                                                    alt=""
                                                    />
                                                </p>
                                            ))}
                                        </div>
                                    )
                                    ) : (
                                    <div style={{ paddingTop: "10px" }}>{globalLoader('lg')}</div>
                                    )}
                                    {isScrollable && <p onClick={scrollRight}><FontAwesomeIcon icon={faAngleRight} size="lg" style={{color: "#000000",}} /></p>}
                                    </div>
                                    <div style={{padding:"30px 50px"}}>------or------</div>
                                    <div><button style={{background:get_platform_action_color(), color:"white", borderRadius:"5px", padding:"5px 12px"}} onClick={()=>faceSearch()}>Take a selfie</button></div>
                                </div>
                            </div>
                        </div>}
                    {tab==guestUpload && collectionData && <GuestUpload data={collectionData} bookingData={getBookingData} />}

                    {!workIdError && (collection || tab==videos) &&
                        document.getElementsByClassName('shareFirstPage').length == 0 && (
                        <>
                            {data?.bottom_float_bar?.length > 0 &&
                                data.bottom_float_bar.map((bar, index) => (
                                    <FloatingBar key={index} data={bar} index={index} />
                                ))}
                            {/* Last in the DOM: FloatingBar closes by its index into .adminSwitchOverlay. */}
                            {selection && (
                                <FloatingBar
                                    key="selection-floating-bar"
                                    index={(data?.bottom_float_bar?.length || 0)}
                                    data={{
                                        title: `${(multipleSelect || []).reduce((sum, item) => sum + (item?.select_list?.length || 0), 0)} selected`,
                                        bg_color: get_platform_bg_color(),
                                        text_color: '#ffffff',
                                        can_cancel: false,
                                    }}
                                />
                            )}
                        </>
                    )}

                    {tab==guestUpload && collection && collection?.hasOwnProperty('user_agreement') && !collection?.user_agreement && <div className="tnCOverlay">
                        <div className="tnCPopup">
                            <div className="tnCText"></div>
                            <div style={{display:"flex", alignItems:"center", justifyContent:"center", padding:"20px 10px"}}>
                                <button style={{background:get_platform_action_color(), color:"white", borderRadius:"10px", padding:"5px 8px"}} onClick={tncApproved}>I agree</button>
                            </div>
                        </div>
                    </div>}
                </>
             : <>
                {faceOnly ? <>
                    <Navbar location={"/workDetails"} title={``}/>
                    {updateLoader && <div className="overlayLoader">{globalLoader()}</div>}
                    <div>
                        <FaceSearch redirectToPastFace={redirectToPastFace}/>
                        {showToast && <Toast message={toastMessage} duration={toastMessage?.hide_in} onClose={() => setShowToast(false)}/>}
                        {pastFaceSearches?.length > 0 && <p style={{padding:currentDimensions>600 ? "15px 0" : "5px 0"}}>Past face searches!</p>}
                        <div style={{display:"flex", alignItems:"center", width:"100%", justifyContent:"center"}}>
                            <div style={{display:"flex", justifyContent:"center", width:"100%", alignItems:"center"}}>
                                {isScrollable && <p onClick={scrollLeft}><FontAwesomeIcon icon={faAngleLeft} size="lg" style={{color: "#000000",}} /></p>}
                                {Array.isArray(pastFaceSearches) ? (
                                pastFaceSearches?.length > 0 && (
                                    <div id='pastFacesDiv'  style={{maxWidth: currentDimensions > 600 ? "60%" : "90%", width:"auto", justifyContent: pastFaceSearches?.length==1 && 'center'}} ref={scrollContainerRef}>
                                    {pastFaceSearches.map((ele, index) => (
                                    <p key={index} style={{margin: `10px ${pastMargin}`}} className="pastFacesPara" onClick={() => pastFaceData(ele._id)}>
                                        <img
                                        style={{borderRadius:"50%", height: currentDimensions <600 ? "80px" : "100px"}}
                                        src={croppedImages[index]}
                                        />
                                    </p>
                                    ))}
                                    </div>
                                )
                                ) : (
                                <div style={{ paddingTop: "30px" }}>{globalLoader('lg')}</div>
                                )}
                                {isScrollable && <p onClick={scrollRight}><FontAwesomeIcon icon={faAngleRight} size="lg" style={{color: "#000000",}} /></p>}
                            </div>
                        </div>
                    </div>
                </>  : !workIdError && <SkeletonLoader />}
            </>}
            {workIdError && <CustomStatus errorMessage={workIdErrorMessage} />}
        </>
    )
}

export default WorkDetail
